//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
var ClientOptions = /** @class */ (function () {
    function ClientOptions(showLoading) {
        if (showLoading === void 0) { showLoading = true; }
        this.showLoading = showLoading;
    }
    return ClientOptions;
}());
export { ClientOptions };
var ClientBase = /** @class */ (function () {
    function ClientBase(options, baseUrl, http) {
    }
    ClientBase.prototype.transformResult = function (url, response, processor) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return (_headers[k] = v); });
        }
        if (status >= 200 && status < 300) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 =
                    _responseText === "" ? null : JSON.parse(_responseText);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then(function (_responseText) {
                return _this.throwException("Resource not found.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then(function (_responseText) {
                var result = null;
                if (_responseText) {
                    try {
                        result = JSON.parse(_responseText);
                        if (result === null || result === void 0 ? void 0 : result.ModelState) {
                            for (var error in result.ModelState) {
                                if (typeof result.ModelState[error] !== "undefined") {
                                    result.message = result.ModelState[error];
                                }
                            }
                        }
                    }
                    catch (e) {
                        // json parsing error
                    }
                }
                return _this.throwException(result
                    ? result.message || result.Message
                    : "An unexpected server error occurred when accessing " + url + " : " + _responseText, status, _responseText, _headers);
            });
        }
    };
    ClientBase.prototype.throwException = function (message, status, response, headers, result) {
        if (result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response, headers, null);
    };
    return ClientBase;
}());
export { ClientBase };
var Client = /** @class */ (function (_super) {
    __extends(Client, _super);
    function Client(configuration, baseUrl, http) {
        var _this = _super.call(this, configuration) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http ? http : window;
        _this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "https://internal-api-develop-fxh6hcd5fveuc0fp.eastus-01.azurewebsites.net";
        return _this;
    }
    /**
     * @return OK
     * @deprecated
     */
    Client.prototype.account_GetUserInfo = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Account/UserInfo";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processAccount_GetUserInfo(_response); });
        });
    };
    Client.prototype.processAccount_GetUserInfo = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.account_GetAdminUserInfo = function (userId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Account/Admin/UserInfo?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processAccount_GetAdminUserInfo(_response); });
        });
    };
    Client.prototype.processAccount_GetAdminUserInfo = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Authorizes token and returns user claims. Used by Player API.
     * @return OK
     */
    Client.prototype.account_Authorize = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Account/Authorize";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processAccount_Authorize(_response); });
        });
    };
    Client.prototype.processAccount_Authorize = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * If the user forget the password this action will send him a reset password mail
     * @param model The forgot password model
     * @return OK
     */
    Client.prototype.account_ForgotPassword = function (model) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Account/ForgotPassword";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processAccount_ForgotPassword(_response); });
        });
    };
    Client.prototype.processAccount_ForgotPassword = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.account_ForgotPasswordAdmin = function (model) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Account/ForgotPasswordAdmin";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processAccount_ForgotPasswordAdmin(_response); });
        });
    };
    Client.prototype.processAccount_ForgotPasswordAdmin = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Reset the user password
     * @param model The bidning model
     * @return OK
     */
    Client.prototype.account_ResetPassword = function (model) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Account/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processAccount_ResetPassword(_response); });
        });
    };
    Client.prototype.processAccount_ResetPassword = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.account_SendEmailConfirmation = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Account/SendEmailConfirmation";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processAccount_SendEmailConfirmation(_response); });
        });
    };
    Client.prototype.processAccount_SendEmailConfirmation = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.account_ConfirmEmail = function (model) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Account/ConfirmEmail";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processAccount_ConfirmEmail(_response); });
        });
    };
    Client.prototype.processAccount_ConfirmEmail = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.account_Logout = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Account/Logout";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processAccount_Logout(_response); });
        });
    };
    Client.prototype.processAccount_Logout = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param generateState (optional)
     * @return OK
     */
    Client.prototype.account_GetManageInfo = function (returnUrl, generateState) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Account/ManageInfo?";
        if (returnUrl === undefined || returnUrl === null)
            throw new Error("The parameter 'returnUrl' must be defined and cannot be null.");
        else
            url_ += "returnUrl=" + encodeURIComponent("" + returnUrl) + "&";
        if (generateState !== undefined && generateState !== null)
            url_ += "generateState=" + encodeURIComponent("" + generateState) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processAccount_GetManageInfo(_response); });
        });
    };
    Client.prototype.processAccount_GetManageInfo = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.account_ChangePassword = function (model) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Account/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processAccount_ChangePassword(_response); });
        });
    };
    Client.prototype.processAccount_ChangePassword = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.account_SetPassword = function (model) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Account/SetPassword";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processAccount_SetPassword(_response); });
        });
    };
    Client.prototype.processAccount_SetPassword = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.account_AddExternalLogin = function (model) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Account/AddExternalLogin";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processAccount_AddExternalLogin(_response); });
        });
    };
    Client.prototype.processAccount_AddExternalLogin = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.account_RemoveLogin = function (model) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Account/RemoveLogin";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processAccount_RemoveLogin(_response); });
        });
    };
    Client.prototype.processAccount_RemoveLogin = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param error (optional)
     * @return OK
     */
    Client.prototype.account_GetExternalLogin = function (provider, error) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Account/ExternalLogin?";
        if (provider === undefined || provider === null)
            throw new Error("The parameter 'provider' must be defined and cannot be null.");
        else
            url_ += "provider=" + encodeURIComponent("" + provider) + "&";
        if (error !== undefined && error !== null)
            url_ += "error=" + encodeURIComponent("" + error) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processAccount_GetExternalLogin(_response); });
        });
    };
    Client.prototype.processAccount_GetExternalLogin = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param generateState (optional)
     * @return OK
     */
    Client.prototype.account_GetExternalLogins = function (returnUrl, generateState) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Account/ExternalLogins?";
        if (returnUrl === undefined || returnUrl === null)
            throw new Error("The parameter 'returnUrl' must be defined and cannot be null.");
        else
            url_ += "returnUrl=" + encodeURIComponent("" + returnUrl) + "&";
        if (generateState !== undefined && generateState !== null)
            url_ += "generateState=" + encodeURIComponent("" + generateState) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processAccount_GetExternalLogins(_response); });
        });
    };
    Client.prototype.processAccount_GetExternalLogins = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.account_Register = function (model) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Account/Register";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processAccount_Register(_response); });
        });
    };
    Client.prototype.processAccount_Register = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.account_RegisterAdmin = function (model) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Account/RegisterAdmin";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processAccount_RegisterAdmin(_response); });
        });
    };
    Client.prototype.processAccount_RegisterAdmin = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.account_GetProfile = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Account/Profile";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processAccount_GetProfile(_response); });
        });
    };
    Client.prototype.processAccount_GetProfile = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.account_PutProfile = function (model) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Account/Profile";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processAccount_PutProfile(_response); });
        });
    };
    Client.prototype.processAccount_PutProfile = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.account_GetAuthorizationCode = function (clientId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Account/GetAuthorizationCode?";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined and cannot be null.");
        else
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processAccount_GetAuthorizationCode(_response); });
        });
    };
    Client.prototype.processAccount_GetAuthorizationCode = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.account_GetGatedContentAuthorizationCode = function (clientId, stripeAccountId, customerId, projectId, email) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Account/GetGatedContentAuthorizationCode?";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined and cannot be null.");
        else
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (stripeAccountId === undefined || stripeAccountId === null)
            throw new Error("The parameter 'stripeAccountId' must be defined and cannot be null.");
        else
            url_ += "stripeAccountId=" + encodeURIComponent("" + stripeAccountId) + "&";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined and cannot be null.");
        else
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined and cannot be null.");
        else
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processAccount_GetGatedContentAuthorizationCode(_response); });
        });
    };
    Client.prototype.processAccount_GetGatedContentAuthorizationCode = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.account_RegisterExternal = function (model) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Account/RegisterExternal";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processAccount_RegisterExternal(_response); });
        });
    };
    Client.prototype.processAccount_RegisterExternal = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.account_GetUserToken = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Account/UserToken";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processAccount_GetUserToken(_response); });
        });
    };
    Client.prototype.processAccount_GetUserToken = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.account_CheckUserToken = function (userId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Account/{userId}/CheckUserToken";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processAccount_CheckUserToken(_response); });
        });
    };
    Client.prototype.processAccount_CheckUserToken = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.allowedDomains_GetAllowedDomains = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/AllowedDomains";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processAllowedDomains_GetAllowedDomains(_response); });
        });
    };
    Client.prototype.processAllowedDomains_GetAllowedDomains = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.allowedDomains_PostAllowedDomain = function (allowedDomain) {
        var _this = this;
        var url_ = this.baseUrl + "/api/AllowedDomains";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(allowedDomain);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processAllowedDomains_PostAllowedDomain(_response); });
        });
    };
    Client.prototype.processAllowedDomains_PostAllowedDomain = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.allowedDomains_GetAllowedDomain = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/AllowedDomains/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processAllowedDomains_GetAllowedDomain(_response); });
        });
    };
    Client.prototype.processAllowedDomains_GetAllowedDomain = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return No Content
     */
    Client.prototype.allowedDomains_PutAllowedDomain = function (id, allowedDomain) {
        var _this = this;
        var url_ = this.baseUrl + "/api/AllowedDomains/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(allowedDomain);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processAllowedDomains_PutAllowedDomain(_response); });
        });
    };
    Client.prototype.processAllowedDomains_PutAllowedDomain = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 204) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.allowedDomains_DeleteAllowedDomain = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/AllowedDomains/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processAllowedDomains_DeleteAllowedDomain(_response); });
        });
    };
    Client.prototype.processAllowedDomains_DeleteAllowedDomain = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.apple_Put = function (request) {
        var _this = this;
        var url_ = this.baseUrl + "/Receipts";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processApple_Put(_response); });
        });
    };
    Client.prototype.processApple_Put = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.apple_Put2 = function (request, userId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{userId}/AppleReceipts";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processApple_Put2(_response); });
        });
    };
    Client.prototype.processApple_Put2 = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.apple_Post = function (payload) {
        var _this = this;
        var url_ = this.baseUrl + "/api/apple/webhook";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(payload);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processApple_Post(_response); });
        });
    };
    Client.prototype.processApple_Post = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Post rehydrate webhook.
     * @param payload The payload.
     * @return OK
     */
    Client.prototype.apple_PostRehydrateWebhook = function (payload) {
        var _this = this;
        var url_ = this.baseUrl + "/api/apple/rehydrate";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(payload);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processApple_PostRehydrateWebhook(_response); });
        });
    };
    Client.prototype.processApple_PostRehydrateWebhook = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.appReactBundles_GetReactBundles = function (appId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Apps/{appId}/ReactBundles";
        if (appId === undefined || appId === null)
            throw new Error("The parameter 'appId' must be defined.");
        url_ = url_.replace("{appId}", encodeURIComponent("" + appId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processAppReactBundles_GetReactBundles(_response); });
        });
    };
    Client.prototype.processAppReactBundles_GetReactBundles = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.appReactBundles_GetReactBundle = function (bundleId, appId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Apps/{appId}/ReactBundles/{bundleId}";
        if (bundleId === undefined || bundleId === null)
            throw new Error("The parameter 'bundleId' must be defined.");
        url_ = url_.replace("{bundleId}", encodeURIComponent("" + bundleId));
        if (appId === undefined || appId === null)
            throw new Error("The parameter 'appId' must be defined.");
        url_ = url_.replace("{appId}", encodeURIComponent("" + appId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processAppReactBundles_GetReactBundle(_response); });
        });
    };
    Client.prototype.processAppReactBundles_GetReactBundle = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.appReactBundles_GetLatestReactBundle = function (appId, apiVersion, appVersion, isTestFlight) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Apps/{appId}/ReactBundles/Latest?";
        if (appId === undefined || appId === null)
            throw new Error("The parameter 'appId' must be defined.");
        url_ = url_.replace("{appId}", encodeURIComponent("" + appId));
        if (apiVersion === undefined || apiVersion === null)
            throw new Error("The parameter 'apiVersion' must be defined and cannot be null.");
        else
            url_ += "apiVersion=" + encodeURIComponent("" + apiVersion) + "&";
        if (appVersion === undefined || appVersion === null)
            throw new Error("The parameter 'appVersion' must be defined and cannot be null.");
        else
            url_ += "appVersion=" + encodeURIComponent("" + appVersion) + "&";
        if (isTestFlight === undefined || isTestFlight === null)
            throw new Error("The parameter 'isTestFlight' must be defined and cannot be null.");
        else
            url_ += "isTestFlight=" + encodeURIComponent("" + isTestFlight) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processAppReactBundles_GetLatestReactBundle(_response); });
        });
    };
    Client.prototype.processAppReactBundles_GetLatestReactBundle = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return No Content
     */
    Client.prototype.appReviews_PutAppReviews = function (appReviews) {
        var _this = this;
        var url_ = this.baseUrl + "/api/AppReviews";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(appReviews);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processAppReviews_PutAppReviews(_response); });
        });
    };
    Client.prototype.processAppReviews_PutAppReviews = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 204) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.assets_PostWebhook = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Assets/Webhook";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processAssets_PostWebhook(_response); });
        });
    };
    Client.prototype.processAssets_PostWebhook = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.assets_GetAssets = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Assets";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processAssets_GetAssets(_response); });
        });
    };
    Client.prototype.processAssets_GetAssets = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.assets_PostAsset = function (assetPostOptions) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Assets";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(assetPostOptions);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processAssets_PostAsset(_response); });
        });
    };
    Client.prototype.processAssets_PostAsset = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.assets_GetAsset = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Assets/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processAssets_GetAsset(_response); });
        });
    };
    Client.prototype.processAssets_GetAsset = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return No Content
     */
    Client.prototype.assets_PutAsset = function (id, asset) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Assets/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(asset);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processAssets_PutAsset(_response); });
        });
    };
    Client.prototype.processAssets_PutAsset = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 204) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.assets_DeleteAsset = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Assets/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processAssets_DeleteAsset(_response); });
        });
    };
    Client.prototype.processAssets_DeleteAsset = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.blueFrameTech_GetSwitcherStudioSetting = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/BlueFrameTech/SwitcherStreamSettings";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processBlueFrameTech_GetSwitcherStudioSetting(_response); });
        });
    };
    Client.prototype.processBlueFrameTech_GetSwitcherStudioSetting = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.blueFrameTech_GetBroadcasts = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/BlueFrameTech/Broadcast";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processBlueFrameTech_GetBroadcasts(_response); });
        });
    };
    Client.prototype.processBlueFrameTech_GetBroadcasts = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.blueFrameTech_GetBroadcast = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/BlueFrameTech/Broadcast/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processBlueFrameTech_GetBroadcast(_response); });
        });
    };
    Client.prototype.processBlueFrameTech_GetBroadcast = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.blueFrameTech_PostStartBroadcast = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/BlueFrameTech/Broadcast/{Id}/Start";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processBlueFrameTech_PostStartBroadcast(_response); });
        });
    };
    Client.prototype.processBlueFrameTech_PostStartBroadcast = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.blueFrameTech_PostStopBroadcast = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/BlueFrameTech/Broadcast/{Id}/Stop";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processBlueFrameTech_PostStopBroadcast(_response); });
        });
    };
    Client.prototype.processBlueFrameTech_PostStopBroadcast = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.blueFrameTech_GetIsAccountLinked = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/BlueFrameTech/IsAccountLinked";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processBlueFrameTech_GetIsAccountLinked(_response); });
        });
    };
    Client.prototype.processBlueFrameTech_GetIsAccountLinked = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.blueFrameTech_PostUnlinkAccount = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/BlueFrameTech/UnlinkAccount";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processBlueFrameTech_PostUnlinkAccount(_response); });
        });
    };
    Client.prototype.processBlueFrameTech_PostUnlinkAccount = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.blueFrameTech_PostLinkAccount = function (basicLogin) {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/BlueFrameTech/LinkAccount";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(basicLogin);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processBlueFrameTech_PostLinkAccount(_response); });
        });
    };
    Client.prototype.processBlueFrameTech_PostLinkAccount = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.brandColors_GetBrandColorsForUser = function (userId, brandId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{userId}/Brands/{brandId}/BrandColors";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (brandId === undefined || brandId === null)
            throw new Error("The parameter 'brandId' must be defined.");
        url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processBrandColors_GetBrandColorsForUser(_response); });
        });
    };
    Client.prototype.processBrandColors_GetBrandColorsForUser = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.brandColors_PostBrandColorForUser = function (userId, brandId, brandColor) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{userId}/Brands/{brandId}/BrandColors";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (brandId === undefined || brandId === null)
            throw new Error("The parameter 'brandId' must be defined.");
        url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(brandColor);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processBrandColors_PostBrandColorForUser(_response); });
        });
    };
    Client.prototype.processBrandColors_PostBrandColorForUser = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.brandColors_GetBrandColorsForOrganization = function (organizationId, brandId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Organizations/{organizationId}/Brands/{brandId}/BrandColors";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (brandId === undefined || brandId === null)
            throw new Error("The parameter 'brandId' must be defined.");
        url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processBrandColors_GetBrandColorsForOrganization(_response); });
        });
    };
    Client.prototype.processBrandColors_GetBrandColorsForOrganization = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.brandColors_PostBrandColorForOrganization = function (organizationId, brandId, brandColor) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Organizations/{organizationId}/Brands/{brandId}/BrandColors";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (brandId === undefined || brandId === null)
            throw new Error("The parameter 'brandId' must be defined.");
        url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(brandColor);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processBrandColors_PostBrandColorForOrganization(_response); });
        });
    };
    Client.prototype.processBrandColors_PostBrandColorForOrganization = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.brandColors_GetBrandColorForUser = function (userId, brandId, colorId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{userId}/Brands/{brandId}/BrandColors/{colorId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (brandId === undefined || brandId === null)
            throw new Error("The parameter 'brandId' must be defined.");
        url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
        if (colorId === undefined || colorId === null)
            throw new Error("The parameter 'colorId' must be defined.");
        url_ = url_.replace("{colorId}", encodeURIComponent("" + colorId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processBrandColors_GetBrandColorForUser(_response); });
        });
    };
    Client.prototype.processBrandColors_GetBrandColorForUser = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.brandColors_DeleteBrandColorForUser = function (userId, brandId, colorId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{userId}/Brands/{brandId}/BrandColors/{colorId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (brandId === undefined || brandId === null)
            throw new Error("The parameter 'brandId' must be defined.");
        url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
        if (colorId === undefined || colorId === null)
            throw new Error("The parameter 'colorId' must be defined.");
        url_ = url_.replace("{colorId}", encodeURIComponent("" + colorId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processBrandColors_DeleteBrandColorForUser(_response); });
        });
    };
    Client.prototype.processBrandColors_DeleteBrandColorForUser = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.brandColors_PatchBrandColorForUser = function (userId, brandId, colorId, patch) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{userId}/Brands/{brandId}/BrandColors/{colorId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (brandId === undefined || brandId === null)
            throw new Error("The parameter 'brandId' must be defined.");
        url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
        if (colorId === undefined || colorId === null)
            throw new Error("The parameter 'colorId' must be defined.");
        url_ = url_.replace("{colorId}", encodeURIComponent("" + colorId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(patch);
        var options_ = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processBrandColors_PatchBrandColorForUser(_response); });
        });
    };
    Client.prototype.processBrandColors_PatchBrandColorForUser = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.brandColors_GetBrandColorForOrganization = function (organizationId, brandId, colorId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Organizations/{organizationId}/Brands/{brandId}/BrandColors/{colorId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (brandId === undefined || brandId === null)
            throw new Error("The parameter 'brandId' must be defined.");
        url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
        if (colorId === undefined || colorId === null)
            throw new Error("The parameter 'colorId' must be defined.");
        url_ = url_.replace("{colorId}", encodeURIComponent("" + colorId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processBrandColors_GetBrandColorForOrganization(_response); });
        });
    };
    Client.prototype.processBrandColors_GetBrandColorForOrganization = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.brandColors_DeleteBrandColorForOrganization = function (organizationId, brandId, colorId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Organizations/{organizationId}/Brands/{brandId}/BrandColors/{colorId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (brandId === undefined || brandId === null)
            throw new Error("The parameter 'brandId' must be defined.");
        url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
        if (colorId === undefined || colorId === null)
            throw new Error("The parameter 'colorId' must be defined.");
        url_ = url_.replace("{colorId}", encodeURIComponent("" + colorId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processBrandColors_DeleteBrandColorForOrganization(_response); });
        });
    };
    Client.prototype.processBrandColors_DeleteBrandColorForOrganization = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.brandColors_PatchBrandColorForOrganization = function (organizationId, brandId, colorId, patch) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Organizations/{organizationId}/Brands/{brandId}/BrandColors/{colorId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (brandId === undefined || brandId === null)
            throw new Error("The parameter 'brandId' must be defined.");
        url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
        if (colorId === undefined || colorId === null)
            throw new Error("The parameter 'colorId' must be defined.");
        url_ = url_.replace("{colorId}", encodeURIComponent("" + colorId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(patch);
        var options_ = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processBrandColors_PatchBrandColorForOrganization(_response); });
        });
    };
    Client.prototype.processBrandColors_PatchBrandColorForOrganization = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.brandLogos_GetUserBrandLogos = function (userId, brandId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{userId}/Brands/{brandId}/BrandLogos";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (brandId === undefined || brandId === null)
            throw new Error("The parameter 'brandId' must be defined.");
        url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processBrandLogos_GetUserBrandLogos(_response); });
        });
    };
    Client.prototype.processBrandLogos_GetUserBrandLogos = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.brandLogos_PutUserBrandLogos = function (userId, brandId, assetPutOptions) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{userId}/Brands/{brandId}/BrandLogos";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (brandId === undefined || brandId === null)
            throw new Error("The parameter 'brandId' must be defined.");
        url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(assetPutOptions);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processBrandLogos_PutUserBrandLogos(_response); });
        });
    };
    Client.prototype.processBrandLogos_PutUserBrandLogos = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.brandLogos_DeleteUserBrandLogos = function (userId, brandId, assets) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{userId}/Brands/{brandId}/BrandLogos";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (brandId === undefined || brandId === null)
            throw new Error("The parameter 'brandId' must be defined.");
        url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(assets);
        var options_ = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processBrandLogos_DeleteUserBrandLogos(_response); });
        });
    };
    Client.prototype.processBrandLogos_DeleteUserBrandLogos = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.brandLogos_GetUserBrandLogo = function (userId, brandId, assetId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{userId}/Brands/{brandId}/BrandLogos/{assetId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (brandId === undefined || brandId === null)
            throw new Error("The parameter 'brandId' must be defined.");
        url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
        if (assetId === undefined || assetId === null)
            throw new Error("The parameter 'assetId' must be defined.");
        url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processBrandLogos_GetUserBrandLogo(_response); });
        });
    };
    Client.prototype.processBrandLogos_GetUserBrandLogo = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.brandLogos_DeleteUserBrandLogo = function (userId, brandId, assetId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{userId}/Brands/{brandId}/BrandLogos/{assetId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (brandId === undefined || brandId === null)
            throw new Error("The parameter 'brandId' must be defined.");
        url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
        if (assetId === undefined || assetId === null)
            throw new Error("The parameter 'assetId' must be defined.");
        url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processBrandLogos_DeleteUserBrandLogo(_response); });
        });
    };
    Client.prototype.processBrandLogos_DeleteUserBrandLogo = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.brandProfileLinks_GetBrandProfileLinksForUser = function (userId, brandId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{userId}/Brands/{brandId}/BrandProfileLinks";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (brandId === undefined || brandId === null)
            throw new Error("The parameter 'brandId' must be defined.");
        url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processBrandProfileLinks_GetBrandProfileLinksForUser(_response); });
        });
    };
    Client.prototype.processBrandProfileLinks_GetBrandProfileLinksForUser = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.brandProfileLinks_PutUserBrandProfileLinks = function (userId, brandId, brandProfileLinks) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{userId}/Brands/{brandId}/BrandProfileLinks";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (brandId === undefined || brandId === null)
            throw new Error("The parameter 'brandId' must be defined.");
        url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(brandProfileLinks);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processBrandProfileLinks_PutUserBrandProfileLinks(_response); });
        });
    };
    Client.prototype.processBrandProfileLinks_PutUserBrandProfileLinks = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.brandProfileLinks_DeleteUserBrandProfileLinksByIds = function (linkIds, userId, brandId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{userId}/Brands/{brandId}/BrandProfileLinks";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (brandId === undefined || brandId === null)
            throw new Error("The parameter 'brandId' must be defined.");
        url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(linkIds);
        var options_ = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processBrandProfileLinks_DeleteUserBrandProfileLinksByIds(_response); });
        });
    };
    Client.prototype.processBrandProfileLinks_DeleteUserBrandProfileLinksByIds = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.brandProfileLinks_GetBrandProfileLinksForOrganization = function (organizationId, brandId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Organizations/{organizationId}/Brands/{brandId}/BrandProfileLinks";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (brandId === undefined || brandId === null)
            throw new Error("The parameter 'brandId' must be defined.");
        url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processBrandProfileLinks_GetBrandProfileLinksForOrganization(_response); });
        });
    };
    Client.prototype.processBrandProfileLinks_GetBrandProfileLinksForOrganization = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.brandProfileLinks_PutOrganizationBrandProfileLinks = function (organizationId, brandId, brandProfileLinks) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Organizations/{organizationId}/Brands/{brandId}/BrandProfileLinks";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (brandId === undefined || brandId === null)
            throw new Error("The parameter 'brandId' must be defined.");
        url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(brandProfileLinks);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processBrandProfileLinks_PutOrganizationBrandProfileLinks(_response); });
        });
    };
    Client.prototype.processBrandProfileLinks_PutOrganizationBrandProfileLinks = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.brandProfileLinks_DeleteOrganizationBrandProfileLinksByIds = function (linkIds, organizationId, brandId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Organizations/{organizationId}/Brands/{brandId}/BrandProfileLinks";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (brandId === undefined || brandId === null)
            throw new Error("The parameter 'brandId' must be defined.");
        url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(linkIds);
        var options_ = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processBrandProfileLinks_DeleteOrganizationBrandProfileLinksByIds(_response); });
        });
    };
    Client.prototype.processBrandProfileLinks_DeleteOrganizationBrandProfileLinksByIds = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param id The id of the broadcast.
     * @param includeThumbnailAsset (optional) If true, add the thumbnail asset to the data
     * @return OK
     * @deprecated
     */
    Client.prototype.broadcasts_GetBroadcast = function (id, includeThumbnailAsset) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Broadcasts/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (includeThumbnailAsset !== undefined && includeThumbnailAsset !== null)
            url_ += "includeThumbnailAsset=" + encodeURIComponent("" + includeThumbnailAsset) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processBroadcasts_GetBroadcast(_response); });
        });
    };
    Client.prototype.processBroadcasts_GetBroadcast = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Update the broadcast.
     * @param id The id of the broadcast.
     * @param broadcast The updated broadcast
     * @param addToDefaultPlaylist (optional) Deprecated, videos automatically add to Library Collection and any other collections should be handled through other endpoints. Should add to default playlist or not
     * @param createTwilioSyncResource (optional) Should create Twilio Sync resource or not
     * @return No Content
     */
    Client.prototype.broadcasts_PutBroadcast = function (id, broadcast, addToDefaultPlaylist, createTwilioSyncResource) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Broadcasts/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (addToDefaultPlaylist !== undefined && addToDefaultPlaylist !== null)
            url_ += "addToDefaultPlaylist=" + encodeURIComponent("" + addToDefaultPlaylist) + "&";
        if (createTwilioSyncResource !== undefined && createTwilioSyncResource !== null)
            url_ += "createTwilioSyncResource=" + encodeURIComponent("" + createTwilioSyncResource) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(broadcast);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processBroadcasts_PutBroadcast(_response); });
        });
    };
    Client.prototype.processBroadcasts_PutBroadcast = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 204) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Deletes the broadcast.
     * @param id The id.
     * @return OK
     */
    Client.prototype.broadcasts_DeleteBroadcast = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Broadcasts/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processBroadcasts_DeleteBroadcast(_response); });
        });
    };
    Client.prototype.processBroadcasts_DeleteBroadcast = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Create a new broadcast for uploaded videos.
     * @param request The broadcast create request to save.
     * @return OK
     */
    Client.prototype.broadcasts_UploadBroadcast = function (request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Broadcasts/Upload";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processBroadcasts_UploadBroadcast(_response); });
        });
    };
    Client.prototype.processBroadcasts_UploadBroadcast = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Creates the input.
     * @param id The id.
     * @return OK
     */
    Client.prototype.broadcasts_CreateInput = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Broadcasts/{id}/Input";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processBroadcasts_CreateInput(_response); });
        });
    };
    Client.prototype.processBroadcasts_CreateInput = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Create the output.
     * @param id The id.
     * @param setting The setting.
     * @return OK
     */
    Client.prototype.broadcasts_CreateOutput = function (id, setting) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Broadcasts/{id}/Outputs";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(setting);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processBroadcasts_CreateOutput(_response); });
        });
    };
    Client.prototype.processBroadcasts_CreateOutput = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Initializes the broadcast.
     * @param id The id.
     * @param body The body.
     * @return OK
     */
    Client.prototype.broadcasts_InitializeBroadcast = function (id, body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Broadcasts/{id}/Initialize";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processBroadcasts_InitializeBroadcast(_response); });
        });
    };
    Client.prototype.processBroadcasts_InitializeBroadcast = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Called by the native app to get the current status of a Multicast or
    Switcher Player broadcast. If everything connects the status to active
    and responds to app accordingly.
     * @return OK
     */
    Client.prototype.broadcasts_getBroadcastStatus = function (broadcastId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Broadcasts/{broadcastId}/Status";
        if (broadcastId === undefined || broadcastId === null)
            throw new Error("The parameter 'broadcastId' must be defined.");
        url_ = url_.replace("{broadcastId}", encodeURIComponent("" + broadcastId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processBroadcasts_getBroadcastStatus(_response); });
        });
    };
    Client.prototype.processBroadcasts_getBroadcastStatus = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Returns the list of Video Players associated with the Broadcast ID
     * @return OK
     */
    Client.prototype.broadcasts_getVideoPlayers = function (broadcastId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Broadcasts/{broadcastId}/VideoPlayers";
        if (broadcastId === undefined || broadcastId === null)
            throw new Error("The parameter 'broadcastId' must be defined.");
        url_ = url_.replace("{broadcastId}", encodeURIComponent("" + broadcastId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processBroadcasts_getVideoPlayers(_response); });
        });
    };
    Client.prototype.processBroadcasts_getVideoPlayers = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * End the broadcast.
     * @param broadcastId The broadcast id.
     * @return OK
     */
    Client.prototype.broadcasts_EndBroadcast = function (broadcastId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Broadcasts/{broadcastId}/End";
        if (broadcastId === undefined || broadcastId === null)
            throw new Error("The parameter 'broadcastId' must be defined.");
        url_ = url_.replace("{broadcastId}", encodeURIComponent("" + broadcastId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processBroadcasts_EndBroadcast(_response); });
        });
    };
    Client.prototype.processBroadcasts_EndBroadcast = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Get stream settings for the broadcast asynchronously.
     * @param broadcastId The broadcast id.
     * @return OK
     */
    Client.prototype.broadcasts_GetStreamSettings = function (broadcastId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Broadcasts/{broadcastId}/StreamSettings";
        if (broadcastId === undefined || broadcastId === null)
            throw new Error("The parameter 'broadcastId' must be defined.");
        url_ = url_.replace("{broadcastId}", encodeURIComponent("" + broadcastId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processBroadcasts_GetStreamSettings(_response); });
        });
    };
    Client.prototype.processBroadcasts_GetStreamSettings = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Deletes broadcast output.
     * @param inputId The input id.
     * @param outputId The output id.
     * @return OK
     */
    Client.prototype.broadcasts_DeleteBroadcastOutput = function (inputId, outputId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Broadcasts/Output?";
        if (inputId === undefined || inputId === null)
            throw new Error("The parameter 'inputId' must be defined and cannot be null.");
        else
            url_ += "inputId=" + encodeURIComponent("" + inputId) + "&";
        if (outputId === undefined || outputId === null)
            throw new Error("The parameter 'outputId' must be defined and cannot be null.");
        else
            url_ += "outputId=" + encodeURIComponent("" + outputId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processBroadcasts_DeleteBroadcastOutput(_response); });
        });
    };
    Client.prototype.processBroadcasts_DeleteBroadcastOutput = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Update broadcast protection.  DEPRECATED: Use the correct routing for this method.
     * @param broadcastId The broadcast id.
     * @param isProtected If true, is protected.
     * @return OK
     * @deprecated
     */
    Client.prototype.broadcasts_UpdateBroadcastProtectionDeprecated = function (broadcastId, isProtected) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Broadcasts/api/Broadcasts/{broadcastId}?";
        if (broadcastId === undefined || broadcastId === null)
            throw new Error("The parameter 'broadcastId' must be defined.");
        url_ = url_.replace("{broadcastId}", encodeURIComponent("" + broadcastId));
        if (isProtected === undefined || isProtected === null)
            throw new Error("The parameter 'isProtected' must be defined and cannot be null.");
        else
            url_ += "IsProtected=" + encodeURIComponent("" + isProtected) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processBroadcasts_UpdateBroadcastProtectionDeprecated(_response); });
        });
    };
    Client.prototype.processBroadcasts_UpdateBroadcastProtectionDeprecated = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Update broadcast protection.
     * @param broadcastId The broadcast id.
     * @param isProtected If true, is protected.
     * @return OK
     */
    Client.prototype.broadcasts_UpdateBroadcastProtection = function (broadcastId, isProtected) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Broadcasts/{broadcastId}?";
        if (broadcastId === undefined || broadcastId === null)
            throw new Error("The parameter 'broadcastId' must be defined.");
        url_ = url_.replace("{broadcastId}", encodeURIComponent("" + broadcastId));
        if (isProtected === undefined || isProtected === null)
            throw new Error("The parameter 'isProtected' must be defined and cannot be null.");
        else
            url_ += "IsProtected=" + encodeURIComponent("" + isProtected) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processBroadcasts_UpdateBroadcastProtection(_response); });
        });
    };
    Client.prototype.processBroadcasts_UpdateBroadcastProtection = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Get the entitlements.  DEPRECATED: Use the correct routing for this method.
     * @param broadcastIds The broadcast ids.
     * @return OK
     * @deprecated
     */
    Client.prototype.broadcasts_GetEntitlementsDeprecated = function (broadcastIds) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Broadcasts/api/Broadcasts/Entitlements?";
        if (broadcastIds === undefined || broadcastIds === null)
            throw new Error("The parameter 'broadcastIds' must be defined and cannot be null.");
        else
            broadcastIds && broadcastIds.forEach(function (item) { url_ += "broadcastIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processBroadcasts_GetEntitlementsDeprecated(_response); });
        });
    };
    Client.prototype.processBroadcasts_GetEntitlementsDeprecated = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Get the entitlements.
     * @param broadcastIds The broadcast ids.
     * @return OK
     */
    Client.prototype.broadcasts_GetEntitlements = function (broadcastIds) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Broadcasts/Entitlements?";
        if (broadcastIds === undefined || broadcastIds === null)
            throw new Error("The parameter 'broadcastIds' must be defined and cannot be null.");
        else
            broadcastIds && broadcastIds.forEach(function (item) { url_ += "broadcastIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processBroadcasts_GetEntitlements(_response); });
        });
    };
    Client.prototype.processBroadcasts_GetEntitlements = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Flag broadcasts for deletion.  DEPRECATED: Use the correct routing for this method.
     * @param broadcastId The broadcast id.
     * @param isSoftDelete (optional) DEPRECATED: This argument no longer changes the function of this method.
     * @return OK
     * @deprecated
     */
    Client.prototype.broadcasts_DeleteBroadcastCloudflareVideosDeprecated = function (broadcastId, isSoftDelete) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Broadcasts/api/Broadcasts/{broadcastId}/Videos?";
        if (broadcastId === undefined || broadcastId === null)
            throw new Error("The parameter 'broadcastId' must be defined.");
        url_ = url_.replace("{broadcastId}", encodeURIComponent("" + broadcastId));
        if (isSoftDelete !== undefined && isSoftDelete !== null)
            url_ += "isSoftDelete=" + encodeURIComponent("" + isSoftDelete) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processBroadcasts_DeleteBroadcastCloudflareVideosDeprecated(_response); });
        });
    };
    Client.prototype.processBroadcasts_DeleteBroadcastCloudflareVideosDeprecated = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Flag broadcasts for deletion.
     * @param broadcastId The broadcast id.
     * @param isSoftDelete (optional) DEPRECATED: This argument no longer changes the function of this method.
     * @return OK
     */
    Client.prototype.broadcasts_DeleteBroadcastCloudflareVideos = function (broadcastId, isSoftDelete) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Broadcasts/{broadcastId}/Videos?";
        if (broadcastId === undefined || broadcastId === null)
            throw new Error("The parameter 'broadcastId' must be defined.");
        url_ = url_.replace("{broadcastId}", encodeURIComponent("" + broadcastId));
        if (isSoftDelete !== undefined && isSoftDelete !== null)
            url_ += "isSoftDelete=" + encodeURIComponent("" + isSoftDelete) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processBroadcasts_DeleteBroadcastCloudflareVideos(_response); });
        });
    };
    Client.prototype.processBroadcasts_DeleteBroadcastCloudflareVideos = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Get video download status.  DEPRECATED: Use the correct routing for this method.
     * @param videoId The video id.
     * @return OK
     * @deprecated
     */
    Client.prototype.broadcasts_GetVideoDownloadStatusDeprecated = function (videoId, broadcastId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Broadcasts/api/Broadcasts/{broadcastId}/Videos/{videoId}";
        if (videoId === undefined || videoId === null)
            throw new Error("The parameter 'videoId' must be defined.");
        url_ = url_.replace("{videoId}", encodeURIComponent("" + videoId));
        if (broadcastId === undefined || broadcastId === null)
            throw new Error("The parameter 'broadcastId' must be defined.");
        url_ = url_.replace("{broadcastId}", encodeURIComponent("" + broadcastId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processBroadcasts_GetVideoDownloadStatusDeprecated(_response); });
        });
    };
    Client.prototype.processBroadcasts_GetVideoDownloadStatusDeprecated = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Start video download.  DEPRECATED: Use the correct routing for this method.
     * @param videoId The video id.
     * @return OK
     * @deprecated
     */
    Client.prototype.broadcasts_StartVideoDownloadDeprecated = function (videoId, broadcastId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Broadcasts/api/Broadcasts/{broadcastId}/Videos/{videoId}";
        if (videoId === undefined || videoId === null)
            throw new Error("The parameter 'videoId' must be defined.");
        url_ = url_.replace("{videoId}", encodeURIComponent("" + videoId));
        if (broadcastId === undefined || broadcastId === null)
            throw new Error("The parameter 'broadcastId' must be defined.");
        url_ = url_.replace("{broadcastId}", encodeURIComponent("" + broadcastId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processBroadcasts_StartVideoDownloadDeprecated(_response); });
        });
    };
    Client.prototype.processBroadcasts_StartVideoDownloadDeprecated = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Get video download status.
     * @param videoId The video id.
     * @return OK
     */
    Client.prototype.broadcasts_GetVideoDownloadStatus = function (videoId, broadcastId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Broadcasts/{broadcastId}/Videos/{videoId}";
        if (videoId === undefined || videoId === null)
            throw new Error("The parameter 'videoId' must be defined.");
        url_ = url_.replace("{videoId}", encodeURIComponent("" + videoId));
        if (broadcastId === undefined || broadcastId === null)
            throw new Error("The parameter 'broadcastId' must be defined.");
        url_ = url_.replace("{broadcastId}", encodeURIComponent("" + broadcastId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processBroadcasts_GetVideoDownloadStatus(_response); });
        });
    };
    Client.prototype.processBroadcasts_GetVideoDownloadStatus = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Start video download.
     * @param videoId The video id.
     * @return OK
     */
    Client.prototype.broadcasts_StartVideoDownload = function (videoId, broadcastId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Broadcasts/{broadcastId}/Videos/{videoId}";
        if (videoId === undefined || videoId === null)
            throw new Error("The parameter 'videoId' must be defined.");
        url_ = url_.replace("{videoId}", encodeURIComponent("" + videoId));
        if (broadcastId === undefined || broadcastId === null)
            throw new Error("The parameter 'broadcastId' must be defined.");
        url_ = url_.replace("{broadcastId}", encodeURIComponent("" + broadcastId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processBroadcasts_StartVideoDownload(_response); });
        });
    };
    Client.prototype.processBroadcasts_StartVideoDownload = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Get video download statuses. DEPRECATED: Use the correct routing for this method.
     * @param videoIds The video ids.
     * @return OK
     * @deprecated
     */
    Client.prototype.broadcasts_GetVideoDownloadStatusesDeprecated = function (videoIds) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Broadcasts/api/Broadcasts/Statuses?";
        if (videoIds === undefined || videoIds === null)
            throw new Error("The parameter 'videoIds' must be defined and cannot be null.");
        else
            videoIds && videoIds.forEach(function (item) { url_ += "videoIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processBroadcasts_GetVideoDownloadStatusesDeprecated(_response); });
        });
    };
    Client.prototype.processBroadcasts_GetVideoDownloadStatusesDeprecated = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Get video download statuses.
     * @param videoIds The video ids.
     * @return OK
     */
    Client.prototype.broadcasts_GetVideoDownloadStatuses = function (videoIds) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Broadcasts/Statuses?";
        if (videoIds === undefined || videoIds === null)
            throw new Error("The parameter 'videoIds' must be defined and cannot be null.");
        else
            videoIds && videoIds.forEach(function (item) { url_ += "videoIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processBroadcasts_GetVideoDownloadStatuses(_response); });
        });
    };
    Client.prototype.processBroadcasts_GetVideoDownloadStatuses = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Get output status.
     * @param broadcastId The broadcast id.
     * @param userRequested (optional) True to bypass sampling.
     * @return OK
     */
    Client.prototype.broadcasts_GetOutputStatus = function (broadcastId, userRequested) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Broadcasts/{broadcastId}/OutputStatus?";
        if (broadcastId === undefined || broadcastId === null)
            throw new Error("The parameter 'broadcastId' must be defined.");
        url_ = url_.replace("{broadcastId}", encodeURIComponent("" + broadcastId));
        if (userRequested !== undefined && userRequested !== null)
            url_ += "userRequested=" + encodeURIComponent("" + userRequested) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processBroadcasts_GetOutputStatus(_response); });
        });
    };
    Client.prototype.processBroadcasts_GetOutputStatus = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Gets the list of captions. Not the actual captions, just the languages and whether they are ready/AI generated
     * @param broadcastId Id for the broadcast
     * @return OK
     */
    Client.prototype.broadcasts_GetCaptionsForVideo = function (broadcastId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Broadcasts/Captions?";
        if (broadcastId === undefined || broadcastId === null)
            throw new Error("The parameter 'broadcastId' must be defined and cannot be null.");
        else
            url_ += "broadcastId=" + encodeURIComponent("" + broadcastId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processBroadcasts_GetCaptionsForVideo(_response); });
        });
    };
    Client.prototype.processBroadcasts_GetCaptionsForVideo = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Gets the captions for a specified language. Not the actual captions, just the language and whether they are ready/AI generated
     * @param broadcastId Id for the broadcast
     * @param language Language code to get captions information on. Example: "en"
     * @return OK
     */
    Client.prototype.broadcasts_GetCaptions = function (broadcastId, language) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Broadcasts/Captions/{language}?";
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined.");
        url_ = url_.replace("{language}", encodeURIComponent("" + language));
        if (broadcastId === undefined || broadcastId === null)
            throw new Error("The parameter 'broadcastId' must be defined and cannot be null.");
        else
            url_ += "broadcastId=" + encodeURIComponent("" + broadcastId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processBroadcasts_GetCaptions(_response); });
        });
    };
    Client.prototype.processBroadcasts_GetCaptions = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Upload captions
     * @param broadcastId Id for the broadcast
     * @param language Language code to get captions information on. Example: "en"
     * @return OK
     */
    Client.prototype.broadcasts_UploadCaptions = function (broadcastId, language) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Broadcasts/Captions/{language}?";
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined.");
        url_ = url_.replace("{language}", encodeURIComponent("" + language));
        if (broadcastId === undefined || broadcastId === null)
            throw new Error("The parameter 'broadcastId' must be defined and cannot be null.");
        else
            url_ += "broadcastId=" + encodeURIComponent("" + broadcastId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processBroadcasts_UploadCaptions(_response); });
        });
    };
    Client.prototype.processBroadcasts_UploadCaptions = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Delete captions for language
     * @param broadcastId Id for the broadcast
     * @param language Language code to get captions information on. Example: "en"
     * @return OK
     */
    Client.prototype.broadcasts_DeleteCaptions = function (broadcastId, language) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Broadcasts/Captions/{language}?";
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined.");
        url_ = url_.replace("{language}", encodeURIComponent("" + language));
        if (broadcastId === undefined || broadcastId === null)
            throw new Error("The parameter 'broadcastId' must be defined and cannot be null.");
        else
            url_ += "broadcastId=" + encodeURIComponent("" + broadcastId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processBroadcasts_DeleteCaptions(_response); });
        });
    };
    Client.prototype.processBroadcasts_DeleteCaptions = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Gets the captions as a string representation of the Vtt file stored on CloudFlare
     * @param broadcastId Id for the broadcast
     * @param language Language code to get captions information on. Example: "en"
     * @param type File type of the upload, only vtt for now, but in place if it changes in future. Example: "vtt"
     * @return OK
     */
    Client.prototype.broadcasts_GetCaptionsFile = function (broadcastId, language, type) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Broadcasts/Captions/{language}/File/{type}?";
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined.");
        url_ = url_.replace("{language}", encodeURIComponent("" + language));
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        if (broadcastId === undefined || broadcastId === null)
            throw new Error("The parameter 'broadcastId' must be defined and cannot be null.");
        else
            url_ += "broadcastId=" + encodeURIComponent("" + broadcastId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processBroadcasts_GetCaptionsFile(_response); });
        });
    };
    Client.prototype.processBroadcasts_GetCaptionsFile = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Generate Captions via AI
     * @param broadcastId Id for the broadcast
     * @param language Language code to generate captions. Example: "en"
     * @return OK
     */
    Client.prototype.broadcasts_GenerateCaptions = function (broadcastId, language) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Broadcasts/Captions/Generate/{language}?";
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined.");
        url_ = url_.replace("{language}", encodeURIComponent("" + language));
        if (broadcastId === undefined || broadcastId === null)
            throw new Error("The parameter 'broadcastId' must be defined and cannot be null.");
        else
            url_ += "broadcastId=" + encodeURIComponent("" + broadcastId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processBroadcasts_GenerateCaptions(_response); });
        });
    };
    Client.prototype.processBroadcasts_GenerateCaptions = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Create a new broadcast.
     * @param broadcast The broadcast to save.
     * @param addToDefaultPlaylist (optional) Deprecated, videos automatically add to Library Collection and any other collections should be handled through other endpoints. Should add to default playlist or not
     * @return OK
     */
    Client.prototype.broadcasts_PostBroadcast = function (broadcast, addToDefaultPlaylist) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Broadcasts?";
        if (addToDefaultPlaylist !== undefined && addToDefaultPlaylist !== null)
            url_ += "addToDefaultPlaylist=" + encodeURIComponent("" + addToDefaultPlaylist) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(broadcast);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processBroadcasts_PostBroadcast(_response); });
        });
    };
    Client.prototype.processBroadcasts_PostBroadcast = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Get catalog by project id asynchronously.
     * @param projectId The project id.
     * @return OK
     */
    Client.prototype.catalog_GetCatalogByProjectId = function (projectId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Catalog?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processCatalog_GetCatalogByProjectId(_response); });
        });
    };
    Client.prototype.processCatalog_GetCatalogByProjectId = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Update catalog by id asynchronously.
     * @param catalogId The catalog id.
     * @param request The request.
     * @return OK
     */
    Client.prototype.catalog_PutCatalog = function (catalogId, request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Catalog?";
        if (catalogId === undefined || catalogId === null)
            throw new Error("The parameter 'catalogId' must be defined and cannot be null.");
        else
            url_ += "catalogId=" + encodeURIComponent("" + catalogId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processCatalog_PutCatalog(_response); });
        });
    };
    Client.prototype.processCatalog_PutCatalog = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Update catalog by id asynchronously.
     * @param catalogId The catalog id.
     * @param customSlug The custom slug to apply to the catalog.
     * @return OK
     */
    Client.prototype.catalog_PutCatalogSlug = function (catalogId, customSlug) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Catalog/Slug?";
        if (catalogId === undefined || catalogId === null)
            throw new Error("The parameter 'catalogId' must be defined and cannot be null.");
        else
            url_ += "catalogId=" + encodeURIComponent("" + catalogId) + "&";
        if (customSlug === undefined || customSlug === null)
            throw new Error("The parameter 'customSlug' must be defined and cannot be null.");
        else
            url_ += "customSlug=" + encodeURIComponent("" + customSlug) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processCatalog_PutCatalogSlug(_response); });
        });
    };
    Client.prototype.processCatalog_PutCatalogSlug = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Patches featured video.
     * @param catalogId The catalog id.
     * @param request The request.
     * @return OK
     */
    Client.prototype.catalog_PatchFeaturedVideo = function (catalogId, request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Catalog/{catalogId}/FeaturedVideo";
        if (catalogId === undefined || catalogId === null)
            throw new Error("The parameter 'catalogId' must be defined.");
        url_ = url_.replace("{catalogId}", encodeURIComponent("" + catalogId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processCatalog_PatchFeaturedVideo(_response); });
        });
    };
    Client.prototype.processCatalog_PatchFeaturedVideo = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Checks string if it is valid to be a video player slug.
     * @param slug The slug to check.
     * @return OK
     */
    Client.prototype.catalog_CheckCustomSlug = function (slug) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Catalog/Slug/Check?";
        if (slug === undefined || slug === null)
            throw new Error("The parameter 'slug' must be defined and cannot be null.");
        else
            url_ += "slug=" + encodeURIComponent("" + slug) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processCatalog_CheckCustomSlug(_response); });
        });
    };
    Client.prototype.processCatalog_CheckCustomSlug = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Gets the categories.
     * @param projectId The project id.
     * @param categoryType The category type.
     * @return OK
     */
    Client.prototype.categories_GetCategories = function (projectId, categoryType) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Categories?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (categoryType === undefined || categoryType === null)
            throw new Error("The parameter 'categoryType' must be defined and cannot be null.");
        else
            url_ += "categoryType=" + encodeURIComponent("" + categoryType) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processCategories_GetCategories(_response); });
        });
    };
    Client.prototype.processCategories_GetCategories = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Updates the categories.
     * @param categoriesRequest The categories request.
     * @return OK
     */
    Client.prototype.categories_UpdateCategories = function (categoriesRequest) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Categories";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(categoriesRequest);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processCategories_UpdateCategories(_response); });
        });
    };
    Client.prototype.processCategories_UpdateCategories = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Creates the categories.
     * @param categoriesRequest The categories request.
     * @return OK
     */
    Client.prototype.categories_CreateCategories = function (categoriesRequest) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Categories";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(categoriesRequest);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processCategories_CreateCategories(_response); });
        });
    };
    Client.prototype.processCategories_CreateCategories = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Deletes the category.
     * @param categoriesRequest The categories request.
     * @return OK
     */
    Client.prototype.categories_DeleteCategory = function (categoriesRequest) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Categories";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(categoriesRequest);
        var options_ = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processCategories_DeleteCategory(_response); });
        });
    };
    Client.prototype.processCategories_DeleteCategory = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.churchStreamingTv_GetSwitcherStudioSetting = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/ChurchStreamingTv/SwitcherStreamSettings";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processChurchStreamingTv_GetSwitcherStudioSetting(_response); });
        });
    };
    Client.prototype.processChurchStreamingTv_GetSwitcherStudioSetting = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.churchStreamingTv_PostLinkAccount = function (basicLogin) {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/ChurchStreamingTv/LinkAccount";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(basicLogin);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processChurchStreamingTv_PostLinkAccount(_response); });
        });
    };
    Client.prototype.processChurchStreamingTv_PostLinkAccount = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Gets the videos for user.
     * @return OK
     * @deprecated
     */
    Client.prototype.cloudRecordings_GetVideosForUser = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/CloudRecordings";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processCloudRecordings_GetVideosForUser(_response); });
        });
    };
    Client.prototype.processCloudRecordings_GetVideosForUser = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Gets the videos for user.  Version 2.0
     * @param pageNo (optional) Optional page number if api should be paginated
     * @param pageSize (optional) Optional pageSize if api should be paginated
     * @param textQuery (optional) Optional search query
     * @param categoryIds (optional) Optional list of categories to filter
     * @param filter (optional)
     * @param sort (optional)
     * @param sortOrder (optional)
     * @param broadcastIds (optional) Optional list of broadcastId.
     * @return OK
     * @deprecated
     */
    Client.prototype.cloudRecordings_GetVideosForUserV2 = function (pageNo, pageSize, textQuery, categoryIds, filter, sort, sortOrder, broadcastIds) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v2.0/CloudRecordings?";
        if (pageNo !== undefined && pageNo !== null)
            url_ += "pageNo=" + encodeURIComponent("" + pageNo) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (textQuery !== undefined && textQuery !== null)
            url_ += "textQuery=" + encodeURIComponent("" + textQuery) + "&";
        if (categoryIds !== undefined && categoryIds !== null)
            categoryIds && categoryIds.forEach(function (item) { url_ += "categoryIds=" + encodeURIComponent("" + item) + "&"; });
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "sort=" + encodeURIComponent("" + sort) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (broadcastIds !== undefined && broadcastIds !== null)
            broadcastIds && broadcastIds.forEach(function (item) { url_ += "broadcastIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processCloudRecordings_GetVideosForUserV2(_response); });
        });
    };
    Client.prototype.processCloudRecordings_GetVideosForUserV2 = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Gets the videos for given broadcasts. Is not authorized.
     * @param broadcastIds (optional) List of broadcastId to query.
     * @return OK
     * @deprecated
     */
    Client.prototype.cloudRecordings_GetVideos = function (broadcastIds) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v2.0/CloudRecordings/Videos?";
        if (broadcastIds !== undefined && broadcastIds !== null)
            broadcastIds && broadcastIds.forEach(function (item) { url_ += "broadcastIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processCloudRecordings_GetVideos(_response); });
        });
    };
    Client.prototype.processCloudRecordings_GetVideos = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Gets latest cloudflare video(s) for the user's currently live or last recorded broadcast.
     * @return Returns the latest video(s)
     * @deprecated
     */
    Client.prototype.cloudRecordings_GetLatestVideoForUser = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/CloudRecordings/Latest";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processCloudRecordings_GetLatestVideoForUser(_response); });
        });
    };
    Client.prototype.processCloudRecordings_GetLatestVideoForUser = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                return throwException("There are no broadcasts for the user", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Gets latest cloudflare video(s) for for a given project's currently live or last recorded broadcast.
    If the user doesn't have a video player eligible plan, the demo video will be returned.
     * @return Returns the latest video(s)
     * @deprecated
     */
    Client.prototype.cloudRecordings_GetLatestVideoByFilter = function (projectId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/CloudRecordings/LatestByFilter?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processCloudRecordings_GetLatestVideoByFilter(_response); });
        });
    };
    Client.prototype.processCloudRecordings_GetLatestVideoByFilter = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                return throwException("The project dosn\'t exist or there are no broadcasts for the project", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Gets current live and upcoming cloudflare video(s) for for a given project.
    If the user doesn't have a video player eligible plan, the demo video will be returned.
     * @return Returns the latest video(s)
     * @deprecated
     */
    Client.prototype.cloudRecordings_GetNextEvents = function (projectId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/CloudRecordings/NextEvents?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processCloudRecordings_GetNextEvents(_response); });
        });
    };
    Client.prototype.processCloudRecordings_GetNextEvents = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Gets the upload url.
     * @return OK
     */
    Client.prototype.cloudRecordings_GetUploadUrl = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/CloudRecordings/GetUploadUrl";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processCloudRecordings_GetUploadUrl(_response); });
        });
    };
    Client.prototype.processCloudRecordings_GetUploadUrl = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Gets the usage count and max count for the the user's cloud recordings and optionally the number of videos for each category
     * @param includeCategoryTotals (optional) If true, returns the number of videos for each category
     * @return OK
     */
    Client.prototype.cloudRecordings_GetUsage = function (includeCategoryTotals) {
        var _this = this;
        var url_ = this.baseUrl + "/api/CloudRecordings/GetUsage?";
        if (includeCategoryTotals !== undefined && includeCategoryTotals !== null)
            url_ += "includeCategoryTotals=" + encodeURIComponent("" + includeCategoryTotals) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processCloudRecordings_GetUsage(_response); });
        });
    };
    Client.prototype.processCloudRecordings_GetUsage = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Checks if the given coupon is valid. A 404 not found is returned if no valid coupon is found.
     * @param coupon The public facing coupon string.
     * @return OK
     */
    Client.prototype.coupons_CheckCouponCode = function (coupon) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Coupons/{coupon}/Check";
        if (coupon === undefined || coupon === null)
            throw new Error("The parameter 'coupon' must be defined.");
        url_ = url_.replace("{coupon}", encodeURIComponent("" + coupon));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processCoupons_CheckCouponCode(_response); });
        });
    };
    Client.prototype.processCoupons_CheckCouponCode = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Claims a coupon code given a userId and coupon id
     * @param userId The userId claiming the coupon
     * @param coupon the coupon string
     * @return OK
     */
    Client.prototype.coupons_ClaimCouponCode = function (userId, coupon) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{userId}/Coupons/{coupon}/Claim";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (coupon === undefined || coupon === null)
            throw new Error("The parameter 'coupon' must be defined.");
        url_ = url_.replace("{coupon}", encodeURIComponent("" + coupon));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processCoupons_ClaimCouponCode(_response); });
        });
    };
    Client.prototype.processCoupons_ClaimCouponCode = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Returns a list of claimed coupon codes for the provided userId.
     * @param userId The userId for the user you wish to list claimed coupon codes for.
     * @return OK
     */
    Client.prototype.coupons_GetClaimedCouponCodesByUser = function (userId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{userId}/Coupons";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processCoupons_GetClaimedCouponCodesByUser(_response); });
        });
    };
    Client.prototype.processCoupons_GetClaimedCouponCodesByUser = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * If requested ResellerInventoryItem is a duplicate of an unlimited coupon, deletes ResellerInventoryItem, otherwise it
    clears the user that claimed a given ResellerInventoryItem, resets the status to "Availible - 0" and updates "UpdatedAt" to current UTC timestamp.
     * @param userId The userId for the user you wish to release claimed coupon code for.
     * @param resellerInventoryItemId The resellerInventoryItemId for the coupon you wish to release.
     * @return OK
     */
    Client.prototype.coupons_ReleaseCouponCode = function (userId, resellerInventoryItemId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{userId}/ResellerInventoryItems/{resellerInventoryItemId}/Release";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (resellerInventoryItemId === undefined || resellerInventoryItemId === null)
            throw new Error("The parameter 'resellerInventoryItemId' must be defined.");
        url_ = url_.replace("{resellerInventoryItemId}", encodeURIComponent("" + resellerInventoryItemId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processCoupons_ReleaseCouponCode(_response); });
        });
    };
    Client.prototype.processCoupons_ReleaseCouponCode = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Creates the stripe checkout asynchronously.
     * @param creatorCheckoutRequest The creator checkout request.
     * @return OK
     */
    Client.prototype.creatorCheckout_CreateStripeCheckout = function (creatorCheckoutRequest) {
        var _this = this;
        var url_ = this.baseUrl + "/api/CreatorCheckout/CreateStripeCheckout";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(creatorCheckoutRequest);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processCreatorCheckout_CreateStripeCheckout(_response); });
        });
    };
    Client.prototype.processCreatorCheckout_CreateStripeCheckout = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Gets the current status of a Stripe checkout session
     * @param sessionId The Stripe checkout session id
     * @param creatorStripeAccountId The Stripe account id for the Creator
     * @return OK
     */
    Client.prototype.creatorCheckout_GetStripeCheckoutStatus = function (sessionId, creatorStripeAccountId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/CreatorCheckout/StripeCheckoutStatus?";
        if (sessionId === undefined || sessionId === null)
            throw new Error("The parameter 'sessionId' must be defined and cannot be null.");
        else
            url_ += "sessionId=" + encodeURIComponent("" + sessionId) + "&";
        if (creatorStripeAccountId === undefined || creatorStripeAccountId === null)
            throw new Error("The parameter 'creatorStripeAccountId' must be defined and cannot be null.");
        else
            url_ += "creatorStripeAccountId=" + encodeURIComponent("" + creatorStripeAccountId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processCreatorCheckout_GetStripeCheckoutStatus(_response); });
        });
    };
    Client.prototype.processCreatorCheckout_GetStripeCheckoutStatus = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Checks if user with given email has purchaced videos from given project.
     * @param request the restore purchase request.
     * @return OK
     */
    Client.prototype.creatorCheckout_RestorePurchase = function (request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/CreatorCheckout/RestorePurchase";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processCreatorCheckout_RestorePurchase(_response); });
        });
    };
    Client.prototype.processCreatorCheckout_RestorePurchase = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Gets the CreatorCustomersResponse By Stripe Account asynchronously.
     * @param stripeAccountId The stripe account id.
     * @return OK
     */
    Client.prototype.creatorCustomers_GetByStripeAccount = function (stripeAccountId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/StripeAccount/{stripeAccountId}/CreatorCustomers";
        if (stripeAccountId === undefined || stripeAccountId === null)
            throw new Error("The parameter 'stripeAccountId' must be defined.");
        url_ = url_.replace("{stripeAccountId}", encodeURIComponent("" + stripeAccountId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processCreatorCustomers_GetByStripeAccount(_response); });
        });
    };
    Client.prototype.processCreatorCustomers_GetByStripeAccount = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Gets the {System.Web.Http.IHttpActionResult} asynchronously.
     * @param stripeAccountId The stripe account id.
     * @param customerRequest The customer request.
     * @return OK
     */
    Client.prototype.creatorCustomers_Update = function (stripeAccountId, customerRequest) {
        var _this = this;
        var url_ = this.baseUrl + "/api/StripeAccount/{stripeAccountId}/CreatorCustomers";
        if (stripeAccountId === undefined || stripeAccountId === null)
            throw new Error("The parameter 'stripeAccountId' must be defined.");
        url_ = url_.replace("{stripeAccountId}", encodeURIComponent("" + stripeAccountId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(customerRequest);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processCreatorCustomers_Update(_response); });
        });
    };
    Client.prototype.processCreatorCustomers_Update = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Creates the {System.Web.Http.IHttpActionResult} asynchronously.
     * @param stripeAccountId The stripe account id.
     * @param customerRequest The customer request.
     * @return OK
     */
    Client.prototype.creatorCustomers_Create = function (stripeAccountId, customerRequest) {
        var _this = this;
        var url_ = this.baseUrl + "/api/StripeAccount/{stripeAccountId}/CreatorCustomers";
        if (stripeAccountId === undefined || stripeAccountId === null)
            throw new Error("The parameter 'stripeAccountId' must be defined.");
        url_ = url_.replace("{stripeAccountId}", encodeURIComponent("" + stripeAccountId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(customerRequest);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processCreatorCustomers_Create(_response); });
        });
    };
    Client.prototype.processCreatorCustomers_Create = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Gets the {System.Web.Http.IHttpActionResult} asynchronously.
     * @param stripeAccountId The stripe account id.
     * @param creatorCustomerId The creator customer id.
     * @return OK
     */
    Client.prototype.creatorCustomers_Get = function (stripeAccountId, creatorCustomerId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/StripeAccount/{stripeAccountId}/CreatorCustomers/{creatorCustomerId}";
        if (stripeAccountId === undefined || stripeAccountId === null)
            throw new Error("The parameter 'stripeAccountId' must be defined.");
        url_ = url_.replace("{stripeAccountId}", encodeURIComponent("" + stripeAccountId));
        if (creatorCustomerId === undefined || creatorCustomerId === null)
            throw new Error("The parameter 'creatorCustomerId' must be defined.");
        url_ = url_.replace("{creatorCustomerId}", encodeURIComponent("" + creatorCustomerId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processCreatorCustomers_Get(_response); });
        });
    };
    Client.prototype.processCreatorCustomers_Get = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Gets the {System.Web.Http.IHttpActionResult} asynchronously.
     * @param stripeAccountId The stripe account id.
     * @param creatorCustomerId The creator customer id.
     * @return OK
     */
    Client.prototype.creatorCustomers_Delete = function (stripeAccountId, creatorCustomerId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/StripeAccount/{stripeAccountId}/CreatorCustomers/{creatorCustomerId}";
        if (stripeAccountId === undefined || stripeAccountId === null)
            throw new Error("The parameter 'stripeAccountId' must be defined.");
        url_ = url_.replace("{stripeAccountId}", encodeURIComponent("" + stripeAccountId));
        if (creatorCustomerId === undefined || creatorCustomerId === null)
            throw new Error("The parameter 'creatorCustomerId' must be defined.");
        url_ = url_.replace("{creatorCustomerId}", encodeURIComponent("" + creatorCustomerId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processCreatorCustomers_Delete(_response); });
        });
    };
    Client.prototype.processCreatorCustomers_Delete = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Gets a session portal link for a Creator Customer to manage their subscription.
     * @param stripeAccountId The stripe account id.
     * @param customerId The stripe account id.
     * @param subscriptionId The stripe account id.
     * @return OK
     */
    Client.prototype.creatorCustomerSubscription_GetSessionPortal = function (stripeAccountId, customerId, subscriptionId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/StripeAccount/{stripeAccountId}/CreatorCustomers/{customerId}/Subscription/{subscriptionId}/Portal";
        if (stripeAccountId === undefined || stripeAccountId === null)
            throw new Error("The parameter 'stripeAccountId' must be defined.");
        url_ = url_.replace("{stripeAccountId}", encodeURIComponent("" + stripeAccountId));
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processCreatorCustomerSubscription_GetSessionPortal(_response); });
        });
    };
    Client.prototype.processCreatorCustomerSubscription_GetSessionPortal = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.creatorEmailAccess_CreateOrValidateEmailAccess = function (request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/EmailAccess";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processCreatorEmailAccess_CreateOrValidateEmailAccess(_response); });
        });
    };
    Client.prototype.processCreatorEmailAccess_CreateOrValidateEmailAccess = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Get the entitlement by product id.
     * @param productId The productId id.
     * @return OK
     */
    Client.prototype.creatorProductEntitlements_GetByProductId = function (productId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/CreatorProductEntitlements/ByProductId?";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined and cannot be null.");
        else
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processCreatorProductEntitlements_GetByProductId(_response); });
        });
    };
    Client.prototype.processCreatorProductEntitlements_GetByProductId = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Get the entitlement by video player id.
     * @param videoPlayerId The video player id.
     * @return OK
     */
    Client.prototype.creatorProductEntitlements_GetByVideoPlayerId = function (videoPlayerId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/CreatorProductEntitlements/ByVideoPlayerId?";
        if (videoPlayerId === undefined || videoPlayerId === null)
            throw new Error("The parameter 'videoPlayerId' must be defined and cannot be null.");
        else
            url_ += "videoPlayerId=" + encodeURIComponent("" + videoPlayerId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processCreatorProductEntitlements_GetByVideoPlayerId(_response); });
        });
    };
    Client.prototype.processCreatorProductEntitlements_GetByVideoPlayerId = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Get the entitlement by video player playlist id.
     * @param videoPlayerPlaylistId The video player playlist id.
     * @return OK
     */
    Client.prototype.creatorProductEntitlements_GetByVideoPlayerPlaylistId = function (videoPlayerPlaylistId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/CreatorProductEntitlements/ByVideoPlayerPlaylistId?";
        if (videoPlayerPlaylistId === undefined || videoPlayerPlaylistId === null)
            throw new Error("The parameter 'videoPlayerPlaylistId' must be defined and cannot be null.");
        else
            url_ += "videoPlayerPlaylistId=" + encodeURIComponent("" + videoPlayerPlaylistId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processCreatorProductEntitlements_GetByVideoPlayerPlaylistId(_response); });
        });
    };
    Client.prototype.processCreatorProductEntitlements_GetByVideoPlayerPlaylistId = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Get the Creator Product Entitlements by video player playlist broadcast id.
     * @param videoPlayerPlaylistBroadcastId The video player playlist broadcast id.
     * @param includeProduct (optional) If true, include product.
     * @return OK
     */
    Client.prototype.creatorProductEntitlements_GetByVideoPlayerPlaylistBroadcastId = function (videoPlayerPlaylistBroadcastId, includeProduct) {
        var _this = this;
        var url_ = this.baseUrl + "/api/CreatorProductEntitlements/ByVideoPlayerPlaylistBroadcastId?";
        if (videoPlayerPlaylistBroadcastId === undefined || videoPlayerPlaylistBroadcastId === null)
            throw new Error("The parameter 'videoPlayerPlaylistBroadcastId' must be defined and cannot be null.");
        else
            url_ += "videoPlayerPlaylistBroadcastId=" + encodeURIComponent("" + videoPlayerPlaylistBroadcastId) + "&";
        if (includeProduct !== undefined && includeProduct !== null)
            url_ += "includeProduct=" + encodeURIComponent("" + includeProduct) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processCreatorProductEntitlements_GetByVideoPlayerPlaylistBroadcastId(_response); });
        });
    };
    Client.prototype.processCreatorProductEntitlements_GetByVideoPlayerPlaylistBroadcastId = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Get the Creator Product Entitlements by catalog id.
     * @param catalogId The catalog id.
     * @param includeProduct (optional) If true, include product.
     * @return OK
     */
    Client.prototype.creatorProductEntitlements_GetByCatalogId = function (catalogId, includeProduct) {
        var _this = this;
        var url_ = this.baseUrl + "/api/CreatorProductEntitlements/ByCatalogId?";
        if (catalogId === undefined || catalogId === null)
            throw new Error("The parameter 'catalogId' must be defined and cannot be null.");
        else
            url_ += "catalogId=" + encodeURIComponent("" + catalogId) + "&";
        if (includeProduct !== undefined && includeProduct !== null)
            url_ += "includeProduct=" + encodeURIComponent("" + includeProduct) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processCreatorProductEntitlements_GetByCatalogId(_response); });
        });
    };
    Client.prototype.processCreatorProductEntitlements_GetByCatalogId = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Creates the {System.Web.Http.IHttpActionResult}.
     * @param productEntitlementsRequest The product entitlements request.
     * @return OK
     */
    Client.prototype.creatorProductEntitlements_Create = function (productEntitlementsRequest) {
        var _this = this;
        var url_ = this.baseUrl + "/api/CreatorProductEntitlements";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(productEntitlementsRequest);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processCreatorProductEntitlements_Create(_response); });
        });
    };
    Client.prototype.processCreatorProductEntitlements_Create = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Deletes the {System.Web.Http.IHttpActionResult} asynchronously.
     * @param productEntitlementId The product entitlement id.
     * @return OK
     */
    Client.prototype.creatorProductEntitlements_Delete = function (productEntitlementId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/CreatorProductEntitlements/{productEntitlementId}";
        if (productEntitlementId === undefined || productEntitlementId === null)
            throw new Error("The parameter 'productEntitlementId' must be defined.");
        url_ = url_.replace("{productEntitlementId}", encodeURIComponent("" + productEntitlementId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processCreatorProductEntitlements_Delete(_response); });
        });
    };
    Client.prototype.processCreatorProductEntitlements_Delete = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Cancel all active subscriptions for a given product.
     * @param productId The product id.
     * @return OK
     */
    Client.prototype.creatorProductEntitlements_CancelByProductId = function (productId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/CreatorProductEntitlements/ByProductId/{productId}";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processCreatorProductEntitlements_CancelByProductId(_response); });
        });
    };
    Client.prototype.processCreatorProductEntitlements_CancelByProductId = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Gets the CreatorProductPrices asynchronously.
     * @param stripeAccountId The stripe account id.
     * @param creatorProductId The CreatorProductId
     * @return OK
     */
    Client.prototype.creatorProductPrices_Get = function (stripeAccountId, creatorProductId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/StripeAccount/{stripeAccountId}/CreatorProducts/{creatorProductId}/Prices";
        if (stripeAccountId === undefined || stripeAccountId === null)
            throw new Error("The parameter 'stripeAccountId' must be defined.");
        url_ = url_.replace("{stripeAccountId}", encodeURIComponent("" + stripeAccountId));
        if (creatorProductId === undefined || creatorProductId === null)
            throw new Error("The parameter 'creatorProductId' must be defined.");
        url_ = url_.replace("{creatorProductId}", encodeURIComponent("" + creatorProductId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processCreatorProductPrices_Get(_response); });
        });
    };
    Client.prototype.processCreatorProductPrices_Get = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Updates the CreatorProductPrices asynchronously.
     * @param stripeAccountId The stripe account id.
     * @param creatorProductId The CreatorProductId
     * @param pricesRequest The prices request.
     * @return OK
     */
    Client.prototype.creatorProductPrices_Update = function (stripeAccountId, creatorProductId, pricesRequest) {
        var _this = this;
        var url_ = this.baseUrl + "/api/StripeAccount/{stripeAccountId}/CreatorProducts/{creatorProductId}/Prices";
        if (stripeAccountId === undefined || stripeAccountId === null)
            throw new Error("The parameter 'stripeAccountId' must be defined.");
        url_ = url_.replace("{stripeAccountId}", encodeURIComponent("" + stripeAccountId));
        if (creatorProductId === undefined || creatorProductId === null)
            throw new Error("The parameter 'creatorProductId' must be defined.");
        url_ = url_.replace("{creatorProductId}", encodeURIComponent("" + creatorProductId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(pricesRequest);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processCreatorProductPrices_Update(_response); });
        });
    };
    Client.prototype.processCreatorProductPrices_Update = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Creates the {System.Web.Http.IHttpActionResult} asynchronously.
     * @param stripeAccountId The stripe account id.
     * @param creatorProductId The CreatorProductId
     * @param pricesRequest The prices request.
     * @return OK
     */
    Client.prototype.creatorProductPrices_Create = function (stripeAccountId, creatorProductId, pricesRequest) {
        var _this = this;
        var url_ = this.baseUrl + "/api/StripeAccount/{stripeAccountId}/CreatorProducts/{creatorProductId}/Prices";
        if (stripeAccountId === undefined || stripeAccountId === null)
            throw new Error("The parameter 'stripeAccountId' must be defined.");
        url_ = url_.replace("{stripeAccountId}", encodeURIComponent("" + stripeAccountId));
        if (creatorProductId === undefined || creatorProductId === null)
            throw new Error("The parameter 'creatorProductId' must be defined.");
        url_ = url_.replace("{creatorProductId}", encodeURIComponent("" + creatorProductId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(pricesRequest);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processCreatorProductPrices_Create(_response); });
        });
    };
    Client.prototype.processCreatorProductPrices_Create = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Gets the {System.Web.Http.IHttpActionResult} asynchronously.
     * @param stripeAccountId The stripe account id.
     * @param includePrices (optional) If true, include prices.
     * @param includeEntitlements (optional) Whether to include entitlements in the response
     * @param includeAnalytics (optional) Whether to include revenue analytics in the response
     * @return OK
     */
    Client.prototype.creatorProducts_Get = function (stripeAccountId, includePrices, includeEntitlements, includeAnalytics) {
        var _this = this;
        var url_ = this.baseUrl + "/api/StripeAccount/{stripeAccountId}/CreatorProducts?";
        if (stripeAccountId === undefined || stripeAccountId === null)
            throw new Error("The parameter 'stripeAccountId' must be defined.");
        url_ = url_.replace("{stripeAccountId}", encodeURIComponent("" + stripeAccountId));
        if (includePrices !== undefined && includePrices !== null)
            url_ += "includePrices=" + encodeURIComponent("" + includePrices) + "&";
        if (includeEntitlements !== undefined && includeEntitlements !== null)
            url_ += "includeEntitlements=" + encodeURIComponent("" + includeEntitlements) + "&";
        if (includeAnalytics !== undefined && includeAnalytics !== null)
            url_ += "includeAnalytics=" + encodeURIComponent("" + includeAnalytics) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processCreatorProducts_Get(_response); });
        });
    };
    Client.prototype.processCreatorProducts_Get = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Updates the CreatorProducts asynchronously.
     * @param stripeAccountId The stripe account id.
     * @param productsRequest The products request.
     * @return OK
     */
    Client.prototype.creatorProducts_Update = function (stripeAccountId, productsRequest) {
        var _this = this;
        var url_ = this.baseUrl + "/api/StripeAccount/{stripeAccountId}/CreatorProducts";
        if (stripeAccountId === undefined || stripeAccountId === null)
            throw new Error("The parameter 'stripeAccountId' must be defined.");
        url_ = url_.replace("{stripeAccountId}", encodeURIComponent("" + stripeAccountId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(productsRequest);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processCreatorProducts_Update(_response); });
        });
    };
    Client.prototype.processCreatorProducts_Update = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Creates the {System.Web.Http.IHttpActionResult} asynchronously.
     * @param stripeAccountId The stripe account id.
     * @param productsRequest The products request.
     * @return OK
     */
    Client.prototype.creatorProducts_Create = function (stripeAccountId, productsRequest) {
        var _this = this;
        var url_ = this.baseUrl + "/api/StripeAccount/{stripeAccountId}/CreatorProducts";
        if (stripeAccountId === undefined || stripeAccountId === null)
            throw new Error("The parameter 'stripeAccountId' must be defined.");
        url_ = url_.replace("{stripeAccountId}", encodeURIComponent("" + stripeAccountId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(productsRequest);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processCreatorProducts_Create(_response); });
        });
    };
    Client.prototype.processCreatorProducts_Create = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Gets the number of subscribers for a given product
     * @return OK
     */
    Client.prototype.creatorProducts_GetSubscriberCount = function (stripeAccountId, creatorProductId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/StripeAccount/{stripeAccountId}/CreatorProducts/{creatorProductId}/SubscriberCount";
        if (stripeAccountId === undefined || stripeAccountId === null)
            throw new Error("The parameter 'stripeAccountId' must be defined.");
        url_ = url_.replace("{stripeAccountId}", encodeURIComponent("" + stripeAccountId));
        if (creatorProductId === undefined || creatorProductId === null)
            throw new Error("The parameter 'creatorProductId' must be defined.");
        url_ = url_.replace("{creatorProductId}", encodeURIComponent("" + creatorProductId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processCreatorProducts_GetSubscriberCount(_response); });
        });
    };
    Client.prototype.processCreatorProducts_GetSubscriberCount = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Gets a summary of product prices, including number of active subscribers per price
     * @return OK
     */
    Client.prototype.creatorProducts_GetProductActiveSubscriberCountByPrice = function (stripeAccountId, creatorProductId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/StripeAccount/{stripeAccountId}/CreatorProducts/{creatorProductId}/ActiveSubscriberCountByPrice";
        if (stripeAccountId === undefined || stripeAccountId === null)
            throw new Error("The parameter 'stripeAccountId' must be defined.");
        url_ = url_.replace("{stripeAccountId}", encodeURIComponent("" + stripeAccountId));
        if (creatorProductId === undefined || creatorProductId === null)
            throw new Error("The parameter 'creatorProductId' must be defined.");
        url_ = url_.replace("{creatorProductId}", encodeURIComponent("" + creatorProductId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processCreatorProducts_GetProductActiveSubscriberCountByPrice(_response); });
        });
    };
    Client.prototype.processCreatorProducts_GetProductActiveSubscriberCountByPrice = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Post web hook.
     * @param stripeEvent The my stripe event.
     * @return OK
     */
    Client.prototype.creatorWebhooks_PostWebHook = function (stripeEvent) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Creator/Webhook";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(stripeEvent);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processCreatorWebhooks_PostWebHook(_response); });
        });
    };
    Client.prototype.processCreatorWebhooks_PostWebHook = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Gets the metrics asynchronously.
     * @param request The request.
     * @return OK
     */
    Client.prototype.customerRedemptionAnalytics_GetCustomersForUser = function (request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/CustomerRedemption/Analytics/User";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processCustomerRedemptionAnalytics_GetCustomersForUser(_response); });
        });
    };
    Client.prototype.processCustomerRedemptionAnalytics_GetCustomersForUser = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.deletionRequests_GetDeleteionRequestById = function (userId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{userId}/DeletionRequest";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processDeletionRequests_GetDeleteionRequestById(_response); });
        });
    };
    Client.prototype.processDeletionRequests_GetDeleteionRequestById = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.deletionRequests_PostDeletionRequest = function (userId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{userId}/DeletionRequest";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processDeletionRequests_PostDeletionRequest(_response); });
        });
    };
    Client.prototype.processDeletionRequests_PostDeletionRequest = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.deletionRequests_DeleteDeletionRequest = function (userId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{userId}/DeletionRequest";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processDeletionRequests_DeleteDeletionRequest(_response); });
        });
    };
    Client.prototype.processDeletionRequests_DeleteDeletionRequest = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.deletionRequests_GetDeletionRequests = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/DeletionRequests";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processDeletionRequests_GetDeletionRequests(_response); });
        });
    };
    Client.prototype.processDeletionRequests_GetDeletionRequests = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.discoveryEndpoint_GetConfiguration = function () {
        var _this = this;
        var url_ = this.baseUrl + "/.well-known/openid-configuration";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processDiscoveryEndpoint_GetConfiguration(_response); });
        });
    };
    Client.prototype.processDiscoveryEndpoint_GetConfiguration = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * GET: api/Extensions/{id}/Icons
    Get all Icons on Extension.
     * @param id Id of Extention.
     * @return OK
     */
    Client.prototype.extensionIcons_GetExtensionIcons = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Extensions/{id}/Icons";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processExtensionIcons_GetExtensionIcons(_response); });
        });
    };
    Client.prototype.processExtensionIcons_GetExtensionIcons = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * POST: api/Extensions/{id}/Icons
    Connects an existing Asset as an Icon for given Extension.
     * @param id Id of Extention.
     * @param icons Asset object containing id of Icon Asset.
     * @return OK
     */
    Client.prototype.extensionIcons_PostExtensionIcons = function (id, icons) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Extensions/{id}/Icons";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(icons);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processExtensionIcons_PostExtensionIcons(_response); });
        });
    };
    Client.prototype.processExtensionIcons_PostExtensionIcons = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * GET: api/Extensions/{id}/Icons/{iconId}
    Get Icon on Extension.
     * @param id Id of Extention.
     * @param iconId Id of Icon Asset.
     * @return OK
     */
    Client.prototype.extensionIcons_GetExtensionIcon = function (id, iconId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Extensions/{id}/Icons/{iconId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (iconId === undefined || iconId === null)
            throw new Error("The parameter 'iconId' must be defined.");
        url_ = url_.replace("{iconId}", encodeURIComponent("" + iconId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processExtensionIcons_GetExtensionIcon(_response); });
        });
    };
    Client.prototype.processExtensionIcons_GetExtensionIcon = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * DELETE: api/Extensions/{id}/Icons/{iconId}
    Removes Icon Asset to Extension relationship
     * @param id Id of Extention.
     * @param iconId Id of Icon Asset.
     * @return OK
     */
    Client.prototype.extensionIcons_DeleteExtensionIcon = function (id, iconId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Extensions/{id}/Icons/{iconId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (iconId === undefined || iconId === null)
            throw new Error("The parameter 'iconId' must be defined.");
        url_ = url_.replace("{iconId}", encodeURIComponent("" + iconId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processExtensionIcons_DeleteExtensionIcon(_response); });
        });
    };
    Client.prototype.processExtensionIcons_DeleteExtensionIcon = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.extensions_GetExtension = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Extensions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processExtensions_GetExtension(_response); });
        });
    };
    Client.prototype.processExtensions_GetExtension = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return No Content
     */
    Client.prototype.extensions_PutExtension = function (id, extension) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Extensions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(extension);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processExtensions_PutExtension(_response); });
        });
    };
    Client.prototype.processExtensions_PutExtension = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 204) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.extensions_DeleteExtension = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Extensions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processExtensions_DeleteExtension(_response); });
        });
    };
    Client.prototype.processExtensions_DeleteExtension = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.extensions_GetExtensions = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Extensions";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processExtensions_GetExtensions(_response); });
        });
    };
    Client.prototype.processExtensions_GetExtensions = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.extensions_PostExtension = function (extension) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Extensions";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(extension);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processExtensions_PostExtension(_response); });
        });
    };
    Client.prototype.processExtensions_PostExtension = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.externalProviderSwitcherStreamSettings_GetExternalProviderSwitcherStreamSetting = function (providerId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/{providerId}/SwitcherStreamSettings";
        if (providerId === undefined || providerId === null)
            throw new Error("The parameter 'providerId' must be defined.");
        url_ = url_.replace("{providerId}", encodeURIComponent("" + providerId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processExternalProviderSwitcherStreamSettings_GetExternalProviderSwitcherStreamSetting(_response); });
        });
    };
    Client.prototype.processExternalProviderSwitcherStreamSettings_GetExternalProviderSwitcherStreamSetting = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return No Content
     */
    Client.prototype.externalProviderSwitcherStreamSettings_PutExternalProviderSwitcherStreamSetting = function (providerId, externalProviderSwitcherStreamSetting) {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/{providerId}/SwitcherStreamSettings";
        if (providerId === undefined || providerId === null)
            throw new Error("The parameter 'providerId' must be defined.");
        url_ = url_.replace("{providerId}", encodeURIComponent("" + providerId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(externalProviderSwitcherStreamSetting);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processExternalProviderSwitcherStreamSettings_PutExternalProviderSwitcherStreamSetting(_response); });
        });
    };
    Client.prototype.processExternalProviderSwitcherStreamSettings_PutExternalProviderSwitcherStreamSetting = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 204) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.externalProviderSwitcherStreamSettings_PostExternalProviderSwitcherStreamSetting = function (providerId, externalProviderSwitcherStreamSetting) {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/{providerId}/SwitcherStreamSettings";
        if (providerId === undefined || providerId === null)
            throw new Error("The parameter 'providerId' must be defined.");
        url_ = url_.replace("{providerId}", encodeURIComponent("" + providerId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(externalProviderSwitcherStreamSetting);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processExternalProviderSwitcherStreamSettings_PostExternalProviderSwitcherStreamSetting(_response); });
        });
    };
    Client.prototype.processExternalProviderSwitcherStreamSettings_PostExternalProviderSwitcherStreamSetting = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.externalProviderSwitcherStreamSettings_DeleteExternalProviderSwitcherStreamSetting = function (providerId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/{providerId}/SwitcherStreamSettings";
        if (providerId === undefined || providerId === null)
            throw new Error("The parameter 'providerId' must be defined.");
        url_ = url_.replace("{providerId}", encodeURIComponent("" + providerId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processExternalProviderSwitcherStreamSettings_DeleteExternalProviderSwitcherStreamSetting(_response); });
        });
    };
    Client.prototype.processExternalProviderSwitcherStreamSettings_DeleteExternalProviderSwitcherStreamSetting = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.facebook_GetFacebookRequest = function (url) {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/Facebook/Proxy/{url}";
        if (url === undefined || url === null)
            throw new Error("The parameter 'url' must be defined.");
        url_ = url_.replace("{url}", encodeURIComponent("" + url));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processFacebook_GetFacebookRequest(_response); });
        });
    };
    Client.prototype.processFacebook_GetFacebookRequest = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.facebook_PostFacebookRequest = function (url) {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/Facebook/Proxy/{url}";
        if (url === undefined || url === null)
            throw new Error("The parameter 'url' must be defined.");
        url_ = url_.replace("{url}", encodeURIComponent("" + url));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processFacebook_PostFacebookRequest(_response); });
        });
    };
    Client.prototype.processFacebook_PostFacebookRequest = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.facebook_DeleteFacebookRequest = function (url) {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/Facebook/Proxy/{url}";
        if (url === undefined || url === null)
            throw new Error("The parameter 'url' must be defined.");
        url_ = url_.replace("{url}", encodeURIComponent("" + url));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processFacebook_DeleteFacebookRequest(_response); });
        });
    };
    Client.prototype.processFacebook_DeleteFacebookRequest = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.facebook_GetFaceBookCredentials = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/Facebook/Credentials";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processFacebook_GetFaceBookCredentials(_response); });
        });
    };
    Client.prototype.processFacebook_GetFaceBookCredentials = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.facebook_PostCredentials = function (creds) {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/Facebook/Credentials";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(creds);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processFacebook_PostCredentials(_response); });
        });
    };
    Client.prototype.processFacebook_PostCredentials = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.facebook_DeleteCredentials = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/Facebook/Credentials";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processFacebook_DeleteCredentials(_response); });
        });
    };
    Client.prototype.processFacebook_DeleteCredentials = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.facebook_GetFacebookSwitcherStreamSetting = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/Facebook/SwitcherStreamSettings";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processFacebook_GetFacebookSwitcherStreamSetting(_response); });
        });
    };
    Client.prototype.processFacebook_GetFacebookSwitcherStreamSetting = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.facebook_PutFacebookSwitcherStreamSetting = function (switcherStreamSetting) {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/Facebook/SwitcherStreamSettings";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(switcherStreamSetting);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processFacebook_PutFacebookSwitcherStreamSetting(_response); });
        });
    };
    Client.prototype.processFacebook_PutFacebookSwitcherStreamSetting = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.facebook_PostFacebookSwitcherStreamSetting = function (switcherStreamSetting) {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/Facebook/SwitcherStreamSettings";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(switcherStreamSetting);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processFacebook_PostFacebookSwitcherStreamSetting(_response); });
        });
    };
    Client.prototype.processFacebook_PostFacebookSwitcherStreamSetting = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.facebook_PostStreamEnd = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/Facebook/StreamEnd";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processFacebook_PostStreamEnd(_response); });
        });
    };
    Client.prototype.processFacebook_PostStreamEnd = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.facebook_GetFacebookStreamStatus = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/Facebook/StreamStatus";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processFacebook_GetFacebookStreamStatus(_response); });
        });
    };
    Client.prototype.processFacebook_GetFacebookStreamStatus = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.features_GetFeatures = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Features";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processFeatures_GetFeatures(_response); });
        });
    };
    Client.prototype.processFeatures_GetFeatures = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.features_PostFeature = function (feature) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Features";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(feature);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processFeatures_PostFeature(_response); });
        });
    };
    Client.prototype.processFeatures_PostFeature = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.features_GetFeature = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Features/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processFeatures_GetFeature(_response); });
        });
    };
    Client.prototype.processFeatures_GetFeature = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return No Content
     */
    Client.prototype.features_PutFeature = function (id, feature) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Features/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(feature);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processFeatures_PutFeature(_response); });
        });
    };
    Client.prototype.processFeatures_PutFeature = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 204) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.features_DeleteFeature = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Features/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processFeatures_DeleteFeature(_response); });
        });
    };
    Client.prototype.processFeatures_DeleteFeature = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.growsurf_GetReferrer = function (campaignId, participantId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Growsurf/Campaign/{campaignId}/Referrer/{participantId}";
        if (campaignId === undefined || campaignId === null)
            throw new Error("The parameter 'campaignId' must be defined.");
        url_ = url_.replace("{campaignId}", encodeURIComponent("" + campaignId));
        if (participantId === undefined || participantId === null)
            throw new Error("The parameter 'participantId' must be defined.");
        url_ = url_.replace("{participantId}", encodeURIComponent("" + participantId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGrowsurf_GetReferrer(_response); });
        });
    };
    Client.prototype.processGrowsurf_GetReferrer = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.growsurf_GrowsurfWebhook = function (campaignId, payload) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Growsurf/Webhook/{campaignId}";
        if (campaignId === undefined || campaignId === null)
            throw new Error("The parameter 'campaignId' must be defined.");
        url_ = url_.replace("{campaignId}", encodeURIComponent("" + campaignId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(payload);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGrowsurf_GrowsurfWebhook(_response); });
        });
    };
    Client.prototype.processGrowsurf_GrowsurfWebhook = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.icons_GetIcons = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Icons";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processIcons_GetIcons(_response); });
        });
    };
    Client.prototype.processIcons_GetIcons = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.icons_PostIcons = function (payload) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Icons";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(payload);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processIcons_PostIcons(_response); });
        });
    };
    Client.prototype.processIcons_PostIcons = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.linkedIn_GetEventsWebhook = function (challengeCode) {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/LinkedIn/events-webhook?";
        if (challengeCode === undefined || challengeCode === null)
            throw new Error("The parameter 'challengeCode' must be defined and cannot be null.");
        else
            url_ += "challengeCode=" + encodeURIComponent("" + challengeCode) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processLinkedIn_GetEventsWebhook(_response); });
        });
    };
    Client.prototype.processLinkedIn_GetEventsWebhook = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.linkedIn_PostEventsWebhook = function (liEvent) {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/LinkedIn/events-webhook";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(liEvent);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processLinkedIn_PostEventsWebhook(_response); });
        });
    };
    Client.prototype.processLinkedIn_PostEventsWebhook = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.linkedIn_PostDrainEvents = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/LinkedIn/drain-events";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processLinkedIn_PostDrainEvents(_response); });
        });
    };
    Client.prototype.processLinkedIn_PostDrainEvents = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.linkedIn_GetLinkedInCredentials = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/LinkedIn/Credentials";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processLinkedIn_GetLinkedInCredentials(_response); });
        });
    };
    Client.prototype.processLinkedIn_GetLinkedInCredentials = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.linkedIn_PostCredentials = function (creds) {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/LinkedIn/Credentials";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(creds);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processLinkedIn_PostCredentials(_response); });
        });
    };
    Client.prototype.processLinkedIn_PostCredentials = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.linkedIn_DeleteCredentials = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/LinkedIn/Credentials";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processLinkedIn_DeleteCredentials(_response); });
        });
    };
    Client.prototype.processLinkedIn_DeleteCredentials = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.linkedIn_GetLinkedInSwitcherStreamSetting = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/LinkedIn/SwitcherStreamSettings";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processLinkedIn_GetLinkedInSwitcherStreamSetting(_response); });
        });
    };
    Client.prototype.processLinkedIn_GetLinkedInSwitcherStreamSetting = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.linkedIn_PutLinkedInSwitcherStreamSetting = function (switcherStreamSetting) {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/LinkedIn/SwitcherStreamSettings";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(switcherStreamSetting);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processLinkedIn_PutLinkedInSwitcherStreamSetting(_response); });
        });
    };
    Client.prototype.processLinkedIn_PutLinkedInSwitcherStreamSetting = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.linkedIn_PostLinkedInSwitcherStreamSetting = function (switcherStreamSetting) {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/LinkedIn/SwitcherStreamSettings";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(switcherStreamSetting);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processLinkedIn_PostLinkedInSwitcherStreamSetting(_response); });
        });
    };
    Client.prototype.processLinkedIn_PostLinkedInSwitcherStreamSetting = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.linkedIn_PostStreamEnd = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/LinkedIn/StreamEnd";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processLinkedIn_PostStreamEnd(_response); });
        });
    };
    Client.prototype.processLinkedIn_PostStreamEnd = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.linkedIn_GetLinkedInStreamStatus = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/LinkedIn/StreamStatus";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processLinkedIn_GetLinkedInStreamStatus(_response); });
        });
    };
    Client.prototype.processLinkedIn_GetLinkedInStreamStatus = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.linkedIn_GetLinkedInPostUrn = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/LinkedIn/PostUrn";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processLinkedIn_GetLinkedInPostUrn(_response); });
        });
    };
    Client.prototype.processLinkedIn_GetLinkedInPostUrn = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.linkedIn_GetLinkedInRequest = function (url) {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/LinkedIn/Proxy/{url}";
        if (url === undefined || url === null)
            throw new Error("The parameter 'url' must be defined.");
        url_ = url_.replace("{url}", encodeURIComponent("" + url));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processLinkedIn_GetLinkedInRequest(_response); });
        });
    };
    Client.prototype.processLinkedIn_GetLinkedInRequest = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.linkedIn_PostLinkedInRequest = function (url) {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/LinkedIn/Proxy/{url}";
        if (url === undefined || url === null)
            throw new Error("The parameter 'url' must be defined.");
        url_ = url_.replace("{url}", encodeURIComponent("" + url));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processLinkedIn_PostLinkedInRequest(_response); });
        });
    };
    Client.prototype.processLinkedIn_PostLinkedInRequest = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.metrics_GetPlansLtv = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Metrics/PlansLtv";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processMetrics_GetPlansLtv(_response); });
        });
    };
    Client.prototype.processMetrics_GetPlansLtv = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.organizationAssets_GetOrganizationAssets = function (organizationId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Organizations/{organizationId}/Assets";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processOrganizationAssets_GetOrganizationAssets(_response); });
        });
    };
    Client.prototype.processOrganizationAssets_GetOrganizationAssets = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param keepPreviousVersions (optional)
     * @return OK
     */
    Client.prototype.organizationAssets_PutOrganizationAssets = function (organizationId, assetPutOptions, keepPreviousVersions) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Organizations/{organizationId}/Assets?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (keepPreviousVersions !== undefined && keepPreviousVersions !== null)
            url_ += "keepPreviousVersions=" + encodeURIComponent("" + keepPreviousVersions) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(assetPutOptions);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processOrganizationAssets_PutOrganizationAssets(_response); });
        });
    };
    Client.prototype.processOrganizationAssets_PutOrganizationAssets = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.organizationAssets_DeleteOrganizationAssets = function (organizationId, assets) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Organizations/{organizationId}/Assets";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(assets);
        var options_ = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processOrganizationAssets_DeleteOrganizationAssets(_response); });
        });
    };
    Client.prototype.processOrganizationAssets_DeleteOrganizationAssets = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.organizationAssets_GetOrganizationAsset = function (organizationId, assetId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Organizations/{organizationId}/Assets/{assetId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (assetId === undefined || assetId === null)
            throw new Error("The parameter 'assetId' must be defined.");
        url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processOrganizationAssets_GetOrganizationAsset(_response); });
        });
    };
    Client.prototype.processOrganizationAssets_GetOrganizationAsset = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.organizationAssets_DeleteOrganizationAsset = function (organizationId, assetId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Organizations/{organizationId}/Assets/{assetId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (assetId === undefined || assetId === null)
            throw new Error("The parameter 'assetId' must be defined.");
        url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processOrganizationAssets_DeleteOrganizationAsset(_response); });
        });
    };
    Client.prototype.processOrganizationAssets_DeleteOrganizationAsset = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.organizationBrands_GetOrganizationBrands = function (organizationId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Organizations/{organizationId}/Brands";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processOrganizationBrands_GetOrganizationBrands(_response); });
        });
    };
    Client.prototype.processOrganizationBrands_GetOrganizationBrands = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.organizationBrands_PostOrganizationBrand = function (organizationId, brand) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Organizations/{organizationId}/Brands";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(brand);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processOrganizationBrands_PostOrganizationBrand(_response); });
        });
    };
    Client.prototype.processOrganizationBrands_PostOrganizationBrand = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.organizationBrands_PutOrganizationBrand = function (organizationId, brandId, brand) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Organizations/{organizationId}/Brands/{brandId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (brandId === undefined || brandId === null)
            throw new Error("The parameter 'brandId' must be defined.");
        url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(brand);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processOrganizationBrands_PutOrganizationBrand(_response); });
        });
    };
    Client.prototype.processOrganizationBrands_PutOrganizationBrand = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.organizationBrands_DeleteOrganizationBrand = function (organizationId, brandId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Organizations/{organizationId}/Brands/{brandId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (brandId === undefined || brandId === null)
            throw new Error("The parameter 'brandId' must be defined.");
        url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processOrganizationBrands_DeleteOrganizationBrand(_response); });
        });
    };
    Client.prototype.processOrganizationBrands_DeleteOrganizationBrand = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.organizations_GetOrganizations = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Organizations";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processOrganizations_GetOrganizations(_response); });
        });
    };
    Client.prototype.processOrganizations_GetOrganizations = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.organizations_PostOrganization = function (organization) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Organizations";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(organization);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processOrganizations_PostOrganization(_response); });
        });
    };
    Client.prototype.processOrganizations_PostOrganization = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.organizations_GetOrganization = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Organizations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processOrganizations_GetOrganization(_response); });
        });
    };
    Client.prototype.processOrganizations_GetOrganization = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return No Content
     */
    Client.prototype.organizations_PutOrganization = function (id, organization) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Organizations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(organization);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processOrganizations_PutOrganization(_response); });
        });
    };
    Client.prototype.processOrganizations_PutOrganization = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 204) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.organizations_DeleteOrganization = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Organizations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processOrganizations_DeleteOrganization(_response); });
        });
    };
    Client.prototype.processOrganizations_DeleteOrganization = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.organizations_PatchOrganization = function (id, patch) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Organizations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(patch);
        var options_ = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processOrganizations_PatchOrganization(_response); });
        });
    };
    Client.prototype.processOrganizations_PatchOrganization = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.organizationStreamDestinations_GetOrganizationStreamDestinations = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/OrganizationStreamDestinations";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processOrganizationStreamDestinations_GetOrganizationStreamDestinations(_response); });
        });
    };
    Client.prototype.processOrganizationStreamDestinations_GetOrganizationStreamDestinations = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.organizationStreamDestinations_PostOrganizationStreamDestination = function (organizationStreamDestination) {
        var _this = this;
        var url_ = this.baseUrl + "/api/OrganizationStreamDestinations";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(organizationStreamDestination);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processOrganizationStreamDestinations_PostOrganizationStreamDestination(_response); });
        });
    };
    Client.prototype.processOrganizationStreamDestinations_PostOrganizationStreamDestination = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.organizationStreamDestinations_GetOrganizationStreamDestination = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/OrganizationStreamDestinations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processOrganizationStreamDestinations_GetOrganizationStreamDestination(_response); });
        });
    };
    Client.prototype.processOrganizationStreamDestinations_GetOrganizationStreamDestination = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return No Content
     */
    Client.prototype.organizationStreamDestinations_PutOrganizationStreamDestination = function (id, organizationStreamDestination) {
        var _this = this;
        var url_ = this.baseUrl + "/api/OrganizationStreamDestinations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(organizationStreamDestination);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processOrganizationStreamDestinations_PutOrganizationStreamDestination(_response); });
        });
    };
    Client.prototype.processOrganizationStreamDestinations_PutOrganizationStreamDestination = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 204) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.organizationStreamDestinations_DeleteOrganizationStreamDestination = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/OrganizationStreamDestinations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processOrganizationStreamDestinations_DeleteOrganizationStreamDestination(_response); });
        });
    };
    Client.prototype.processOrganizationStreamDestinations_DeleteOrganizationStreamDestination = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.organizationUsers_GetOrganizationUsers = function (orgId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Organizations/{orgId}/Users";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{orgId}", encodeURIComponent("" + orgId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processOrganizationUsers_GetOrganizationUsers(_response); });
        });
    };
    Client.prototype.processOrganizationUsers_GetOrganizationUsers = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.organizationUsers_PostOrganizationUser = function (orgId, account) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Organizations/{orgId}/Users";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{orgId}", encodeURIComponent("" + orgId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(account);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processOrganizationUsers_PostOrganizationUser(_response); });
        });
    };
    Client.prototype.processOrganizationUsers_PostOrganizationUser = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.organizationUsers_GetOrganizationUser = function (orgId, id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Organizations/{orgId}/Users/{id}";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{orgId}", encodeURIComponent("" + orgId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processOrganizationUsers_GetOrganizationUser(_response); });
        });
    };
    Client.prototype.processOrganizationUsers_GetOrganizationUser = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return No Content
     */
    Client.prototype.organizationUsers_PutOrganizationUser = function (orgId, id, organizationUser) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Organizations/{orgId}/Users/{id}";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{orgId}", encodeURIComponent("" + orgId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(organizationUser);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processOrganizationUsers_PutOrganizationUser(_response); });
        });
    };
    Client.prototype.processOrganizationUsers_PutOrganizationUser = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 204) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.organizationUsers_DeleteOrganizationUser = function (orgId, id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Organizations/{orgId}/Users/{id}";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{orgId}", encodeURIComponent("" + orgId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processOrganizationUsers_DeleteOrganizationUser(_response); });
        });
    };
    Client.prototype.processOrganizationUsers_DeleteOrganizationUser = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.organizationUsers_PostSendInvite = function (orgId, id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Organizations/{orgId}/Users/{Id}/SendInvite";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{orgId}", encodeURIComponent("" + orgId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processOrganizationUsers_PostSendInvite(_response); });
        });
    };
    Client.prototype.processOrganizationUsers_PostSendInvite = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param sendEmailInvitation (optional)
     * @return OK
     */
    Client.prototype.organizationUsers_PostOrganizationAdmin = function (orgId, admin, sendEmailInvitation) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Organizations/{orgId}/Users/admin?";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{orgId}", encodeURIComponent("" + orgId));
        if (sendEmailInvitation !== undefined && sendEmailInvitation !== null)
            url_ += "sendEmailInvitation=" + encodeURIComponent("" + sendEmailInvitation) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(admin);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processOrganizationUsers_PostOrganizationAdmin(_response); });
        });
    };
    Client.prototype.processOrganizationUsers_PostOrganizationAdmin = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                return throwException("BadRequest", status, _responseText, _headers);
            });
        }
        else if (status === 409) {
            return response.text().then(function (_responseText) {
                return throwException("Conflict", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.organizationUserStreamDestinations_GetOrganizationUserStreamDestinations = function (orgId, userId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Organizations/{orgId}/Users/{userId}/StreamDestinations";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{orgId}", encodeURIComponent("" + orgId));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processOrganizationUserStreamDestinations_GetOrganizationUserStreamDestinations(_response); });
        });
    };
    Client.prototype.processOrganizationUserStreamDestinations_GetOrganizationUserStreamDestinations = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.organizationUserStreamDestinations_PostOrganizationUserStreamDestination = function (orgId, userId, organizationUserStreamDestination) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Organizations/{orgId}/Users/{userId}/StreamDestinations";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{orgId}", encodeURIComponent("" + orgId));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(organizationUserStreamDestination);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processOrganizationUserStreamDestinations_PostOrganizationUserStreamDestination(_response); });
        });
    };
    Client.prototype.processOrganizationUserStreamDestinations_PostOrganizationUserStreamDestination = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.organizationUserStreamDestinations_DeleteOrganizationUserStreamDestinations = function (orgId, userId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Organizations/{orgId}/Users/{userId}/StreamDestinations";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{orgId}", encodeURIComponent("" + orgId));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processOrganizationUserStreamDestinations_DeleteOrganizationUserStreamDestinations(_response); });
        });
    };
    Client.prototype.processOrganizationUserStreamDestinations_DeleteOrganizationUserStreamDestinations = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.organizationUserStreamDestinations_GetOrganizationUserStreamDestination = function (orgId, userId, id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Organizations/{orgId}/Users/{userId}/StreamDestinations/{id}";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{orgId}", encodeURIComponent("" + orgId));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processOrganizationUserStreamDestinations_GetOrganizationUserStreamDestination(_response); });
        });
    };
    Client.prototype.processOrganizationUserStreamDestinations_GetOrganizationUserStreamDestination = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return No Content
     */
    Client.prototype.organizationUserStreamDestinations_PutOrganizationUserStreamDestination = function (orgId, userId, id, organizationUserStreamDestination) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Organizations/{orgId}/Users/{userId}/StreamDestinations/{id}";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{orgId}", encodeURIComponent("" + orgId));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(organizationUserStreamDestination);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processOrganizationUserStreamDestinations_PutOrganizationUserStreamDestination(_response); });
        });
    };
    Client.prototype.processOrganizationUserStreamDestinations_PutOrganizationUserStreamDestination = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 204) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.organizationUserStreamDestinations_DeleteOrganizationUserStreamDestination = function (orgId, userId, id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Organizations/{orgId}/Users/{userId}/StreamDestinations/{id}";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{orgId}", encodeURIComponent("" + orgId));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processOrganizationUserStreamDestinations_DeleteOrganizationUserStreamDestination(_response); });
        });
    };
    Client.prototype.processOrganizationUserStreamDestinations_DeleteOrganizationUserStreamDestination = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.organizationVideos_GetVideos = function (orgId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Organizations/{orgId}/Videos";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{orgId}", encodeURIComponent("" + orgId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processOrganizationVideos_GetVideos(_response); });
        });
    };
    Client.prototype.processOrganizationVideos_GetVideos = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Gets PartnerStack Partner (known as "partnerships" in PS parlance)
     * @return Partner successfully found and returned
     */
    Client.prototype.partnerStack_GetPartnership = function (partnershipKey) {
        var _this = this;
        var url_ = this.baseUrl + "/api/PartnerStack/Partnership/{partnershipKey}";
        if (partnershipKey === undefined || partnershipKey === null)
            throw new Error("The parameter 'partnershipKey' must be defined.");
        url_ = url_.replace("{partnershipKey}", encodeURIComponent("" + partnershipKey));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processPartnerStack_GetPartnership(_response); });
        });
    };
    Client.prototype.processPartnerStack_GetPartnership = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                return throwException("No partner found", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.prices_GetPrices = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Prices";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processPrices_GetPrices(_response); });
        });
    };
    Client.prototype.processPrices_GetPrices = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.prices_PostPrice = function (price) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Prices";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(price);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processPrices_PostPrice(_response); });
        });
    };
    Client.prototype.processPrices_PostPrice = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.prices_GetPrice = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Prices/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processPrices_GetPrice(_response); });
        });
    };
    Client.prototype.processPrices_GetPrice = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return No Content
     */
    Client.prototype.prices_PutPrice = function (id, price) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Prices/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(price);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processPrices_PutPrice(_response); });
        });
    };
    Client.prototype.processPrices_PutPrice = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 204) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.prices_DeletePrice = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Prices/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processPrices_DeletePrice(_response); });
        });
    };
    Client.prototype.processPrices_DeletePrice = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.products_GetUserAppleProducts = function (userId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{userId}/AppleProducts";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processProducts_GetUserAppleProducts(_response); });
        });
    };
    Client.prototype.processProducts_GetUserAppleProducts = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     * @deprecated
     */
    Client.prototype.projects_GetProjectBroadcasts = function (projectId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/projects/{projectId}/broadcasts";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processProjects_GetProjectBroadcasts(_response); });
        });
    };
    Client.prototype.processProjects_GetProjectBroadcasts = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param platformId (optional)
     * @param broadcastStatus (optional)
     * @param includeThumbnailAsset (optional)
     * @return OK
     * @deprecated
     */
    Client.prototype.projects_GetProjectBroadcastsByFilter = function (projectId, platformId, broadcastStatus, includeThumbnailAsset) {
        var _this = this;
        var url_ = this.baseUrl + "/api/projects/{projectId}/broadcastsByFilter?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (platformId !== undefined && platformId !== null)
            url_ += "platformId=" + encodeURIComponent("" + platformId) + "&";
        if (broadcastStatus !== undefined && broadcastStatus !== null)
            url_ += "broadcastStatus=" + encodeURIComponent("" + broadcastStatus) + "&";
        if (includeThumbnailAsset !== undefined && includeThumbnailAsset !== null)
            url_ += "includeThumbnailAsset=" + encodeURIComponent("" + includeThumbnailAsset) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processProjects_GetProjectBroadcastsByFilter(_response); });
        });
    };
    Client.prototype.processProjects_GetProjectBroadcastsByFilter = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.projects_GetDefaultBroadcast = function (projectId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/projects/{projectId}/defaultBroadcast";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processProjects_GetDefaultBroadcast(_response); });
        });
    };
    Client.prototype.processProjects_GetDefaultBroadcast = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return No Content
     */
    Client.prototype.projects_PostDefaultBroadcast = function (projectId, broadcastId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/projects/{projectId}/defaultBroadcast/{broadcastId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (broadcastId === undefined || broadcastId === null)
            throw new Error("The parameter 'broadcastId' must be defined.");
        url_ = url_.replace("{broadcastId}", encodeURIComponent("" + broadcastId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {}
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processProjects_PostDefaultBroadcast(_response); });
        });
    };
    Client.prototype.processProjects_PostDefaultBroadcast = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 204) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Gets the brand profile associated with a given project
     * @return Returns the brand profile
     */
    Client.prototype.projects_GetProjectBrandProfile = function (projectId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/projects/{projectId}/brandProfile";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processProjects_GetProjectBrandProfile(_response); });
        });
    };
    Client.prototype.processProjects_GetProjectBrandProfile = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then(function (_responseText) {
                return throwException("The project dosn\'t exist", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Get project has video player access.
     * @param projectId The project id.
     * @return OK
     */
    Client.prototype.projects_GetProjectHasVideoPlayerAccess = function (projectId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/projects/{projectId}/VideoPlayer/Access";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processProjects_GetProjectHasVideoPlayerAccess(_response); });
        });
    };
    Client.prototype.processProjects_GetProjectHasVideoPlayerAccess = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.projects_GetProject = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Projects/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processProjects_GetProject(_response); });
        });
    };
    Client.prototype.processProjects_GetProject = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return No Content
     */
    Client.prototype.projects_PutProject = function (id, project) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Projects/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(project);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processProjects_PutProject(_response); });
        });
    };
    Client.prototype.processProjects_PutProject = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 204) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.projects_DeleteProject = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Projects/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processProjects_DeleteProject(_response); });
        });
    };
    Client.prototype.processProjects_DeleteProject = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.projects_PostProject = function (project) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Projects";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(project);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processProjects_PostProject(_response); });
        });
    };
    Client.prototype.processProjects_PostProject = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Get Video Player
     * @param projectId The project Id the video player is associated with
     * @return OK
     */
    Client.prototype.projectsVideoPlayer_GetVideoPlayer = function (projectId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/projects/{projectId}/videoplayer";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processProjectsVideoPlayer_GetVideoPlayer(_response); });
        });
    };
    Client.prototype.processProjectsVideoPlayer_GetVideoPlayer = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Get List of Video Players
     * @param projectId The project Id the video player is associated with
     * @param includeEntitlement (optional) If true, the entitlement will be returned with each video player response object
     * @param includeAnalytics (optional) If true, play analytics will be returned with each video player response object
     * @return OK
     * @deprecated
     */
    Client.prototype.projectsVideoPlayer_GetVideoPlayers = function (projectId, includeEntitlement, includeAnalytics) {
        var _this = this;
        var url_ = this.baseUrl + "/api/projects/{projectId}/videoplayers?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (includeEntitlement !== undefined && includeEntitlement !== null)
            url_ += "includeEntitlement=" + encodeURIComponent("" + includeEntitlement) + "&";
        if (includeAnalytics !== undefined && includeAnalytics !== null)
            url_ += "includeAnalytics=" + encodeURIComponent("" + includeAnalytics) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processProjectsVideoPlayer_GetVideoPlayers(_response); });
        });
    };
    Client.prototype.processProjectsVideoPlayer_GetVideoPlayers = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * POST list of video players
     * @param request The request.
     * @return OK
     */
    Client.prototype.projectsVideoPlayer_PostVideoPlayers = function (request, projectId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/projects/{projectId}/videoplayers";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processProjectsVideoPlayer_PostVideoPlayers(_response); });
        });
    };
    Client.prototype.processProjectsVideoPlayer_PostVideoPlayers = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Get the oldest of Video Players
     * @param projectId The project Id the video player is associated with
     * @return OK
     */
    Client.prototype.projectsVideoPlayer_GetOldestVideoPlayer = function (projectId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/projects/{projectId}/videoplayers/oldest";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processProjectsVideoPlayer_GetOldestVideoPlayer(_response); });
        });
    };
    Client.prototype.processProjectsVideoPlayer_GetOldestVideoPlayer = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * PUT video player
     * @param request The request.
     * @return OK
     */
    Client.prototype.projectsVideoPlayer_PutVideoPlayer = function (videoPlayerId, request, projectId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/projects/{projectId}/videoplayers/{videoPlayerId}";
        if (videoPlayerId === undefined || videoPlayerId === null)
            throw new Error("The parameter 'videoPlayerId' must be defined.");
        url_ = url_.replace("{videoPlayerId}", encodeURIComponent("" + videoPlayerId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processProjectsVideoPlayer_PutVideoPlayer(_response); });
        });
    };
    Client.prototype.processProjectsVideoPlayer_PutVideoPlayer = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Delete video player
     * @return OK
     */
    Client.prototype.projectsVideoPlayer_DeleteVideoPlayer = function (videoPlayerId, projectId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/projects/{projectId}/videoplayers/{videoPlayerId}";
        if (videoPlayerId === undefined || videoPlayerId === null)
            throw new Error("The parameter 'videoPlayerId' must be defined.");
        url_ = url_.replace("{videoPlayerId}", encodeURIComponent("" + videoPlayerId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processProjectsVideoPlayer_DeleteVideoPlayer(_response); });
        });
    };
    Client.prototype.processProjectsVideoPlayer_DeleteVideoPlayer = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.purchaseEntitlements_GetUserPurchaseEntitlements = function (userId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{userId}/PurchaseEntitlements";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processPurchaseEntitlements_GetUserPurchaseEntitlements(_response); });
        });
    };
    Client.prototype.processPurchaseEntitlements_GetUserPurchaseEntitlements = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.purchaseEntitlements_PostUserPurchaseEntitlement = function (userId, invoiceId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{userId}/PurchaseEntitlements?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (invoiceId === undefined || invoiceId === null)
            throw new Error("The parameter 'invoiceId' must be defined and cannot be null.");
        else
            url_ += "invoiceId=" + encodeURIComponent("" + invoiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processPurchaseEntitlements_PostUserPurchaseEntitlement(_response); });
        });
    };
    Client.prototype.processPurchaseEntitlements_PostUserPurchaseEntitlement = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.reactBundles_GetReactBundles = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/ReactBundles";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processReactBundles_GetReactBundles(_response); });
        });
    };
    Client.prototype.processReactBundles_GetReactBundles = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.reactBundles_PostReactBundle = function (reactBundle) {
        var _this = this;
        var url_ = this.baseUrl + "/api/ReactBundles";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(reactBundle);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processReactBundles_PostReactBundle(_response); });
        });
    };
    Client.prototype.processReactBundles_PostReactBundle = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.reactBundles_GetReactBundle = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/ReactBundles/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processReactBundles_GetReactBundle(_response); });
        });
    };
    Client.prototype.processReactBundles_GetReactBundle = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return No Content
     */
    Client.prototype.reactBundles_PutReactBundle = function (id, reactBundle) {
        var _this = this;
        var url_ = this.baseUrl + "/api/ReactBundles/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(reactBundle);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processReactBundles_PutReactBundle(_response); });
        });
    };
    Client.prototype.processReactBundles_PutReactBundle = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 204) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.reactBundles_DeleteReactBundle = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/ReactBundles/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processReactBundles_DeleteReactBundle(_response); });
        });
    };
    Client.prototype.processReactBundles_DeleteReactBundle = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.resellerInventories_GetResellerInventories = function (resellerId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Resellers/{resellerId}/Inventories";
        if (resellerId === undefined || resellerId === null)
            throw new Error("The parameter 'resellerId' must be defined.");
        url_ = url_.replace("{resellerId}", encodeURIComponent("" + resellerId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processResellerInventories_GetResellerInventories(_response); });
        });
    };
    Client.prototype.processResellerInventories_GetResellerInventories = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param quantity (optional)
     * @param couponCode (optional)
     * @return OK
     */
    Client.prototype.resellerInventories_PostResellerInventory = function (resellerInventory, resellerId, quantity, couponCode) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Resellers/{resellerId}/Inventories?";
        if (resellerId === undefined || resellerId === null)
            throw new Error("The parameter 'resellerId' must be defined.");
        url_ = url_.replace("{resellerId}", encodeURIComponent("" + resellerId));
        if (quantity !== undefined && quantity !== null)
            url_ += "quantity=" + encodeURIComponent("" + quantity) + "&";
        if (couponCode !== undefined && couponCode !== null)
            url_ += "couponCode=" + encodeURIComponent("" + couponCode) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(resellerInventory);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processResellerInventories_PostResellerInventory(_response); });
        });
    };
    Client.prototype.processResellerInventories_PostResellerInventory = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.resellerInventories_GetResellerInventory = function (resellerId, inventoryId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Resellers/{resellerId}/Inventories/{inventoryId}";
        if (resellerId === undefined || resellerId === null)
            throw new Error("The parameter 'resellerId' must be defined.");
        url_ = url_.replace("{resellerId}", encodeURIComponent("" + resellerId));
        if (inventoryId === undefined || inventoryId === null)
            throw new Error("The parameter 'inventoryId' must be defined.");
        url_ = url_.replace("{inventoryId}", encodeURIComponent("" + inventoryId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processResellerInventories_GetResellerInventory(_response); });
        });
    };
    Client.prototype.processResellerInventories_GetResellerInventory = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param quantityToAdd (optional)
     * @return No Content
     */
    Client.prototype.resellerInventories_PutResellerInventory = function (resellerId, inventoryId, resellerInventory, quantityToAdd) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Resellers/{resellerId}/Inventories/{inventoryId}?";
        if (resellerId === undefined || resellerId === null)
            throw new Error("The parameter 'resellerId' must be defined.");
        url_ = url_.replace("{resellerId}", encodeURIComponent("" + resellerId));
        if (inventoryId === undefined || inventoryId === null)
            throw new Error("The parameter 'inventoryId' must be defined.");
        url_ = url_.replace("{inventoryId}", encodeURIComponent("" + inventoryId));
        if (quantityToAdd !== undefined && quantityToAdd !== null)
            url_ += "quantityToAdd=" + encodeURIComponent("" + quantityToAdd) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(resellerInventory);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processResellerInventories_PutResellerInventory(_response); });
        });
    };
    Client.prototype.processResellerInventories_PutResellerInventory = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 204) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.resellerInventories_DeleteResellerInventory = function (inventoryId, resellerId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Resellers/{resellerId}/Inventories/{inventoryId}";
        if (inventoryId === undefined || inventoryId === null)
            throw new Error("The parameter 'inventoryId' must be defined.");
        url_ = url_.replace("{inventoryId}", encodeURIComponent("" + inventoryId));
        if (resellerId === undefined || resellerId === null)
            throw new Error("The parameter 'resellerId' must be defined.");
        url_ = url_.replace("{resellerId}", encodeURIComponent("" + resellerId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processResellerInventories_DeleteResellerInventory(_response); });
        });
    };
    Client.prototype.processResellerInventories_DeleteResellerInventory = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.resellerInventoryItems_GetResellerInventoryItems = function (resellerId, inventoryId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Resellers/{resellerId}/Inventories/{inventoryId}/Items";
        if (resellerId === undefined || resellerId === null)
            throw new Error("The parameter 'resellerId' must be defined.");
        url_ = url_.replace("{resellerId}", encodeURIComponent("" + resellerId));
        if (inventoryId === undefined || inventoryId === null)
            throw new Error("The parameter 'inventoryId' must be defined.");
        url_ = url_.replace("{inventoryId}", encodeURIComponent("" + inventoryId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processResellerInventoryItems_GetResellerInventoryItems(_response); });
        });
    };
    Client.prototype.processResellerInventoryItems_GetResellerInventoryItems = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.resellerInventoryItems_PostResellerInventoryItem = function (inventoryId, resellerId, resellerInventoryItem) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Resellers/{resellerId}/Inventories/{inventoryId}/Items";
        if (inventoryId === undefined || inventoryId === null)
            throw new Error("The parameter 'inventoryId' must be defined.");
        url_ = url_.replace("{inventoryId}", encodeURIComponent("" + inventoryId));
        if (resellerId === undefined || resellerId === null)
            throw new Error("The parameter 'resellerId' must be defined.");
        url_ = url_.replace("{resellerId}", encodeURIComponent("" + resellerId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(resellerInventoryItem);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processResellerInventoryItems_PostResellerInventoryItem(_response); });
        });
    };
    Client.prototype.processResellerInventoryItems_PostResellerInventoryItem = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return No Content
     */
    Client.prototype.resellerInventoryItems_PutResellerInventoryItem = function (inventoryItemId, resellerInventoryItem, resellerId, inventoryId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Resellers/{resellerId}/Inventories/{inventoryId}/Items/{inventoryItemId}";
        if (inventoryItemId === undefined || inventoryItemId === null)
            throw new Error("The parameter 'inventoryItemId' must be defined.");
        url_ = url_.replace("{inventoryItemId}", encodeURIComponent("" + inventoryItemId));
        if (resellerId === undefined || resellerId === null)
            throw new Error("The parameter 'resellerId' must be defined.");
        url_ = url_.replace("{resellerId}", encodeURIComponent("" + resellerId));
        if (inventoryId === undefined || inventoryId === null)
            throw new Error("The parameter 'inventoryId' must be defined.");
        url_ = url_.replace("{inventoryId}", encodeURIComponent("" + inventoryId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(resellerInventoryItem);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processResellerInventoryItems_PutResellerInventoryItem(_response); });
        });
    };
    Client.prototype.processResellerInventoryItems_PutResellerInventoryItem = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 204) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.resellerInventoryItems_DeleteResellerInventoryItem = function (inventoryItemId, resellerId, inventoryId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Resellers/{resellerId}/Inventories/{inventoryId}/Items/{inventoryItemId}";
        if (inventoryItemId === undefined || inventoryItemId === null)
            throw new Error("The parameter 'inventoryItemId' must be defined.");
        url_ = url_.replace("{inventoryItemId}", encodeURIComponent("" + inventoryItemId));
        if (resellerId === undefined || resellerId === null)
            throw new Error("The parameter 'resellerId' must be defined.");
        url_ = url_.replace("{resellerId}", encodeURIComponent("" + resellerId));
        if (inventoryId === undefined || inventoryId === null)
            throw new Error("The parameter 'inventoryId' must be defined.");
        url_ = url_.replace("{inventoryId}", encodeURIComponent("" + inventoryId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processResellerInventoryItems_DeleteResellerInventoryItem(_response); });
        });
    };
    Client.prototype.processResellerInventoryItems_DeleteResellerInventoryItem = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.resellerInventoryItems_GetResellerInventoryItem = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/ResellerInventoryItems/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processResellerInventoryItems_GetResellerInventoryItem(_response); });
        });
    };
    Client.prototype.processResellerInventoryItems_GetResellerInventoryItem = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.resellers_GetResellers = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Resellers";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processResellers_GetResellers(_response); });
        });
    };
    Client.prototype.processResellers_GetResellers = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.resellers_PostReseller = function (reseller) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Resellers";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(reseller);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processResellers_PostReseller(_response); });
        });
    };
    Client.prototype.processResellers_PostReseller = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.resellers_GetReseller = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Resellers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processResellers_GetReseller(_response); });
        });
    };
    Client.prototype.processResellers_GetReseller = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return No Content
     */
    Client.prototype.resellers_PutReseller = function (id, reseller) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Resellers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(reseller);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processResellers_PutReseller(_response); });
        });
    };
    Client.prototype.processResellers_PutReseller = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 204) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.resellers_DeleteReseller = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Resellers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processResellers_DeleteReseller(_response); });
        });
    };
    Client.prototype.processResellers_DeleteReseller = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.resellerUser_GetResellerUsers = function (resellerId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Resellers/{resellerId}/Users";
        if (resellerId === undefined || resellerId === null)
            throw new Error("The parameter 'resellerId' must be defined.");
        url_ = url_.replace("{resellerId}", encodeURIComponent("" + resellerId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processResellerUser_GetResellerUsers(_response); });
        });
    };
    Client.prototype.processResellerUser_GetResellerUsers = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.resellerUser_PostResellerAdmin = function (newResellerUser, resellerId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Resellers/{resellerId}/Users";
        if (resellerId === undefined || resellerId === null)
            throw new Error("The parameter 'resellerId' must be defined.");
        url_ = url_.replace("{resellerId}", encodeURIComponent("" + resellerId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(newResellerUser);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processResellerUser_PostResellerAdmin(_response); });
        });
    };
    Client.prototype.processResellerUser_PostResellerAdmin = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.resellerUser_DeleteOrganizationUser = function (resellerId, userId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Resellers/{resellerId}/Users/{userId}";
        if (resellerId === undefined || resellerId === null)
            throw new Error("The parameter 'resellerId' must be defined.");
        url_ = url_.replace("{resellerId}", encodeURIComponent("" + resellerId));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processResellerUser_DeleteOrganizationUser(_response); });
        });
    };
    Client.prototype.processResellerUser_DeleteOrganizationUser = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Gets the revenue for user asynchronously.
     * @param request The request.
     * @return OK
     */
    Client.prototype.revenueAnalytics_GetRevenue = function (request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Revenue/Analytics/User";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processRevenueAnalytics_GetRevenue(_response); });
        });
    };
    Client.prototype.processRevenueAnalytics_GetRevenue = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.roomService_Provision = function (request) {
        var _this = this;
        var url_ = this.baseUrl + "/RoomService/Provision";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processRoomService_Provision(_response); });
        });
    };
    Client.prototype.processRoomService_Provision = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.settings_GetSettings = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Settings/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processSettings_GetSettings(_response); });
        });
    };
    Client.prototype.processSettings_GetSettings = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.shopify_GetShopifyAnalyticsByShopId = function (shopId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Shopify/{shopId}/Analytics";
        if (shopId === undefined || shopId === null)
            throw new Error("The parameter 'shopId' must be defined.");
        url_ = url_.replace("{shopId}", encodeURIComponent("" + shopId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processShopify_GetShopifyAnalyticsByShopId(_response); });
        });
    };
    Client.prototype.processShopify_GetShopifyAnalyticsByShopId = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param start (optional)
     * @param end (optional)
     * @return OK
     */
    Client.prototype.shopify_GetShopifyBroadcastAnalyticsByShopId = function (shopId, start, end) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Shopify/{shopId}/Analytics/Broadcasts?";
        if (shopId === undefined || shopId === null)
            throw new Error("The parameter 'shopId' must be defined.");
        url_ = url_.replace("{shopId}", encodeURIComponent("" + shopId));
        if (start !== undefined && start !== null)
            url_ += "start=" + encodeURIComponent("" + start) + "&";
        if (end !== undefined && end !== null)
            url_ += "end=" + encodeURIComponent("" + end) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processShopify_GetShopifyBroadcastAnalyticsByShopId(_response); });
        });
    };
    Client.prototype.processShopify_GetShopifyBroadcastAnalyticsByShopId = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.shopify_GetShopifyAnalyticsByBroadcastId = function (shopId, broadcastId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Shopify/{shopId}/Analytics/Broadcasts/{broadcastId}";
        if (shopId === undefined || shopId === null)
            throw new Error("The parameter 'shopId' must be defined.");
        url_ = url_.replace("{shopId}", encodeURIComponent("" + shopId));
        if (broadcastId === undefined || broadcastId === null)
            throw new Error("The parameter 'broadcastId' must be defined.");
        url_ = url_.replace("{broadcastId}", encodeURIComponent("" + broadcastId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processShopify_GetShopifyAnalyticsByBroadcastId(_response); });
        });
    };
    Client.prototype.processShopify_GetShopifyAnalyticsByBroadcastId = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.shopify_RedirectForAuthorization = function (hmac, shop, timestamp) {
        var _this = this;
        var url_ = this.baseUrl + "/api/ShopRedirects/RedirectForAuthorization?";
        if (hmac === undefined || hmac === null)
            throw new Error("The parameter 'hmac' must be defined and cannot be null.");
        else
            url_ += "hmac=" + encodeURIComponent("" + hmac) + "&";
        if (shop === undefined || shop === null)
            throw new Error("The parameter 'shop' must be defined and cannot be null.");
        else
            url_ += "shop=" + encodeURIComponent("" + shop) + "&";
        if (timestamp === undefined || timestamp === null)
            throw new Error("The parameter 'timestamp' must be defined and cannot be null.");
        else
            url_ += "timestamp=" + encodeURIComponent("" + timestamp) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processShopify_RedirectForAuthorization(_response); });
        });
    };
    Client.prototype.processShopify_RedirectForAuthorization = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.shopify_RedirectAfterAuthorization = function (code, shop, state) {
        var _this = this;
        var url_ = this.baseUrl + "/api/ShopRedirects/RedirectAfterAuthorization?";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined and cannot be null.");
        else
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (shop === undefined || shop === null)
            throw new Error("The parameter 'shop' must be defined and cannot be null.");
        else
            url_ += "shop=" + encodeURIComponent("" + shop) + "&";
        if (state === undefined || state === null)
            throw new Error("The parameter 'state' must be defined and cannot be null.");
        else
            url_ += "state=" + encodeURIComponent("" + state) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processShopify_RedirectAfterAuthorization(_response); });
        });
    };
    Client.prototype.processShopify_RedirectAfterAuthorization = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.shopify_GetConnectedShopUser = function (shop) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Providers/Shopify/Connect?";
        if (shop === undefined || shop === null)
            throw new Error("The parameter 'shop' must be defined and cannot be null.");
        else
            url_ += "shop=" + encodeURIComponent("" + shop) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processShopify_GetConnectedShopUser(_response); });
        });
    };
    Client.prototype.processShopify_GetConnectedShopUser = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.shopify_PostConnectShopToUser = function (shop) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Providers/Shopify/Connect?";
        if (shop === undefined || shop === null)
            throw new Error("The parameter 'shop' must be defined and cannot be null.");
        else
            url_ += "shop=" + encodeURIComponent("" + shop) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processShopify_PostConnectShopToUser(_response); });
        });
    };
    Client.prototype.processShopify_PostConnectShopToUser = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.shopify_DeleteConnectedShopUser = function (shop) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Providers/Shopify/Connect?";
        if (shop === undefined || shop === null)
            throw new Error("The parameter 'shop' must be defined and cannot be null.");
        else
            url_ += "shop=" + encodeURIComponent("" + shop) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processShopify_DeleteConnectedShopUser(_response); });
        });
    };
    Client.prototype.processShopify_DeleteConnectedShopUser = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.shopify_GetCredentials = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Providers/Shopify/Credentials";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processShopify_GetCredentials(_response); });
        });
    };
    Client.prototype.processShopify_GetCredentials = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.shopify_PostCredentials = function (externalAuth) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Providers/Shopify/Credentials";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(externalAuth);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processShopify_PostCredentials(_response); });
        });
    };
    Client.prototype.processShopify_PostCredentials = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.shopify_DeleteCredentials = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Providers/Shopify/Credentials";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processShopify_DeleteCredentials(_response); });
        });
    };
    Client.prototype.processShopify_DeleteCredentials = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param userId (optional)
     * @return OK
     */
    Client.prototype.shopify_GetStorefrontAccessToken = function (shopId, userId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Providers/Shopify/StorefrontAccessToken?";
        if (shopId === undefined || shopId === null)
            throw new Error("The parameter 'shopId' must be defined and cannot be null.");
        else
            url_ += "shopId=" + encodeURIComponent("" + shopId) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processShopify_GetStorefrontAccessToken(_response); });
        });
    };
    Client.prototype.processShopify_GetStorefrontAccessToken = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.shopify_GetStorefrontAccessTokenByShop = function (shopId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Providers/Shopify/StorefrontAccessTokenByShop?";
        if (shopId === undefined || shopId === null)
            throw new Error("The parameter 'shopId' must be defined and cannot be null.");
        else
            url_ += "shopId=" + encodeURIComponent("" + shopId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processShopify_GetStorefrontAccessTokenByShop(_response); });
        });
    };
    Client.prototype.processShopify_GetStorefrontAccessTokenByShop = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.shopify_PersistBroadcastProduct = function (product) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Providers/Shopify/PersistBroadcastProduct";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(product);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processShopify_PersistBroadcastProduct(_response); });
        });
    };
    Client.prototype.processShopify_PersistBroadcastProduct = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.shopify_GetShopifyProducts = function (broadcastId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Providers/Shopify/GetShopifyProducts?";
        if (broadcastId === undefined || broadcastId === null)
            throw new Error("The parameter 'broadcastId' must be defined and cannot be null.");
        else
            url_ += "broadcastId=" + encodeURIComponent("" + broadcastId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processShopify_GetShopifyProducts(_response); });
        });
    };
    Client.prototype.processShopify_GetShopifyProducts = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param shopId (optional)
     * @return OK
     */
    Client.prototype.shopify_PostWebHook = function (data, shopId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Providers/Shopify/WebHook?";
        if (shopId !== undefined && shopId !== null)
            url_ += "shopId=" + encodeURIComponent("" + shopId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(data);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processShopify_PostWebHook(_response); });
        });
    };
    Client.prototype.processShopify_PostWebHook = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.shopify_QueryShopifyAdminGraphQL = function (query) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Providers/Shopify/Proxy/Admin/GraphQL";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(query);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processShopify_QueryShopifyAdminGraphQL(_response); });
        });
    };
    Client.prototype.processShopify_QueryShopifyAdminGraphQL = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.shopify_QueryShopifyAdmin = function (url) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Providers/Shopify/Proxy/Admin/{url}";
        if (url === undefined || url === null)
            throw new Error("The parameter 'url' must be defined.");
        url_ = url_.replace("{url}", encodeURIComponent("" + url));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processShopify_QueryShopifyAdmin(_response); });
        });
    };
    Client.prototype.processShopify_QueryShopifyAdmin = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.shopify_QueryShopifyStorefront = function (query) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Providers/Shopify/Proxy/Storefront";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(query);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processShopify_QueryShopifyStorefront(_response); });
        });
    };
    Client.prototype.processShopify_QueryShopifyStorefront = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.shopify_GetCollectionsCountProxy = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Providers/Shopify/Proxy/Collections/Count";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processShopify_GetCollectionsCountProxy(_response); });
        });
    };
    Client.prototype.processShopify_GetCollectionsCountProxy = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Returns a list of claimed coupon codes for the connected user of provided shop.
     * @param shopId The shopId for the user you wish to list claimed coupon codes for.
     * @return OK
     */
    Client.prototype.shopifyCoupons_GetClaimedCouponCodesByShop = function (shopId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Shopify/{shopId}/Coupons";
        if (shopId === undefined || shopId === null)
            throw new Error("The parameter 'shopId' must be defined.");
        url_ = url_.replace("{shopId}", encodeURIComponent("" + shopId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processShopifyCoupons_GetClaimedCouponCodesByShop(_response); });
        });
    };
    Client.prototype.processShopifyCoupons_GetClaimedCouponCodesByShop = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Claims a coupon code given a shopId and coupon code
     * @param shopId The shopId claiming the coupon
     * @param couponCode the coupon string
     * @return OK
     */
    Client.prototype.shopifyCoupons_ClaimCouponCode = function (shopId, couponCode) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Shopify/{shopId}/Coupons/{couponCode}/Claim";
        if (shopId === undefined || shopId === null)
            throw new Error("The parameter 'shopId' must be defined.");
        url_ = url_.replace("{shopId}", encodeURIComponent("" + shopId));
        if (couponCode === undefined || couponCode === null)
            throw new Error("The parameter 'couponCode' must be defined.");
        url_ = url_.replace("{couponCode}", encodeURIComponent("" + couponCode));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processShopifyCoupons_ClaimCouponCode(_response); });
        });
    };
    Client.prototype.processShopifyCoupons_ClaimCouponCode = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * If requested ResellerInventoryItem is a duplicate of an unlimited coupon, deletes ResellerInventoryItem, otherwise it
    clears the user that claimed a given ResellerInventoryItem, resets the status to "Availible - 0" and updates "UpdatedAt" to current UTC timestamp.
     * @param shopId The shopId for the shop you wish to release claimed coupon code for.
     * @param resellerInventoryItemId The resellerInventoryItemId for the coupon you wish to release.
     * @return OK
     */
    Client.prototype.shopifyCoupons_ReleaseCouponCode = function (shopId, resellerInventoryItemId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Shopify/{shopId}/Coupons/{resellerInventoryItemId}/Release";
        if (shopId === undefined || shopId === null)
            throw new Error("The parameter 'shopId' must be defined.");
        url_ = url_.replace("{shopId}", encodeURIComponent("" + shopId));
        if (resellerInventoryItemId === undefined || resellerInventoryItemId === null)
            throw new Error("The parameter 'resellerInventoryItemId' must be defined.");
        url_ = url_.replace("{resellerInventoryItemId}", encodeURIComponent("" + resellerInventoryItemId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processShopifyCoupons_ReleaseCouponCode(_response); });
        });
    };
    Client.prototype.processShopifyCoupons_ReleaseCouponCode = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param locale (optional)
     * @return OK
     */
    Client.prototype.shopifyPrices_GetShopifyPrices = function (shopId, locale) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Shopify/{shopId}/Prices?";
        if (shopId === undefined || shopId === null)
            throw new Error("The parameter 'shopId' must be defined.");
        url_ = url_.replace("{shopId}", encodeURIComponent("" + shopId));
        if (locale !== undefined && locale !== null)
            url_ += "locale=" + encodeURIComponent("" + locale) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processShopifyPrices_GetShopifyPrices(_response); });
        });
    };
    Client.prototype.processShopifyPrices_GetShopifyPrices = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param locale (optional)
     * @return OK
     */
    Client.prototype.shopifyPrices_GetShopifyPrice = function (shopId, priceId, locale) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Shopify/{shopId}/Prices/{priceId}?";
        if (shopId === undefined || shopId === null)
            throw new Error("The parameter 'shopId' must be defined.");
        url_ = url_.replace("{shopId}", encodeURIComponent("" + shopId));
        if (priceId === undefined || priceId === null)
            throw new Error("The parameter 'priceId' must be defined.");
        url_ = url_.replace("{priceId}", encodeURIComponent("" + priceId));
        if (locale !== undefined && locale !== null)
            url_ += "locale=" + encodeURIComponent("" + locale) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processShopifyPrices_GetShopifyPrice(_response); });
        });
    };
    Client.prototype.processShopifyPrices_GetShopifyPrice = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param locale (optional)
     * @return OK
     */
    Client.prototype.shopifyProducts_GetShopifyProducts = function (shopId, locale) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Shopify/{shopId}/Products?";
        if (shopId === undefined || shopId === null)
            throw new Error("The parameter 'shopId' must be defined.");
        url_ = url_.replace("{shopId}", encodeURIComponent("" + shopId));
        if (locale !== undefined && locale !== null)
            url_ += "locale=" + encodeURIComponent("" + locale) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processShopifyProducts_GetShopifyProducts(_response); });
        });
    };
    Client.prototype.processShopifyProducts_GetShopifyProducts = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.shopifyStores_GetStoreInfoById = function (shopId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Shopify/Stores/{shopId}/Info";
        if (shopId === undefined || shopId === null)
            throw new Error("The parameter 'shopId' must be defined.");
        url_ = url_.replace("{shopId}", encodeURIComponent("" + shopId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processShopifyStores_GetStoreInfoById(_response); });
        });
    };
    Client.prototype.processShopifyStores_GetStoreInfoById = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.shopifySubscriptions_GetShopifySubscriptions = function (shopId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Shopify/{shopId}/Subscriptions";
        if (shopId === undefined || shopId === null)
            throw new Error("The parameter 'shopId' must be defined.");
        url_ = url_.replace("{shopId}", encodeURIComponent("" + shopId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processShopifySubscriptions_GetShopifySubscriptions(_response); });
        });
    };
    Client.prototype.processShopifySubscriptions_GetShopifySubscriptions = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.shopifySubscriptions_PutShopifySubscription = function (shopId, subscriptionId, isActive) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Shopify/{shopId}/Subscriptions?";
        if (shopId === undefined || shopId === null)
            throw new Error("The parameter 'shopId' must be defined.");
        url_ = url_.replace("{shopId}", encodeURIComponent("" + shopId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined and cannot be null.");
        else
            url_ += "subscriptionId=" + encodeURIComponent("" + subscriptionId) + "&";
        if (isActive === undefined || isActive === null)
            throw new Error("The parameter 'isActive' must be defined and cannot be null.");
        else
            url_ += "isActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processShopifySubscriptions_PutShopifySubscription(_response); });
        });
    };
    Client.prototype.processShopifySubscriptions_PutShopifySubscription = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.shopifySubscriptions_PostShopifySubscription = function (shopId, sub) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Shopify/{shopId}/Subscriptions";
        if (shopId === undefined || shopId === null)
            throw new Error("The parameter 'shopId' must be defined.");
        url_ = url_.replace("{shopId}", encodeURIComponent("" + shopId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(sub);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processShopifySubscriptions_PostShopifySubscription(_response); });
        });
    };
    Client.prototype.processShopifySubscriptions_PostShopifySubscription = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.shopifySubscriptions_DeleteShopifySubscription = function (shopId, subscriptionId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Shopify/{shopId}/Subscriptions?";
        if (shopId === undefined || shopId === null)
            throw new Error("The parameter 'shopId' must be defined.");
        url_ = url_.replace("{shopId}", encodeURIComponent("" + shopId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined and cannot be null.");
        else
            url_ += "subscriptionId=" + encodeURIComponent("" + subscriptionId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processShopifySubscriptions_DeleteShopifySubscription(_response); });
        });
    };
    Client.prototype.processShopifySubscriptions_DeleteShopifySubscription = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.simulcast_GetSimulcastSwitcherStreamSetting = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/Simulcast/SwitcherStreamSettings";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processSimulcast_GetSimulcastSwitcherStreamSetting(_response); });
        });
    };
    Client.prototype.processSimulcast_GetSimulcastSwitcherStreamSetting = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.simulcast_PutSimulcastSwitcherStreamSetting = function (switcherStreamSetting) {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/Simulcast/SwitcherStreamSettings";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(switcherStreamSetting);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processSimulcast_PutSimulcastSwitcherStreamSetting(_response); });
        });
    };
    Client.prototype.processSimulcast_PutSimulcastSwitcherStreamSetting = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.streamDestinations_GetStreamDestinations = function (userId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{userId}/StreamDestinations";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processStreamDestinations_GetStreamDestinations(_response); });
        });
    };
    Client.prototype.processStreamDestinations_GetStreamDestinations = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.streamDestinations_PostStreamDestination = function (streamDestination, userId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{userId}/StreamDestinations";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(streamDestination);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processStreamDestinations_PostStreamDestination(_response); });
        });
    };
    Client.prototype.processStreamDestinations_PostStreamDestination = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.streamDestinations_GetStreamDestination = function (userId, id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{userId}/StreamDestinations/{id}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processStreamDestinations_GetStreamDestination(_response); });
        });
    };
    Client.prototype.processStreamDestinations_GetStreamDestination = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return No Content
     */
    Client.prototype.streamDestinations_PutStreamDestination = function (id, streamDestination, userId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{userId}/StreamDestinations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(streamDestination);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processStreamDestinations_PutStreamDestination(_response); });
        });
    };
    Client.prototype.processStreamDestinations_PutStreamDestination = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 204) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.streamDestinations_DeleteStreamDestination = function (id, userId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{userId}/StreamDestinations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processStreamDestinations_DeleteStreamDestination(_response); });
        });
    };
    Client.prototype.processStreamDestinations_DeleteStreamDestination = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.streamingProviders_GetStreamingProvider = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processStreamingProviders_GetStreamingProvider(_response); });
        });
    };
    Client.prototype.processStreamingProviders_GetStreamingProvider = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.streamingProviders_GetSwitchboardStreamingProvider = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/switchboard";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processStreamingProviders_GetSwitchboardStreamingProvider(_response); });
        });
    };
    Client.prototype.processStreamingProviders_GetSwitchboardStreamingProvider = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.streamingProviders_GetSimulcastStreamingProvider = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/simulcast";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processStreamingProviders_GetSimulcastStreamingProvider(_response); });
        });
    };
    Client.prototype.processStreamingProviders_GetSimulcastStreamingProvider = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.streamingProviders_GetVideoPlayerStreamingProvider = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/switcherplayer";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processStreamingProviders_GetVideoPlayerStreamingProvider(_response); });
        });
    };
    Client.prototype.processStreamingProviders_GetVideoPlayerStreamingProvider = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.streamingProviders_GetFacebookStreamingProvider = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/facebook";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processStreamingProviders_GetFacebookStreamingProvider(_response); });
        });
    };
    Client.prototype.processStreamingProviders_GetFacebookStreamingProvider = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.streamingProviders_GetYouTubeStreamingProvider = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/youtube";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processStreamingProviders_GetYouTubeStreamingProvider(_response); });
        });
    };
    Client.prototype.processStreamingProviders_GetYouTubeStreamingProvider = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.streamingProviders_GetLinkedInStreamingProvider = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/linkedin";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processStreamingProviders_GetLinkedInStreamingProvider(_response); });
        });
    };
    Client.prototype.processStreamingProviders_GetLinkedInStreamingProvider = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.streamingProviders_GetTwitchStreamingProvider = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/twitch";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processStreamingProviders_GetTwitchStreamingProvider(_response); });
        });
    };
    Client.prototype.processStreamingProviders_GetTwitchStreamingProvider = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param browse (optional)
     * @return OK
     */
    Client.prototype.streamingProviders_GetStreamingProviders = function (browse) {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders?";
        if (browse !== undefined && browse !== null)
            url_ += "browse=" + encodeURIComponent("" + browse) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processStreamingProviders_GetStreamingProviders(_response); });
        });
    };
    Client.prototype.processStreamingProviders_GetStreamingProviders = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.streamSpot_GetSwitcherStudioSetting = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/StreamSpot/SwitcherStreamSettings";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processStreamSpot_GetSwitcherStudioSetting(_response); });
        });
    };
    Client.prototype.processStreamSpot_GetSwitcherStudioSetting = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.streamSpot_PostLinkAccount = function (basicLogin) {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/StreamSpot/LinkAccount";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(basicLogin);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processStreamSpot_PostLinkAccount(_response); });
        });
    };
    Client.prototype.processStreamSpot_PostLinkAccount = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Post web hook.
     * @param myStripeEvent The my stripe event.
     * @return OK
     */
    Client.prototype.stripe_PostWebHook = function (myStripeEvent) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Stripe/WebHook";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(myStripeEvent);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processStripe_PostWebHook(_response); });
        });
    };
    Client.prototype.processStripe_PostWebHook = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.stripe_CreateSubscription = function (subscription) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Stripe/CreateSubscription";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(subscription);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processStripe_CreateSubscription(_response); });
        });
    };
    Client.prototype.processStripe_CreateSubscription = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.stripe_CreateCustomer = function (email) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Stripe/CreateCustomer?";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined and cannot be null.");
        else
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processStripe_CreateCustomer(_response); });
        });
    };
    Client.prototype.processStripe_CreateCustomer = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.stripe_GetCustomer = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Stripe/Customer";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processStripe_GetCustomer(_response); });
        });
    };
    Client.prototype.processStripe_GetCustomer = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param cancelAtPeriodEnd (optional)
     * @return OK
     */
    Client.prototype.stripe_DeleteSubscription = function (subId, cancelAtPeriodEnd) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Stripe/Subscriptions/{SubId}?";
        if (subId === undefined || subId === null)
            throw new Error("The parameter 'subId' must be defined.");
        url_ = url_.replace("{SubId}", encodeURIComponent("" + subId));
        if (cancelAtPeriodEnd !== undefined && cancelAtPeriodEnd !== null)
            url_ += "cancelAtPeriodEnd=" + encodeURIComponent("" + cancelAtPeriodEnd) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processStripe_DeleteSubscription(_response); });
        });
    };
    Client.prototype.processStripe_DeleteSubscription = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.stripe_RenewSubscription = function (subId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Stripe/Subscriptions/{SubId}/Renew";
        if (subId === undefined || subId === null)
            throw new Error("The parameter 'subId' must be defined.");
        url_ = url_.replace("{SubId}", encodeURIComponent("" + subId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processStripe_RenewSubscription(_response); });
        });
    };
    Client.prototype.processStripe_RenewSubscription = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.stripe_changeSubscription = function (subId, subscriptionUpdate) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Stripe/Subscriptions/{SubId}/Change";
        if (subId === undefined || subId === null)
            throw new Error("The parameter 'subId' must be defined.");
        url_ = url_.replace("{SubId}", encodeURIComponent("" + subId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(subscriptionUpdate);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processStripe_changeSubscription(_response); });
        });
    };
    Client.prototype.processStripe_changeSubscription = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.stripe_AddSubscription = function (subscription) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Stripe/Subscriptions";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(subscription);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processStripe_AddSubscription(_response); });
        });
    };
    Client.prototype.processStripe_AddSubscription = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.stripe_DeleteCard = function (cardId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Stripe/Cards/{CardId}";
        if (cardId === undefined || cardId === null)
            throw new Error("The parameter 'cardId' must be defined.");
        url_ = url_.replace("{CardId}", encodeURIComponent("" + cardId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processStripe_DeleteCard(_response); });
        });
    };
    Client.prototype.processStripe_DeleteCard = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.stripe_PostCard = function (stripeToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Stripe/Cards/{StripeToken}";
        if (stripeToken === undefined || stripeToken === null)
            throw new Error("The parameter 'stripeToken' must be defined.");
        url_ = url_.replace("{StripeToken}", encodeURIComponent("" + stripeToken));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processStripe_PostCard(_response); });
        });
    };
    Client.prototype.processStripe_PostCard = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.stripe_SetPrimaryCard = function (cardId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Stripe/Cards/{CardId}/SetPrimary";
        if (cardId === undefined || cardId === null)
            throw new Error("The parameter 'cardId' must be defined.");
        url_ = url_.replace("{CardId}", encodeURIComponent("" + cardId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processStripe_SetPrimaryCard(_response); });
        });
    };
    Client.prototype.processStripe_SetPrimaryCard = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param startDate (optional)
     * @param endDate (optional)
     * @return OK
     */
    Client.prototype.stripe_GetInvoices = function (startDate, endDate) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Stripe/Invoices?";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent("" + endDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processStripe_GetInvoices(_response); });
        });
    };
    Client.prototype.processStripe_GetInvoices = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param quantity (optional)
     * @param subscriptionId (optional)
     * @param resellerInventoryItemId (optional)
     * @param prorationDate (optional)
     * @return OK
     */
    Client.prototype.stripe_GetProration = function (newStripePlan, quantity, subscriptionId, resellerInventoryItemId, prorationDate) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Stripe/Prorate?";
        if (newStripePlan === undefined || newStripePlan === null)
            throw new Error("The parameter 'newStripePlan' must be defined and cannot be null.");
        else
            url_ += "newStripePlan=" + encodeURIComponent("" + newStripePlan) + "&";
        if (quantity !== undefined && quantity !== null)
            url_ += "quantity=" + encodeURIComponent("" + quantity) + "&";
        if (subscriptionId !== undefined && subscriptionId !== null)
            url_ += "subscriptionId=" + encodeURIComponent("" + subscriptionId) + "&";
        if (resellerInventoryItemId !== undefined && resellerInventoryItemId !== null)
            url_ += "resellerInventoryItemId=" + encodeURIComponent("" + resellerInventoryItemId) + "&";
        if (prorationDate !== undefined && prorationDate !== null)
            url_ += "prorationDate=" + encodeURIComponent("" + prorationDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processStripe_GetProration(_response); });
        });
    };
    Client.prototype.processStripe_GetProration = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.stripe_GetCoupons = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Stripe/Coupons";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processStripe_GetCoupons(_response); });
        });
    };
    Client.prototype.processStripe_GetCoupons = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Gets the stripe account.
     * @param userId The user id.
     * @param expandDetails (optional)
     * @return OK
     */
    Client.prototype.stripeConnect_GetStripeAccount = function (userId, expandDetails) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{userId}/StripeAccount?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (expandDetails !== undefined && expandDetails !== null)
            url_ += "expandDetails=" + encodeURIComponent("" + expandDetails) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processStripeConnect_GetStripeAccount(_response); });
        });
    };
    Client.prototype.processStripeConnect_GetStripeAccount = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     * @deprecated
     */
    Client.prototype.stripeConnect_GetAccountLink = function (userId, redirectUrl) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{userId}/AccountLink?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (redirectUrl === undefined || redirectUrl === null)
            throw new Error("The parameter 'redirectUrl' must be defined and cannot be null.");
        else
            url_ += "redirectUrl=" + encodeURIComponent("" + redirectUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processStripeConnect_GetAccountLink(_response); });
        });
    };
    Client.prototype.processStripeConnect_GetAccountLink = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     * @deprecated
     */
    Client.prototype.stripeConnect_CreateLoginLink = function (userId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{userId}/LoginLink";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processStripeConnect_CreateLoginLink(_response); });
        });
    };
    Client.prototype.processStripeConnect_CreateLoginLink = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Creates and returns a setup intent.
     * @return OK
     */
    Client.prototype.stripeIntents_GetSetupIntent = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/StripeIntents/SetupIntent";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processStripeIntents_GetSetupIntent(_response); });
        });
    };
    Client.prototype.processStripeIntents_GetSetupIntent = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Creates and returns a payment intent.
     * @return OK
     */
    Client.prototype.stripeIntents_GetPaymentIntent = function (request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/StripeIntents/PaymentIntent";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processStripeIntents_GetPaymentIntent(_response); });
        });
    };
    Client.prototype.processStripeIntents_GetPaymentIntent = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.stripeInvoices_PostInvoice = function (userId, req) {
        var _this = this;
        var url_ = this.baseUrl + "/api/User/{userId}/Invoices";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(req);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processStripeInvoices_PostInvoice(_response); });
        });
    };
    Client.prototype.processStripeInvoices_PostInvoice = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.stripeInvoices_FinalizeInvoice = function (userId, invoiceId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/User/{userId}/Invoices/{invoiceId}/FinalizeInvoice";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (invoiceId === undefined || invoiceId === null)
            throw new Error("The parameter 'invoiceId' must be defined.");
        url_ = url_.replace("{invoiceId}", encodeURIComponent("" + invoiceId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processStripeInvoices_FinalizeInvoice(_response); });
        });
    };
    Client.prototype.processStripeInvoices_FinalizeInvoice = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * PostFinalizeInvoice is used specifically to finalize and complete one-time purchases on the legacy dashboard.
    It should be removed once we have completed our transition to the new dashboard (RAD).
     * @param userId The user id.
     * @param invoiceId The invoice id.
     * @return OK
     */
    Client.prototype.stripeInvoices_PostFinalizeInvoice = function (userId, invoiceId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/User/{userId}/Invoices/{invoiceId}/Finalize";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (invoiceId === undefined || invoiceId === null)
            throw new Error("The parameter 'invoiceId' must be defined.");
        url_ = url_.replace("{invoiceId}", encodeURIComponent("" + invoiceId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processStripeInvoices_PostFinalizeInvoice(_response); });
        });
    };
    Client.prototype.processStripeInvoices_PostFinalizeInvoice = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Get the requested invoice.
     * @return OK
     */
    Client.prototype.stripeInvoices_GetInvoice = function (invoiceId, userId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{userId}/Invoices/{invoiceId}";
        if (invoiceId === undefined || invoiceId === null)
            throw new Error("The parameter 'invoiceId' must be defined.");
        url_ = url_.replace("{invoiceId}", encodeURIComponent("" + invoiceId));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processStripeInvoices_GetInvoice(_response); });
        });
    };
    Client.prototype.processStripeInvoices_GetInvoice = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.stripePrices_GetPricesByProductId = function (productId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/StripePrices/ByProductId/{productId}";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processStripePrices_GetPricesByProductId(_response); });
        });
    };
    Client.prototype.processStripePrices_GetPricesByProductId = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param locale (optional)
     * @return OK
     */
    Client.prototype.stripePrices_GetActivePrices = function (locale) {
        var _this = this;
        var url_ = this.baseUrl + "/api/StripePrices/Active?";
        if (locale !== undefined && locale !== null)
            url_ += "locale=" + encodeURIComponent("" + locale) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processStripePrices_GetActivePrices(_response); });
        });
    };
    Client.prototype.processStripePrices_GetActivePrices = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param locale (optional)
     * @return OK
     */
    Client.prototype.stripePrices_GetPriceInfo = function (id, locale) {
        var _this = this;
        var url_ = this.baseUrl + "/api/StripePrices/{id}/Info?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (locale !== undefined && locale !== null)
            url_ += "locale=" + encodeURIComponent("" + locale) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processStripePrices_GetPriceInfo(_response); });
        });
    };
    Client.prototype.processStripePrices_GetPriceInfo = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.stripePrices_GetPrices = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/StripePrices";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processStripePrices_GetPrices(_response); });
        });
    };
    Client.prototype.processStripePrices_GetPrices = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.stripePrices_GetPrice = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/StripePrices/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processStripePrices_GetPrice(_response); });
        });
    };
    Client.prototype.processStripePrices_GetPrice = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return No Content
     */
    Client.prototype.stripePrices_PutPrice = function (id, price) {
        var _this = this;
        var url_ = this.baseUrl + "/api/StripePrices/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(price);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processStripePrices_PutPrice(_response); });
        });
    };
    Client.prototype.processStripePrices_PutPrice = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 204) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.switchboard_GetSwitcherStudioSetting = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/Switchboard/SwitcherStreamSettings";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processSwitchboard_GetSwitcherStudioSetting(_response); });
        });
    };
    Client.prototype.processSwitchboard_GetSwitcherStudioSetting = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.switchboard_PutSwitchboardSwitcherStreamSetting = function (switcherStreamSetting) {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/Switchboard/SwitcherStreamSettings";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(switcherStreamSetting);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processSwitchboard_PutSwitchboardSwitcherStreamSetting(_response); });
        });
    };
    Client.prototype.processSwitchboard_PutSwitchboardSwitcherStreamSetting = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.switchboard_GetExistingJWT = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/Switchboard/Credentials";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processSwitchboard_GetExistingJWT(_response); });
        });
    };
    Client.prototype.processSwitchboard_GetExistingJWT = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.switchboard_GenerateJWT = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/Switchboard/Credentials";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processSwitchboard_GenerateJWT(_response); });
        });
    };
    Client.prototype.processSwitchboard_GenerateJWT = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.switchboard_DeleteCredentials = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/Switchboard/Credentials";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processSwitchboard_DeleteCredentials(_response); });
        });
    };
    Client.prototype.processSwitchboard_DeleteCredentials = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.switcherStreamSettings_GetAllSwitcherStudioSettings = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/SwitcherStreamSettings/All";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processSwitcherStreamSettings_GetAllSwitcherStudioSettings(_response); });
        });
    };
    Client.prototype.processSwitcherStreamSettings_GetAllSwitcherStudioSettings = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.switcherStreamSettings_GetSwitcherStudioSettings = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/SwitcherStreamSettings";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processSwitcherStreamSettings_GetSwitcherStudioSettings(_response); });
        });
    };
    Client.prototype.processSwitcherStreamSettings_GetSwitcherStudioSettings = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.switcherStreamSettings_PutSwitcherStreamSettings = function (switcherStreamSettings) {
        var _this = this;
        var url_ = this.baseUrl + "/api/SwitcherStreamSettings";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(switcherStreamSettings);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processSwitcherStreamSettings_PutSwitcherStreamSettings(_response); });
        });
    };
    Client.prototype.processSwitcherStreamSettings_PutSwitcherStreamSettings = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.switcherStreamSettings_PostSwitcherStreamSetting = function (switcherStreamSetting) {
        var _this = this;
        var url_ = this.baseUrl + "/api/SwitcherStreamSettings";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(switcherStreamSetting);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processSwitcherStreamSettings_PostSwitcherStreamSetting(_response); });
        });
    };
    Client.prototype.processSwitcherStreamSettings_PostSwitcherStreamSetting = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.switcherStreamSettings_GetSwitcherStreamSetting = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/SwitcherStreamSettings/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processSwitcherStreamSettings_GetSwitcherStreamSetting(_response); });
        });
    };
    Client.prototype.processSwitcherStreamSettings_GetSwitcherStreamSetting = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return No Content
     */
    Client.prototype.switcherStreamSettings_PutSwitcherStreamSetting = function (id, switcherStreamSetting) {
        var _this = this;
        var url_ = this.baseUrl + "/api/SwitcherStreamSettings/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(switcherStreamSetting);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processSwitcherStreamSettings_PutSwitcherStreamSetting(_response); });
        });
    };
    Client.prototype.processSwitcherStreamSettings_PutSwitcherStreamSetting = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 204) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.switcherStreamSettings_DeleteSwitcherStreamSetting = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/SwitcherStreamSettings/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processSwitcherStreamSettings_DeleteSwitcherStreamSetting(_response); });
        });
    };
    Client.prototype.processSwitcherStreamSettings_DeleteSwitcherStreamSetting = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.switcherTempStorage_PostTempAsset = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/TempAssetStorage";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processSwitcherTempStorage_PostTempAsset(_response); });
        });
    };
    Client.prototype.processSwitcherTempStorage_PostTempAsset = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.telemetry_PostApplicationLogUpload = function (applicationLogUploadRequest) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Telemetry/ApplicationLogUpload";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(applicationLogUploadRequest);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processTelemetry_PostApplicationLogUpload(_response); });
        });
    };
    Client.prototype.processTelemetry_PostApplicationLogUpload = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.tutorial_GetTutorialLibrary = function (language, deviceType) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Tutorials/Library?";
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined and cannot be null.");
        else
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        if (deviceType === undefined || deviceType === null)
            throw new Error("The parameter 'deviceType' must be defined and cannot be null.");
        else
            url_ += "deviceType=" + encodeURIComponent("" + deviceType) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processTutorial_GetTutorialLibrary(_response); });
        });
    };
    Client.prototype.processTutorial_GetTutorialLibrary = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.twilio_PostTwilioNotification = function (userId, options) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{userId}/TwilioNotifications";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(options);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processTwilio_PostTwilioNotification(_response); });
        });
    };
    Client.prototype.processTwilio_PostTwilioNotification = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.twilio_PostTwilioInstallAndLoginNotification = function (userId, options) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{userId}/TwilioInstallAndLoginNotifications";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(options);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processTwilio_PostTwilioInstallAndLoginNotification(_response); });
        });
    };
    Client.prototype.processTwilio_PostTwilioInstallAndLoginNotification = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.twilio_PostTwilioAccountNotification = function (userId, options) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{userId}/TwilioAccountNotifications";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(options);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processTwilio_PostTwilioAccountNotification(_response); });
        });
    };
    Client.prototype.processTwilio_PostTwilioAccountNotification = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.twilio_PostTwilioMarketingNotification = function (userId, options) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{userId}/TwilioMarketingNotifications";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(options);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processTwilio_PostTwilioMarketingNotification(_response); });
        });
    };
    Client.prototype.processTwilio_PostTwilioMarketingNotification = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param options_communicationPreferences (optional)
     * @return OK
     */
    Client.prototype.twilio_GetTwilioBindings = function (userId, options_communicationPreferences) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{userId}/TwilioBindings?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (options_communicationPreferences !== undefined && options_communicationPreferences !== null)
            options_communicationPreferences && options_communicationPreferences.forEach(function (item) { url_ += "options.communicationPreferences=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processTwilio_GetTwilioBindings(_response); });
        });
    };
    Client.prototype.processTwilio_GetTwilioBindings = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.twilio_PostTwilioBinding = function (userId, options) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{userId}/TwilioBindings";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(options);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processTwilio_PostTwilioBinding(_response); });
        });
    };
    Client.prototype.processTwilio_PostTwilioBinding = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.twilio_PutTwilioBinding = function (userId, bindingSid, options) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{userId}/TwilioBindings/{bindingSid}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (bindingSid === undefined || bindingSid === null)
            throw new Error("The parameter 'bindingSid' must be defined.");
        url_ = url_.replace("{bindingSid}", encodeURIComponent("" + bindingSid));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(options);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processTwilio_PutTwilioBinding(_response); });
        });
    };
    Client.prototype.processTwilio_PutTwilioBinding = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.twilio_DeleteTwilioBinding = function (userId, bindingSid) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{userId}/TwilioBindings/{bindingSid}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (bindingSid === undefined || bindingSid === null)
            throw new Error("The parameter 'bindingSid' must be defined.");
        url_ = url_.replace("{bindingSid}", encodeURIComponent("" + bindingSid));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processTwilio_DeleteTwilioBinding(_response); });
        });
    };
    Client.prototype.processTwilio_DeleteTwilioBinding = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.twilio_PostSyncGuestToken = function (syncGrant) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Twilio/Sync/GuestToken";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(syncGrant);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processTwilio_PostSyncGuestToken(_response); });
        });
    };
    Client.prototype.processTwilio_PostSyncGuestToken = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.twilio_PostSyncHostToken = function (syncGrant) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Twilio/Sync/HostToken";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(syncGrant);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processTwilio_PostSyncHostToken(_response); });
        });
    };
    Client.prototype.processTwilio_PostSyncHostToken = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.twilio_GetSyncCommentsToken = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Twilio/Sync/CommentsToken";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processTwilio_GetSyncCommentsToken(_response); });
        });
    };
    Client.prototype.processTwilio_GetSyncCommentsToken = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Post webhook asynchronously.
     * @return OK
     */
    Client.prototype.twilio_PostWebhook = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Twilio/Video/Webhook";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processTwilio_PostWebhook(_response); });
        });
    };
    Client.prototype.processTwilio_PostWebhook = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Post token.
     * @param videoGrant The video grant.
     * @return OK
     */
    Client.prototype.twilio_PostToken = function (videoGrant) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Twilio/Video/Token";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(videoGrant);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processTwilio_PostToken(_response); });
        });
    };
    Client.prototype.processTwilio_PostToken = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Gets the rooms.
     * @param userId The user id.
     * @return OK
     */
    Client.prototype.twilio_GetRooms = function (userId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{userId}/VideoRooms";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processTwilio_GetRooms(_response); });
        });
    };
    Client.prototype.processTwilio_GetRooms = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Post room.
     * @param userId The user id.
     * @param options The options.
     * @return OK
     */
    Client.prototype.twilio_PostRoom = function (userId, options) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{userId}/VideoRooms";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(options);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processTwilio_PostRoom(_response); });
        });
    };
    Client.prototype.processTwilio_PostRoom = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Gets the room.
     * @param userId The user id.
     * @param roomId The room id.
     * @return OK
     */
    Client.prototype.twilio_GetRoom = function (userId, roomId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{userId}/VideoRooms/{roomId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (roomId === undefined || roomId === null)
            throw new Error("The parameter 'roomId' must be defined.");
        url_ = url_.replace("{roomId}", encodeURIComponent("" + roomId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processTwilio_GetRoom(_response); });
        });
    };
    Client.prototype.processTwilio_GetRoom = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Gets the participants.
     * @param userId The user id.
     * @param roomId The room id.
     * @return OK
     */
    Client.prototype.twilio_GetParticipants = function (userId, roomId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{userId}/VideoRooms/{roomId}/Participants";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (roomId === undefined || roomId === null)
            throw new Error("The parameter 'roomId' must be defined.");
        url_ = url_.replace("{roomId}", encodeURIComponent("" + roomId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processTwilio_GetParticipants(_response); });
        });
    };
    Client.prototype.processTwilio_GetParticipants = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Deletes the participant.
     * @param userId The user id.
     * @param roomId The room id.
     * @param participantId The participant id.
     * @return OK
     */
    Client.prototype.twilio_DeleteParticipant = function (userId, roomId, participantId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{userId}/VideoRooms/{roomId}/Participants/{participantId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (roomId === undefined || roomId === null)
            throw new Error("The parameter 'roomId' must be defined.");
        url_ = url_.replace("{roomId}", encodeURIComponent("" + roomId));
        if (participantId === undefined || participantId === null)
            throw new Error("The parameter 'participantId' must be defined.");
        url_ = url_.replace("{participantId}", encodeURIComponent("" + participantId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processTwilio_DeleteParticipant(_response); });
        });
    };
    Client.prototype.processTwilio_DeleteParticipant = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Gets the room usage.
     * @param userId The user id.
     * @return OK
     */
    Client.prototype.twilio_GetRoomUsage = function (userId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{userId}/VideoRoomsUsage";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processTwilio_GetRoomUsage(_response); });
        });
    };
    Client.prototype.processTwilio_GetRoomUsage = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Gets the nts token.
     * @param roomId The room id.
     * @return OK
     */
    Client.prototype.twilio_GetNtsToken = function (roomId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/VideoRooms/{roomId}/NtsToken";
        if (roomId === undefined || roomId === null)
            throw new Error("The parameter 'roomId' must be defined.");
        url_ = url_.replace("{roomId}", encodeURIComponent("" + roomId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processTwilio_GetNtsToken(_response); });
        });
    };
    Client.prototype.processTwilio_GetNtsToken = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.twitch_GetTwitchRequest = function (url) {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/Twitch/Proxy/{url}";
        if (url === undefined || url === null)
            throw new Error("The parameter 'url' must be defined.");
        url_ = url_.replace("{url}", encodeURIComponent("" + url));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processTwitch_GetTwitchRequest(_response); });
        });
    };
    Client.prototype.processTwitch_GetTwitchRequest = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     * @deprecated
     */
    Client.prototype.twitch_PutTwitchRequest = function (url) {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/Twitch/Proxy/{url}";
        if (url === undefined || url === null)
            throw new Error("The parameter 'url' must be defined.");
        url_ = url_.replace("{url}", encodeURIComponent("" + url));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processTwitch_PutTwitchRequest(_response); });
        });
    };
    Client.prototype.processTwitch_PutTwitchRequest = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     * @deprecated
     */
    Client.prototype.twitch_PostTwitchRequest = function (url) {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/Twitch/Proxy/{url}";
        if (url === undefined || url === null)
            throw new Error("The parameter 'url' must be defined.");
        url_ = url_.replace("{url}", encodeURIComponent("" + url));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processTwitch_PostTwitchRequest(_response); });
        });
    };
    Client.prototype.processTwitch_PostTwitchRequest = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     * @deprecated
     */
    Client.prototype.twitch_DeleteTwitchRequest = function (url) {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/Twitch/Proxy/{url}";
        if (url === undefined || url === null)
            throw new Error("The parameter 'url' must be defined.");
        url_ = url_.replace("{url}", encodeURIComponent("" + url));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processTwitch_DeleteTwitchRequest(_response); });
        });
    };
    Client.prototype.processTwitch_DeleteTwitchRequest = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     * @deprecated
     */
    Client.prototype.twitch_PatchTwitchRequest = function (url) {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/Twitch/Proxy/{url}";
        if (url === undefined || url === null)
            throw new Error("The parameter 'url' must be defined.");
        url_ = url_.replace("{url}", encodeURIComponent("" + url));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "PATCH",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processTwitch_PatchTwitchRequest(_response); });
        });
    };
    Client.prototype.processTwitch_PatchTwitchRequest = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.twitch_GetTwitchCredentials = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/Twitch/Credentials";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processTwitch_GetTwitchCredentials(_response); });
        });
    };
    Client.prototype.processTwitch_GetTwitchCredentials = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.twitch_PostCredentials = function (creds) {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/Twitch/Credentials";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(creds);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processTwitch_PostCredentials(_response); });
        });
    };
    Client.prototype.processTwitch_PostCredentials = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.twitch_DeleteCredentials = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/Twitch/Credentials";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processTwitch_DeleteCredentials(_response); });
        });
    };
    Client.prototype.processTwitch_DeleteCredentials = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.twitch_GetTwitchSwitcherStreamSetting = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/Twitch/SwitcherStreamSettings";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processTwitch_GetTwitchSwitcherStreamSetting(_response); });
        });
    };
    Client.prototype.processTwitch_GetTwitchSwitcherStreamSetting = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.twitch_PutTwitchSwitcherStreamSetting = function (switcherStreamSetting) {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/Twitch/SwitcherStreamSettings";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(switcherStreamSetting);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processTwitch_PutTwitchSwitcherStreamSetting(_response); });
        });
    };
    Client.prototype.processTwitch_PutTwitchSwitcherStreamSetting = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.twitch_PostTwitchSwitcherStreamSetting = function (switcherStreamSetting) {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/Twitch/SwitcherStreamSettings";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(switcherStreamSetting);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processTwitch_PostTwitchSwitcherStreamSetting(_response); });
        });
    };
    Client.prototype.processTwitch_PostTwitchSwitcherStreamSetting = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.twitch_GetIngestServers = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/Twitch/IngestServers";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processTwitch_GetIngestServers(_response); });
        });
    };
    Client.prototype.processTwitch_GetIngestServers = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.typeform_RetrieveTypeResponsefromFromId = function (formId, responseUid) {
        var _this = this;
        var url_ = this.baseUrl + "/api/typeform/forms/{formId}/responses/{responseUid}";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (responseUid === undefined || responseUid === null)
            throw new Error("The parameter 'responseUid' must be defined.");
        url_ = url_.replace("{responseUid}", encodeURIComponent("" + responseUid));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processTypeform_RetrieveTypeResponsefromFromId(_response); });
        });
    };
    Client.prototype.processTypeform_RetrieveTypeResponsefromFromId = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param query (optional)
     * @return OK
     */
    Client.prototype.user_GetAllUsers = function (query) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processUser_GetAllUsers(_response); });
        });
    };
    Client.prototype.processUser_GetAllUsers = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.user_GetUserById = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processUser_GetUserById(_response); });
        });
    };
    Client.prototype.processUser_GetUserById = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return No Content
     */
    Client.prototype.user_DeleteUserById = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {}
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processUser_DeleteUserById(_response); });
        });
    };
    Client.prototype.processUser_DeleteUserById = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 204) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return No Content
     */
    Client.prototype.user_PutUsername = function (id, username) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{id}/Username";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(username);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processUser_PutUsername(_response); });
        });
    };
    Client.prototype.processUser_PutUsername = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 204) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.userAssets_GetUserAssets = function (userId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{userId}/Assets";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processUserAssets_GetUserAssets(_response); });
        });
    };
    Client.prototype.processUserAssets_GetUserAssets = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param keepPreviousVersions (optional)
     * @return OK
     */
    Client.prototype.userAssets_PutUserAssets = function (userId, assetPutOptions, keepPreviousVersions) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{userId}/Assets?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (keepPreviousVersions !== undefined && keepPreviousVersions !== null)
            url_ += "keepPreviousVersions=" + encodeURIComponent("" + keepPreviousVersions) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(assetPutOptions);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processUserAssets_PutUserAssets(_response); });
        });
    };
    Client.prototype.processUserAssets_PutUserAssets = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.userAssets_DeleteUserAssetsAll = function (userId, assets) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{userId}/Assets";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(assets);
        var options_ = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processUserAssets_DeleteUserAssetsAll(_response); });
        });
    };
    Client.prototype.processUserAssets_DeleteUserAssetsAll = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.userAssets_GetUserAsset = function (userId, assetId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{userId}/Assets/{assetId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (assetId === undefined || assetId === null)
            throw new Error("The parameter 'assetId' must be defined.");
        url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processUserAssets_GetUserAsset(_response); });
        });
    };
    Client.prototype.processUserAssets_GetUserAsset = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.userAssets_DeleteUserAssets = function (userId, assetId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{userId}/Assets/{assetId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (assetId === undefined || assetId === null)
            throw new Error("The parameter 'assetId' must be defined.");
        url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processUserAssets_DeleteUserAssets(_response); });
        });
    };
    Client.prototype.processUserAssets_DeleteUserAssets = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.userAssetsUsage_GetUserAssetsUsage = function (userId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{userId}/AssetsUsage";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processUserAssetsUsage_GetUserAssetsUsage(_response); });
        });
    };
    Client.prototype.processUserAssetsUsage_GetUserAssetsUsage = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.userBrandProfile_GetUserBrandProfile = function (userId, brandId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{userId}/Brands/{brandId}/Profile";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (brandId === undefined || brandId === null)
            throw new Error("The parameter 'brandId' must be defined.");
        url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processUserBrandProfile_GetUserBrandProfile(_response); });
        });
    };
    Client.prototype.processUserBrandProfile_GetUserBrandProfile = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.userBrands_GetUserBrands = function (userId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{userId}/Brands";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processUserBrands_GetUserBrands(_response); });
        });
    };
    Client.prototype.processUserBrands_GetUserBrands = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.userBrands_PostUserBrand = function (userId, brand) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{userId}/Brands";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(brand);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processUserBrands_PostUserBrand(_response); });
        });
    };
    Client.prototype.processUserBrands_PostUserBrand = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.userBrands_PutUserBrand = function (userId, brandId, brand) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{userId}/Brands/{brandId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (brandId === undefined || brandId === null)
            throw new Error("The parameter 'brandId' must be defined.");
        url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(brand);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processUserBrands_PutUserBrand(_response); });
        });
    };
    Client.prototype.processUserBrands_PutUserBrand = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.userBrands_DeleteUserBrand = function (userId, brandId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{userId}/Brands/{brandId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (brandId === undefined || brandId === null)
            throw new Error("The parameter 'brandId' must be defined.");
        url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processUserBrands_DeleteUserBrand(_response); });
        });
    };
    Client.prototype.processUserBrands_DeleteUserBrand = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Get claims for a user
     * @param userId The userId to fetch claims for
     * @return OK
     */
    Client.prototype.userClaims_GetUserClaims = function (userId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Claims?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processUserClaims_GetUserClaims(_response); });
        });
    };
    Client.prototype.processUserClaims_GetUserClaims = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Add user claims.
     * @param request The request.
     * @return OK
     */
    Client.prototype.userClaims_AddUserClaims = function (request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Claims";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processUserClaims_AddUserClaims(_response); });
        });
    };
    Client.prototype.processUserClaims_AddUserClaims = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Deletes the user claims.
     * @param request The request.
     * @return OK
     */
    Client.prototype.userClaims_DeleteUserClaims = function (request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Claims";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processUserClaims_DeleteUserClaims(_response); });
        });
    };
    Client.prototype.processUserClaims_DeleteUserClaims = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.userEntitlements_getActiveUserEntitlements = function (userId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/users/{userId}/Entitlements";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processUserEntitlements_getActiveUserEntitlements(_response); });
        });
    };
    Client.prototype.processUserEntitlements_getActiveUserEntitlements = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.userExtensions_GetExtensions = function (userId, bundleId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{userId}/Extensions?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (bundleId === undefined || bundleId === null)
            throw new Error("The parameter 'bundleId' must be defined and cannot be null.");
        else
            url_ += "bundleId=" + encodeURIComponent("" + bundleId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processUserExtensions_GetExtensions(_response); });
        });
    };
    Client.prototype.processUserExtensions_GetExtensions = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Get user external auth for the given platformId.
     * @return OK
     */
    Client.prototype.userExternalAuths_GetExternalAuth = function (userId, platformId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{userId}/ExternalAuths/{platformId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (platformId === undefined || platformId === null)
            throw new Error("The parameter 'platformId' must be defined.");
        url_ = url_.replace("{platformId}", encodeURIComponent("" + platformId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processUserExternalAuths_GetExternalAuth(_response); });
        });
    };
    Client.prototype.processUserExternalAuths_GetExternalAuth = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.userFeatures_GetUserFeatures = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{id}/Features";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processUserFeatures_GetUserFeatures(_response); });
        });
    };
    Client.prototype.processUserFeatures_GetUserFeatures = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.userFeatures_PutUserFeatures = function (features, id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{id}/Features";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(features);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processUserFeatures_PutUserFeatures(_response); });
        });
    };
    Client.prototype.processUserFeatures_PutUserFeatures = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.userFeatures_GetUserFeature = function (featureId, id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{id}/Features/{featureId}";
        if (featureId === undefined || featureId === null)
            throw new Error("The parameter 'featureId' must be defined.");
        url_ = url_.replace("{featureId}", encodeURIComponent("" + featureId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processUserFeatures_GetUserFeature(_response); });
        });
    };
    Client.prototype.processUserFeatures_GetUserFeature = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.userFeatures_PutUserFeature = function (featureId, feature, id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{id}/Features/{featureId}";
        if (featureId === undefined || featureId === null)
            throw new Error("The parameter 'featureId' must be defined.");
        url_ = url_.replace("{featureId}", encodeURIComponent("" + featureId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(feature);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processUserFeatures_PutUserFeature(_response); });
        });
    };
    Client.prototype.processUserFeatures_PutUserFeature = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.userOrganizations_Index = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{id}/Organizations";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processUserOrganizations_Index(_response); });
        });
    };
    Client.prototype.processUserOrganizations_Index = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.userOrganizations_GetDefault = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{id}/Organizations/Default";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processUserOrganizations_GetDefault(_response); });
        });
    };
    Client.prototype.processUserOrganizations_GetDefault = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.userOrganizations_PostDefault = function (id, organizationUserId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{id}/Organizations/Default?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (organizationUserId === undefined || organizationUserId === null)
            throw new Error("The parameter 'organizationUserId' must be defined and cannot be null.");
        else
            url_ += "organizationUserId=" + encodeURIComponent("" + organizationUserId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processUserOrganizations_PostDefault(_response); });
        });
    };
    Client.prototype.processUserOrganizations_PostDefault = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.userOrganizations_DeleteDefault = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{id}/Organizations/Default";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processUserOrganizations_DeleteDefault(_response); });
        });
    };
    Client.prototype.processUserOrganizations_DeleteDefault = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Set the primary payment method for the customer.
     * @return OK
     */
    Client.prototype.userPaymentMethods_SetPrimaryPaymentMethod = function (userId, paymentMethodId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{userId}/PaymentMethods/{paymentMethodId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (paymentMethodId === undefined || paymentMethodId === null)
            throw new Error("The parameter 'paymentMethodId' must be defined.");
        url_ = url_.replace("{paymentMethodId}", encodeURIComponent("" + paymentMethodId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "PUT",
            headers: {}
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processUserPaymentMethods_SetPrimaryPaymentMethod(_response); });
        });
    };
    Client.prototype.processUserPaymentMethods_SetPrimaryPaymentMethod = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                return throwException("BadRequest", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Attach a new payment method and assign it to a customer.
     * @return OK
     */
    Client.prototype.userPaymentMethods_AttachPaymentMethod = function (userId, paymentMethodId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{userId}/PaymentMethods/{paymentMethodId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (paymentMethodId === undefined || paymentMethodId === null)
            throw new Error("The parameter 'paymentMethodId' must be defined.");
        url_ = url_.replace("{paymentMethodId}", encodeURIComponent("" + paymentMethodId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {}
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processUserPaymentMethods_AttachPaymentMethod(_response); });
        });
    };
    Client.prototype.processUserPaymentMethods_AttachPaymentMethod = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                return throwException("BadRequest", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Delete the payment method for the customer.
     * @return OK
     */
    Client.prototype.userPaymentMethods_DeletePaymentMethod = function (userId, paymentMethodId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{userId}/PaymentMethods/{paymentMethodId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (paymentMethodId === undefined || paymentMethodId === null)
            throw new Error("The parameter 'paymentMethodId' must be defined.");
        url_ = url_.replace("{paymentMethodId}", encodeURIComponent("" + paymentMethodId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {}
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processUserPaymentMethods_DeletePaymentMethod(_response); });
        });
    };
    Client.prototype.processUserPaymentMethods_DeletePaymentMethod = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                return throwException("BadRequest", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.userReferralParticipants_GetUserReferralParticipants = function (userId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/User/{userId}/UserReferralParticipants";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processUserReferralParticipants_GetUserReferralParticipants(_response); });
        });
    };
    Client.prototype.processUserReferralParticipants_GetUserReferralParticipants = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.userReferralParticipants_PutReferralParticipant = function (userId, campaignId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/User/{userId}/UserReferralParticipants?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (campaignId === undefined || campaignId === null)
            throw new Error("The parameter 'campaignId' must be defined and cannot be null.");
        else
            url_ += "campaignId=" + encodeURIComponent("" + campaignId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processUserReferralParticipants_PutReferralParticipant(_response); });
        });
    };
    Client.prototype.processUserReferralParticipants_PutReferralParticipant = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.userReferralParticipants_GetCampaign = function (userId, campaignId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/User/{userId}/UserReferralParticipants/Campaigns/{campaignId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (campaignId === undefined || campaignId === null)
            throw new Error("The parameter 'campaignId' must be defined.");
        url_ = url_.replace("{campaignId}", encodeURIComponent("" + campaignId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processUserReferralParticipants_GetCampaign(_response); });
        });
    };
    Client.prototype.processUserReferralParticipants_GetCampaign = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param limit (optional)
     * @param offset (optional)
     * @return OK
     */
    Client.prototype.userReferralParticipants_GetUserParticipantReferralStatus = function (userId, campaignId, limit, offset) {
        var _this = this;
        var url_ = this.baseUrl + "/api/User/{userId}/UserReferralParticipants/Campaigns/{campaignId}/ReferralStatus?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (campaignId === undefined || campaignId === null)
            throw new Error("The parameter 'campaignId' must be defined.");
        url_ = url_.replace("{campaignId}", encodeURIComponent("" + campaignId));
        if (limit !== undefined && limit !== null)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (offset !== undefined && offset !== null)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processUserReferralParticipants_GetUserParticipantReferralStatus(_response); });
        });
    };
    Client.prototype.processUserReferralParticipants_GetUserParticipantReferralStatus = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.userShopifySubscriptionEntitlements_GetShopifySubscriptionEntitlements = function (userId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/users/{userId}/ShopifySubscriptionEntitlements";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processUserShopifySubscriptionEntitlements_GetShopifySubscriptionEntitlements(_response); });
        });
    };
    Client.prototype.processUserShopifySubscriptionEntitlements_GetShopifySubscriptionEntitlements = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param locale (optional)
     * @return OK
     */
    Client.prototype.userStripePrices_GetStripePrices = function (userId, locale) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{userId}/StripePrices?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (locale !== undefined && locale !== null)
            url_ += "locale=" + encodeURIComponent("" + locale) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processUserStripePrices_GetStripePrices(_response); });
        });
    };
    Client.prototype.processUserStripePrices_GetStripePrices = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param locale (optional)
     * @return OK
     */
    Client.prototype.userStripePrices_GetStripePrice = function (userId, priceId, locale) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{userId}/StripePrices/{priceId}?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (priceId === undefined || priceId === null)
            throw new Error("The parameter 'priceId' must be defined.");
        url_ = url_.replace("{priceId}", encodeURIComponent("" + priceId));
        if (locale !== undefined && locale !== null)
            url_ += "locale=" + encodeURIComponent("" + locale) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processUserStripePrices_GetStripePrice(_response); });
        });
    };
    Client.prototype.processUserStripePrices_GetStripePrice = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Get a Stripe subscription for a customer.
     * @return OK
     */
    Client.prototype.userSubscriptions_GetSubscription = function (userId, subId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{userId}/Subscriptions?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (subId === undefined || subId === null)
            throw new Error("The parameter 'subId' must be defined and cannot be null.");
        else
            url_ += "subId=" + encodeURIComponent("" + subId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processUserSubscriptions_GetSubscription(_response); });
        });
    };
    Client.prototype.processUserSubscriptions_GetSubscription = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Create a Stripe subscription for a customer.
     * @return OK
     */
    Client.prototype.userSubscriptions_CreateSubscription = function (userId, request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{userId}/Subscriptions";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processUserSubscriptions_CreateSubscription(_response); });
        });
    };
    Client.prototype.processUserSubscriptions_CreateSubscription = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Update the DB with the latest subscription data from Stripe.
     * @return No Content
     */
    Client.prototype.userSubscriptions_ReloadSubscription = function (userId, subscriptionId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{userId}/Subscriptions/{subscriptionId}/Reload";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {}
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processUserSubscriptions_ReloadSubscription(_response); });
        });
    };
    Client.prototype.processUserSubscriptions_ReloadSubscription = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 204) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Update a Stripe subscription for a customer.
     * @return OK
     */
    Client.prototype.userSubscriptions_UpdateSubscription = function (userId, subscriptionId, request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{userId}/Subscriptions/{subscriptionId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processUserSubscriptions_UpdateSubscription(_response); });
        });
    };
    Client.prototype.processUserSubscriptions_UpdateSubscription = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Gets the metrics asynchronously.
     * @param request The request.
     * @return OK
     */
    Client.prototype.videoAnalytics_GetMetrics = function (request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Video/Analytics/User";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processVideoAnalytics_GetMetrics(_response); });
        });
    };
    Client.prototype.processVideoAnalytics_GetMetrics = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Gets the metrics by broadcast asynchronously.
     * @param request The request.
     * @return OK
     */
    Client.prototype.videoAnalytics_GetMetricsByBroadcast = function (request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Video/Analytics/Broadcast";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processVideoAnalytics_GetMetricsByBroadcast(_response); });
        });
    };
    Client.prototype.processVideoAnalytics_GetMetricsByBroadcast = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Gets the metrics by video player asynchronously.
     * @param request The request.
     * @return OK
     */
    Client.prototype.videoAnalytics_GetMetricsByVideoPlayer = function (request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Video/Analytics/VideoPlayer";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processVideoAnalytics_GetMetricsByVideoPlayer(_response); });
        });
    };
    Client.prototype.processVideoAnalytics_GetMetricsByVideoPlayer = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Gets the metrics by playlist broadcast asynchronously.
     * @param request The request.
     * @return OK
     */
    Client.prototype.videoAnalytics_GetMetricsByPlaylistBroadcast = function (request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Video/Analytics/PlaylistBroadcast";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processVideoAnalytics_GetMetricsByPlaylistBroadcast(_response); });
        });
    };
    Client.prototype.processVideoAnalytics_GetMetricsByPlaylistBroadcast = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.videoPlayer_GetVideoPlayerSwitcherStreamSetting = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/VideoPlayer/SwitcherStreamSettings";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processVideoPlayer_GetVideoPlayerSwitcherStreamSetting(_response); });
        });
    };
    Client.prototype.processVideoPlayer_GetVideoPlayerSwitcherStreamSetting = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.videoPlayer_PutVideoPlayerStreamSetting = function (switcherStreamSetting) {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/VideoPlayer/SwitcherStreamSettings";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(switcherStreamSetting);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processVideoPlayer_PutVideoPlayerStreamSetting(_response); });
        });
    };
    Client.prototype.processVideoPlayer_PutVideoPlayerStreamSetting = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.videoPlayer_PostVideoPlayerStreamSetting = function (switcherStreamSetting) {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/VideoPlayer/SwitcherStreamSettings";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(switcherStreamSetting);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processVideoPlayer_PostVideoPlayerStreamSetting(_response); });
        });
    };
    Client.prototype.processVideoPlayer_PostVideoPlayerStreamSetting = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Gets the video player profile associated with a given project
     * @return Returns the video player profile
     */
    Client.prototype.videoPlayerPlaylist_GetVideoPlayerPlaylist = function (videoPlayerPlaylistId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/playlist/{videoPlayerPlaylistId}";
        if (videoPlayerPlaylistId === undefined || videoPlayerPlaylistId === null)
            throw new Error("The parameter 'videoPlayerPlaylistId' must be defined.");
        url_ = url_.replace("{videoPlayerPlaylistId}", encodeURIComponent("" + videoPlayerPlaylistId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processVideoPlayerPlaylist_GetVideoPlayerPlaylist(_response); });
        });
    };
    Client.prototype.processVideoPlayerPlaylist_GetVideoPlayerPlaylist = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then(function (_responseText) {
                return throwException("The project or profile dosn\'t exist", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Puts the video player playlist.
     * @param videoPlayerPlaylistId The video player playlist id.
     * @param playlist The playlist.
     * @return OK
     */
    Client.prototype.videoPlayerPlaylist_PutVideoPlayerPlaylist = function (videoPlayerPlaylistId, playlist) {
        var _this = this;
        var url_ = this.baseUrl + "/api/playlist/{videoPlayerPlaylistId}";
        if (videoPlayerPlaylistId === undefined || videoPlayerPlaylistId === null)
            throw new Error("The parameter 'videoPlayerPlaylistId' must be defined.");
        url_ = url_.replace("{videoPlayerPlaylistId}", encodeURIComponent("" + videoPlayerPlaylistId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(playlist);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processVideoPlayerPlaylist_PutVideoPlayerPlaylist(_response); });
        });
    };
    Client.prototype.processVideoPlayerPlaylist_PutVideoPlayerPlaylist = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Post video player playlist.
     * @param playlist The playlist.
     * @return OK
     */
    Client.prototype.videoPlayerPlaylist_PostVideoPlayerPlaylist = function (playlist) {
        var _this = this;
        var url_ = this.baseUrl + "/api/playlist";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(playlist);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processVideoPlayerPlaylist_PostVideoPlayerPlaylist(_response); });
        });
    };
    Client.prototype.processVideoPlayerPlaylist_PostVideoPlayerPlaylist = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * PUT video player playlist broadcasts.
     * @param videoPlayerPlaylistId The video player playlist id.
     * @param playlistBroadcastsRequest The playlist broadcasts request.
     * @return OK
     */
    Client.prototype.videoPlayerPlaylist_PutVideoPlayerPlaylistBroadcasts = function (videoPlayerPlaylistId, playlistBroadcastsRequest) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Playlists/{videoPlayerPlaylistId}/Broadcasts";
        if (videoPlayerPlaylistId === undefined || videoPlayerPlaylistId === null)
            throw new Error("The parameter 'videoPlayerPlaylistId' must be defined.");
        url_ = url_.replace("{videoPlayerPlaylistId}", encodeURIComponent("" + videoPlayerPlaylistId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(playlistBroadcastsRequest);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processVideoPlayerPlaylist_PutVideoPlayerPlaylistBroadcasts(_response); });
        });
    };
    Client.prototype.processVideoPlayerPlaylist_PutVideoPlayerPlaylistBroadcasts = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Post video player playlist broadcasts.
     * @param videoPlayerPlaylistId The video player playlist id.
     * @param playlistBroadcastsRequest The playlist broadcasts request.
     * @return OK
     */
    Client.prototype.videoPlayerPlaylist_PostVideoPlayerPlaylistBroadcasts = function (videoPlayerPlaylistId, playlistBroadcastsRequest) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Playlists/{videoPlayerPlaylistId}/Broadcasts";
        if (videoPlayerPlaylistId === undefined || videoPlayerPlaylistId === null)
            throw new Error("The parameter 'videoPlayerPlaylistId' must be defined.");
        url_ = url_.replace("{videoPlayerPlaylistId}", encodeURIComponent("" + videoPlayerPlaylistId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(playlistBroadcastsRequest);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processVideoPlayerPlaylist_PostVideoPlayerPlaylistBroadcasts(_response); });
        });
    };
    Client.prototype.processVideoPlayerPlaylist_PostVideoPlayerPlaylistBroadcasts = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Delete video player playlist broadcasts.
     * @param videoPlayerPlaylistId The video player playlist id.
     * @param playlistBroadcasts The playlist broadcasts.
     * @return OK
     */
    Client.prototype.videoPlayerPlaylist_DeleteVideoPlayerPlaylistBroadcasts = function (videoPlayerPlaylistId, playlistBroadcasts) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Playlists/{videoPlayerPlaylistId}/Broadcasts";
        if (videoPlayerPlaylistId === undefined || videoPlayerPlaylistId === null)
            throw new Error("The parameter 'videoPlayerPlaylistId' must be defined.");
        url_ = url_.replace("{videoPlayerPlaylistId}", encodeURIComponent("" + videoPlayerPlaylistId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(playlistBroadcasts);
        var options_ = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processVideoPlayerPlaylist_DeleteVideoPlayerPlaylistBroadcasts(_response); });
        });
    };
    Client.prototype.processVideoPlayerPlaylist_DeleteVideoPlayerPlaylistBroadcasts = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * PUT video player playlist broadcasts.
     * @param videoPlayerPlaylistId The video player playlist id.
     * @param playlistBroadcastRequest The playlist broadcasts request.
     * @return OK
     */
    Client.prototype.videoPlayerPlaylist_PutVideoPlayerPlaylistBroadcasts2 = function (videoPlayerPlaylistId, playlistBroadcastRequest) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Playlists/{videoPlayerPlaylistId}/Broadcast";
        if (videoPlayerPlaylistId === undefined || videoPlayerPlaylistId === null)
            throw new Error("The parameter 'videoPlayerPlaylistId' must be defined.");
        url_ = url_.replace("{videoPlayerPlaylistId}", encodeURIComponent("" + videoPlayerPlaylistId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(playlistBroadcastRequest);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processVideoPlayerPlaylist_PutVideoPlayerPlaylistBroadcasts2(_response); });
        });
    };
    Client.prototype.processVideoPlayerPlaylist_PutVideoPlayerPlaylistBroadcasts2 = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Post video player playlist broadcast.
     * @param videoPlayerPlaylistId The video player playlist id.
     * @param playlistBroadcastRequest The playlist broadcast request object.
     * @return OK
     */
    Client.prototype.videoPlayerPlaylist_PostVideoPlayerPlaylistBroadcast = function (videoPlayerPlaylistId, playlistBroadcastRequest) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Playlists/{videoPlayerPlaylistId}/Broadcast";
        if (videoPlayerPlaylistId === undefined || videoPlayerPlaylistId === null)
            throw new Error("The parameter 'videoPlayerPlaylistId' must be defined.");
        url_ = url_.replace("{videoPlayerPlaylistId}", encodeURIComponent("" + videoPlayerPlaylistId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(playlistBroadcastRequest);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processVideoPlayerPlaylist_PostVideoPlayerPlaylistBroadcast(_response); });
        });
    };
    Client.prototype.processVideoPlayerPlaylist_PostVideoPlayerPlaylistBroadcast = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Delete video player playlist broadcast.
     * @param videoPlayerPlaylistId The video player playlist id.
     * @param playlistBroadcast The playlist broadcast.
     * @return OK
     */
    Client.prototype.videoPlayerPlaylist_DeleteVideoPlayerPlaylistBroadcast = function (videoPlayerPlaylistId, playlistBroadcast) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Playlists/{videoPlayerPlaylistId}/Broadcast";
        if (videoPlayerPlaylistId === undefined || videoPlayerPlaylistId === null)
            throw new Error("The parameter 'videoPlayerPlaylistId' must be defined.");
        url_ = url_.replace("{videoPlayerPlaylistId}", encodeURIComponent("" + videoPlayerPlaylistId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(playlistBroadcast);
        var options_ = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processVideoPlayerPlaylist_DeleteVideoPlayerPlaylistBroadcast(_response); });
        });
    };
    Client.prototype.processVideoPlayerPlaylist_DeleteVideoPlayerPlaylistBroadcast = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Post to add a broadcast to the playlist
     * @param videoPlayerPlaylistId The video player playlist id.
     * @param broadcastId The broadcast id to add to the playlist.
     * @return OK
     */
    Client.prototype.videoPlayerPlaylist_PostVideoPlayerPlaylistBroadcastById = function (videoPlayerPlaylistId, broadcastId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Playlists/{videoPlayerPlaylistId}/BroadcastById?";
        if (videoPlayerPlaylistId === undefined || videoPlayerPlaylistId === null)
            throw new Error("The parameter 'videoPlayerPlaylistId' must be defined.");
        url_ = url_.replace("{videoPlayerPlaylistId}", encodeURIComponent("" + videoPlayerPlaylistId));
        if (broadcastId === undefined || broadcastId === null)
            throw new Error("The parameter 'broadcastId' must be defined and cannot be null.");
        else
            url_ += "broadcastId=" + encodeURIComponent("" + broadcastId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processVideoPlayerPlaylist_PostVideoPlayerPlaylistBroadcastById(_response); });
        });
    };
    Client.prototype.processVideoPlayerPlaylist_PostVideoPlayerPlaylistBroadcastById = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Post to add multiple broadcasts to the playlist
     * @param videoPlayerPlaylistId The video player playlist id.
     * @param broadcastIds The broadcast ids to add to the playlist.
     * @return OK
     */
    Client.prototype.videoPlayerPlaylist_PostVideoPlayerPlaylistBroadcastsByIds = function (videoPlayerPlaylistId, broadcastIds) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Playlists/{videoPlayerPlaylistId}/BroadcastsByIds";
        if (videoPlayerPlaylistId === undefined || videoPlayerPlaylistId === null)
            throw new Error("The parameter 'videoPlayerPlaylistId' must be defined.");
        url_ = url_.replace("{videoPlayerPlaylistId}", encodeURIComponent("" + videoPlayerPlaylistId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(broadcastIds);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processVideoPlayerPlaylist_PostVideoPlayerPlaylistBroadcastsByIds(_response); });
        });
    };
    Client.prototype.processVideoPlayerPlaylist_PostVideoPlayerPlaylistBroadcastsByIds = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Get by id asynchronously.
     * @param videoPlayerPlaylistBroadcastId The video player playlist broadcast id.
     * @param includeAnalytics (optional) Whether to include analytics
     * @return OK
     */
    Client.prototype.videoPlayerPlaylistBroadcast_GetById = function (videoPlayerPlaylistBroadcastId, includeAnalytics) {
        var _this = this;
        var url_ = this.baseUrl + "/api/PlaylistBroadcast/{videoPlayerPlaylistBroadcastId}?";
        if (videoPlayerPlaylistBroadcastId === undefined || videoPlayerPlaylistBroadcastId === null)
            throw new Error("The parameter 'videoPlayerPlaylistBroadcastId' must be defined.");
        url_ = url_.replace("{videoPlayerPlaylistBroadcastId}", encodeURIComponent("" + videoPlayerPlaylistBroadcastId));
        if (includeAnalytics !== undefined && includeAnalytics !== null)
            url_ += "includeAnalytics=" + encodeURIComponent("" + includeAnalytics) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processVideoPlayerPlaylistBroadcast_GetById(_response); });
        });
    };
    Client.prototype.processVideoPlayerPlaylistBroadcast_GetById = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Updates a broadcast in the playlist.
     * @param videoPlayerPlaylistBroadcastUpdateRequest The update request object.
     * @return OK
     */
    Client.prototype.videoPlayerPlaylistBroadcast_UpdateVideoPlayerPlaylistBroadcast = function (videoPlayerPlaylistBroadcastUpdateRequest, videoPlayerPlaylistBroadcastId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/PlaylistBroadcast/{videoPlayerPlaylistBroadcastId}";
        if (videoPlayerPlaylistBroadcastId === undefined || videoPlayerPlaylistBroadcastId === null)
            throw new Error("The parameter 'videoPlayerPlaylistBroadcastId' must be defined.");
        url_ = url_.replace("{videoPlayerPlaylistBroadcastId}", encodeURIComponent("" + videoPlayerPlaylistBroadcastId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(videoPlayerPlaylistBroadcastUpdateRequest);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processVideoPlayerPlaylistBroadcast_UpdateVideoPlayerPlaylistBroadcast(_response); });
        });
    };
    Client.prototype.processVideoPlayerPlaylistBroadcast_UpdateVideoPlayerPlaylistBroadcast = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Gets the video player profile associated with a given project
     * @param projectId The Project Id
     * @param includeCloudflareResponse (optional) Indicate if cloudflare response should be included
     * @return Returns the video player profile
     */
    Client.prototype.videoPlayerProfile_GetVideoPlayerProfile = function (projectId, includeCloudflareResponse) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Projects/{projectId}/VideoPlayerProfile?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (includeCloudflareResponse !== undefined && includeCloudflareResponse !== null)
            url_ += "includeCloudflareResponse=" + encodeURIComponent("" + includeCloudflareResponse) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processVideoPlayerProfile_GetVideoPlayerProfile(_response); });
        });
    };
    Client.prototype.processVideoPlayerProfile_GetVideoPlayerProfile = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then(function (_responseText) {
                return throwException("The project or profile dosn\'t exist", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Gets the video player profile associated with a given video player
     * @param videoPlayerId The video player Id
     * @param includeCloudflareResponse (optional) Indicate if cloudflare response should be included
     * @return Returns the video player profile
     */
    Client.prototype.videoPlayerProfile_GetVideoPlayerProfileByVideoPlayerId = function (videoPlayerId, includeCloudflareResponse) {
        var _this = this;
        var url_ = this.baseUrl + "/api/VideoPlayers/{videoPlayerId}/VideoPlayerProfile?";
        if (videoPlayerId === undefined || videoPlayerId === null)
            throw new Error("The parameter 'videoPlayerId' must be defined.");
        url_ = url_.replace("{videoPlayerId}", encodeURIComponent("" + videoPlayerId));
        if (includeCloudflareResponse !== undefined && includeCloudflareResponse !== null)
            url_ += "includeCloudflareResponse=" + encodeURIComponent("" + includeCloudflareResponse) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processVideoPlayerProfile_GetVideoPlayerProfileByVideoPlayerId(_response); });
        });
    };
    Client.prototype.processVideoPlayerProfile_GetVideoPlayerProfileByVideoPlayerId = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then(function (_responseText) {
                return throwException("The video player dosn\'t exist", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Gets the video player profile associated with a given video player
     * @param videoPlayerId The video player Id
     * @return Returns the video player profile
     */
    Client.prototype.videoPlayerProfile_GetVideoPlayerEntitlementProfileByVideoPlayerId = function (videoPlayerId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/VideoPlayers/{videoPlayerId}/EntitlementProfile";
        if (videoPlayerId === undefined || videoPlayerId === null)
            throw new Error("The parameter 'videoPlayerId' must be defined.");
        url_ = url_.replace("{videoPlayerId}", encodeURIComponent("" + videoPlayerId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processVideoPlayerProfile_GetVideoPlayerEntitlementProfileByVideoPlayerId(_response); });
        });
    };
    Client.prototype.processVideoPlayerProfile_GetVideoPlayerEntitlementProfileByVideoPlayerId = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then(function (_responseText) {
                return throwException("The video player dosn\'t exist", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Gets the owner associated with a given video player
     * @param videoPlayerId The video player Id
     * @return OK
     */
    Client.prototype.videoPlayerProfile_GetOwner = function (videoPlayerId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/VideoPlayers/{videoPlayerId}/Owner";
        if (videoPlayerId === undefined || videoPlayerId === null)
            throw new Error("The parameter 'videoPlayerId' must be defined.");
        url_ = url_.replace("{videoPlayerId}", encodeURIComponent("" + videoPlayerId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processVideoPlayerProfile_GetOwner(_response); });
        });
    };
    Client.prototype.processVideoPlayerProfile_GetOwner = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Gets the owner associated with a given video player
     * @param broadcastId The broadcast Id
     * @return OK
     */
    Client.prototype.videoPlayerProfile_GetOwnerByBroadcast = function (broadcastId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Broadcasts/{broadcastId}/Owner";
        if (broadcastId === undefined || broadcastId === null)
            throw new Error("The parameter 'broadcastId' must be defined.");
        url_ = url_.replace("{broadcastId}", encodeURIComponent("" + broadcastId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processVideoPlayerProfile_GetOwnerByBroadcast(_response); });
        });
    };
    Client.prototype.processVideoPlayerProfile_GetOwnerByBroadcast = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Creates or updates the video player profile by user.
     * @param userId The user id.
     * @param projectId The project id.
     * @param profile The video player profile.
     * @return OK
     */
    Client.prototype.videoPlayerProfile_PutVideoPlayerProfileByUser = function (userId, projectId, profile) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Users/{userId}/Projects/{projectId}/VideoPlayerProfile";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(profile);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processVideoPlayerProfile_PutVideoPlayerProfileByUser(_response); });
        });
    };
    Client.prototype.processVideoPlayerProfile_PutVideoPlayerProfileByUser = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Gets the video player.  Will return data for the video player including current entitlements.
     * @param videoPlayerId The video player id.
     * @return OK
     */
    Client.prototype.videoPlayers_GetVideoPlayer = function (videoPlayerId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/VideoPlayers/{videoPlayerId}";
        if (videoPlayerId === undefined || videoPlayerId === null)
            throw new Error("The parameter 'videoPlayerId' must be defined.");
        url_ = url_.replace("{videoPlayerId}", encodeURIComponent("" + videoPlayerId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processVideoPlayers_GetVideoPlayer(_response); });
        });
    };
    Client.prototype.processVideoPlayers_GetVideoPlayer = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Gets current live and upcoming cloudflare video(s) for the video player id.
    If the user doesn't have a video player eligible plan, the demo video will be returned.
     * @return Returns the latest video(s)
     */
    Client.prototype.videoPlayers_GetNextEvents = function (videoPlayerId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/VideoPlayers/{videoPlayerId}/NextEvents";
        if (videoPlayerId === undefined || videoPlayerId === null)
            throw new Error("The parameter 'videoPlayerId' must be defined.");
        url_ = url_.replace("{videoPlayerId}", encodeURIComponent("" + videoPlayerId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processVideoPlayers_GetNextEvents(_response); });
        });
    };
    Client.prototype.processVideoPlayers_GetNextEvents = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Gets current live and upcoming cloudflare video(s) for the video player id.
    If the user doesn't have a video player eligible plan, the demo video will be returned.
     * @return Returns the latest video(s)
     */
    Client.prototype.videoPlayers_GetNextEventsWithEntitlements = function (videoPlayerId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/VideoPlayers/{videoPlayerId}/NextEventsWithEntitlements";
        if (videoPlayerId === undefined || videoPlayerId === null)
            throw new Error("The parameter 'videoPlayerId' must be defined.");
        url_ = url_.replace("{videoPlayerId}", encodeURIComponent("" + videoPlayerId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processVideoPlayers_GetNextEventsWithEntitlements(_response); });
        });
    };
    Client.prototype.processVideoPlayers_GetNextEventsWithEntitlements = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Get Video Player Info
     * @param videoPlayerId The video player id
     * @return OK
     * @deprecated
     */
    Client.prototype.videoPlayers_GetVideoPlayerInfo = function (videoPlayerId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/VideoPlayers/{videoPlayerId}/Info";
        if (videoPlayerId === undefined || videoPlayerId === null)
            throw new Error("The parameter 'videoPlayerId' must be defined.");
        url_ = url_.replace("{videoPlayerId}", encodeURIComponent("" + videoPlayerId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processVideoPlayers_GetVideoPlayerInfo(_response); });
        });
    };
    Client.prototype.processVideoPlayers_GetVideoPlayerInfo = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Get Brand Profile for the video player
     * @param videoPlayerId The video player id
     * @param useCache (optional) Whether the brand profile should try to be fetched from the cache
     * @return OK
     */
    Client.prototype.videoPlayers_GetVideoPlayerBrandProfile = function (videoPlayerId, useCache) {
        var _this = this;
        var url_ = this.baseUrl + "/api/VideoPlayers/{videoPlayerId}/BrandProfile?";
        if (videoPlayerId === undefined || videoPlayerId === null)
            throw new Error("The parameter 'videoPlayerId' must be defined.");
        url_ = url_.replace("{videoPlayerId}", encodeURIComponent("" + videoPlayerId));
        if (useCache !== undefined && useCache !== null)
            url_ += "useCache=" + encodeURIComponent("" + useCache) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processVideoPlayers_GetVideoPlayerBrandProfile(_response); });
        });
    };
    Client.prototype.processVideoPlayers_GetVideoPlayerBrandProfile = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Get the thumbnail url for the video player. Will default to the custom thumbnail of the featured video.
    If not present, then the custom thumbnail of the first video will be used.
    If neither are present, then it will return null, allowing the frontend to show placeholder.
     * @return OK
     */
    Client.prototype.videoPlayers_GetVideoPlayerThumbnailUrl = function (videoPlayerId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/VideoPlayers/{videoPlayerId}/Thumbnail";
        if (videoPlayerId === undefined || videoPlayerId === null)
            throw new Error("The parameter 'videoPlayerId' must be defined.");
        url_ = url_.replace("{videoPlayerId}", encodeURIComponent("" + videoPlayerId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processVideoPlayers_GetVideoPlayerThumbnailUrl(_response); });
        });
    };
    Client.prototype.processVideoPlayers_GetVideoPlayerThumbnailUrl = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Sort catalog video player.
     * @param request The request.
     * @return OK
     */
    Client.prototype.videoPlayers_SortVideoPlayer = function (request, videoPlayerId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/VideoPlayers/{videoPlayerId}/Sort";
        if (videoPlayerId === undefined || videoPlayerId === null)
            throw new Error("The parameter 'videoPlayerId' must be defined.");
        url_ = url_.replace("{videoPlayerId}", encodeURIComponent("" + videoPlayerId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processVideoPlayers_SortVideoPlayer(_response); });
        });
    };
    Client.prototype.processVideoPlayers_SortVideoPlayer = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Gets video player from custom slug
     * @param slug The slug to lookup.
     * @return OK
     */
    Client.prototype.videoPlayers_GetVideoPlayerIdByCustomSlug = function (slug) {
        var _this = this;
        var url_ = this.baseUrl + "/api/VideoPlayers/Slug/Lookup?";
        if (slug === undefined || slug === null)
            throw new Error("The parameter 'slug' must be defined and cannot be null.");
        else
            url_ += "slug=" + encodeURIComponent("" + slug) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processVideoPlayers_GetVideoPlayerIdByCustomSlug(_response); });
        });
    };
    Client.prototype.processVideoPlayers_GetVideoPlayerIdByCustomSlug = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Checks string if it is valid to be a video player slug.
     * @param slug The slug to check.
     * @return OK
     */
    Client.prototype.videoPlayers_CheckCustomSlug = function (slug) {
        var _this = this;
        var url_ = this.baseUrl + "/api/VideoPlayers/Slug/Check?";
        if (slug === undefined || slug === null)
            throw new Error("The parameter 'slug' must be defined and cannot be null.");
        else
            url_ += "slug=" + encodeURIComponent("" + slug) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processVideoPlayers_CheckCustomSlug(_response); });
        });
    };
    Client.prototype.processVideoPlayers_CheckCustomSlug = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Gets the video players.  Will return data for the video player including current entitlements.
    ***** USE THIS ENDPOINT *****
     * @param videoPlayerIds The video player ids
     * @return OK
     */
    Client.prototype.videoPlayersV2_GetVideoPlayers = function (videoPlayerIds) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v2/VideoPlayers?";
        if (videoPlayerIds === undefined || videoPlayerIds === null)
            throw new Error("The parameter 'videoPlayerIds' must be defined and cannot be null.");
        else
            videoPlayerIds && videoPlayerIds.forEach(function (item) { url_ += "videoPlayerIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processVideoPlayersV2_GetVideoPlayers(_response); });
        });
    };
    Client.prototype.processVideoPlayersV2_GetVideoPlayers = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Gets the PlayersResponse by project id.  Will return data for the video player including current entitlements.
    *** Newest Endpoint as of October 2024 ***
     * @param projectId The user's project id.
     * @param includeCloudFlare (optional) Include cloudflare repsonses for videos.
     * @param includeDefaultPlayers (optional) Include "generated" players (Video Library and Livestrems).
     * @return OK
     */
    Client.prototype.videoPlayersV2_GetVideoPlayersByProjectId = function (projectId, includeCloudFlare, includeDefaultPlayers) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v2/VideoPlayers/ByProjectId?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (includeCloudFlare !== undefined && includeCloudFlare !== null)
            url_ += "includeCloudFlare=" + encodeURIComponent("" + includeCloudFlare) + "&";
        if (includeDefaultPlayers !== undefined && includeDefaultPlayers !== null)
            url_ += "includeDefaultPlayers=" + encodeURIComponent("" + includeDefaultPlayers) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processVideoPlayersV2_GetVideoPlayersByProjectId(_response); });
        });
    };
    Client.prototype.processVideoPlayersV2_GetVideoPlayersByProjectId = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Sort catalog video player.
     * @param request The request.
     * @return OK
     */
    Client.prototype.videoPlayersV2_SortVideoPlayer = function (request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v2/VideoPlayers/Sort";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processVideoPlayersV2_SortVideoPlayer(_response); });
        });
    };
    Client.prototype.processVideoPlayersV2_SortVideoPlayer = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.videos_GetAllVideos = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/admin/Videos";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processVideos_GetAllVideos(_response); });
        });
    };
    Client.prototype.processVideos_GetAllVideos = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.videos_Post = function (value) {
        var _this = this;
        var url_ = this.baseUrl + "/api/admin/Videos";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(value);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processVideos_Post(_response); });
        });
    };
    Client.prototype.processVideos_Post = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.videos_GetAllUserVideos = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Videos";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processVideos_GetAllUserVideos(_response); });
        });
    };
    Client.prototype.processVideos_GetAllUserVideos = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.videos_Get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/admin/Videos/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processVideos_Get(_response); });
        });
    };
    Client.prototype.processVideos_Get = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.videos_Put = function (id, value) {
        var _this = this;
        var url_ = this.baseUrl + "/api/admin/Videos/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(value);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processVideos_Put(_response); });
        });
    };
    Client.prototype.processVideos_Put = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.videos_Delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/admin/Videos/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processVideos_Delete(_response); });
        });
    };
    Client.prototype.processVideos_Delete = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Get the Broadcast Web Links By Broadcast Ids.
     * @return OK
     */
    Client.prototype.webLink_GetBroadcastWebLinks = function (ids) {
        var _this = this;
        var url_ = this.baseUrl + "/api/WebLink/Broadcast?";
        if (ids === undefined || ids === null)
            throw new Error("The parameter 'ids' must be defined and cannot be null.");
        else
            ids && ids.forEach(function (item) { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processWebLink_GetBroadcastWebLinks(_response); });
        });
    };
    Client.prototype.processWebLink_GetBroadcastWebLinks = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Get the Video Player Web Links By Video Player Ids.
     * @return OK
     */
    Client.prototype.webLink_GetVideoPlayerWebLinks = function (ids) {
        var _this = this;
        var url_ = this.baseUrl + "/api/WebLink/VideoPlayer?";
        if (ids === undefined || ids === null)
            throw new Error("The parameter 'ids' must be defined and cannot be null.");
        else
            ids && ids.forEach(function (item) { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processWebLink_GetVideoPlayerWebLinks(_response); });
        });
    };
    Client.prototype.processWebLink_GetVideoPlayerWebLinks = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Gets the weblinks of the specified type.
     * @param type The type to query.
     * @param ids The ids to filter by.
     * @return OK
     */
    Client.prototype.webLink_Get = function (type, ids) {
        var _this = this;
        var url_ = this.baseUrl + "/api/WebLink?";
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined and cannot be null.");
        else
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (ids === undefined || ids === null)
            throw new Error("The parameter 'ids' must be defined and cannot be null.");
        else
            ids && ids.forEach(function (item) { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processWebLink_Get(_response); });
        });
    };
    Client.prototype.processWebLink_Get = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Save WebLinks based on the specified Type in the Request Object. Will be sequenced in the order they are passed in.
     * @param request The request.
     * @return OK
     */
    Client.prototype.webLink_Post = function (request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/WebLink";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processWebLink_Post(_response); });
        });
    };
    Client.prototype.processWebLink_Post = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Deletes the weblinks by the passed in Ids.
     * @param ids The ids.
     * @return OK
     */
    Client.prototype.webLink_Delete = function (ids) {
        var _this = this;
        var url_ = this.baseUrl + "/api/WebLink?";
        if (ids === undefined || ids === null)
            throw new Error("The parameter 'ids' must be defined and cannot be null.");
        else
            ids && ids.forEach(function (item) { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processWebLink_Delete(_response); });
        });
    };
    Client.prototype.processWebLink_Delete = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     * @deprecated
     */
    Client.prototype.youTube_GetYoutubeRequest = function (url) {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/YouTube/Proxy/{url}";
        if (url === undefined || url === null)
            throw new Error("The parameter 'url' must be defined.");
        url_ = url_.replace("{url}", encodeURIComponent("" + url));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processYouTube_GetYoutubeRequest(_response); });
        });
    };
    Client.prototype.processYouTube_GetYoutubeRequest = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     * @deprecated
     */
    Client.prototype.youTube_PutYoutubeRequest = function (url) {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/YouTube/Proxy/{url}";
        if (url === undefined || url === null)
            throw new Error("The parameter 'url' must be defined.");
        url_ = url_.replace("{url}", encodeURIComponent("" + url));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processYouTube_PutYoutubeRequest(_response); });
        });
    };
    Client.prototype.processYouTube_PutYoutubeRequest = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     * @deprecated
     */
    Client.prototype.youTube_PostYoutubeRequest = function (url) {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/YouTube/Proxy/{url}";
        if (url === undefined || url === null)
            throw new Error("The parameter 'url' must be defined.");
        url_ = url_.replace("{url}", encodeURIComponent("" + url));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processYouTube_PostYoutubeRequest(_response); });
        });
    };
    Client.prototype.processYouTube_PostYoutubeRequest = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     * @deprecated
     */
    Client.prototype.youTube_DeleteYoutubeRequest = function (url) {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/YouTube/Proxy/{url}";
        if (url === undefined || url === null)
            throw new Error("The parameter 'url' must be defined.");
        url_ = url_.replace("{url}", encodeURIComponent("" + url));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processYouTube_DeleteYoutubeRequest(_response); });
        });
    };
    Client.prototype.processYouTube_DeleteYoutubeRequest = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.youTube_GetCredentials = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/YouTube/Credentials";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processYouTube_GetCredentials(_response); });
        });
    };
    Client.prototype.processYouTube_GetCredentials = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.youTube_PostCredentials = function (externalAuth) {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/YouTube/Credentials";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(externalAuth);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processYouTube_PostCredentials(_response); });
        });
    };
    Client.prototype.processYouTube_PostCredentials = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.youTube_DeleteCredentials = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/YouTube/Credentials";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processYouTube_DeleteCredentials(_response); });
        });
    };
    Client.prototype.processYouTube_DeleteCredentials = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.youTube_PostStreamEnd = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/YouTube/StreamEnd";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processYouTube_PostStreamEnd(_response); });
        });
    };
    Client.prototype.processYouTube_PostStreamEnd = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.youTube_GetYouTubeStreamStatus = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/YouTube/StreamStatus";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processYouTube_GetYouTubeStreamStatus(_response); });
        });
    };
    Client.prototype.processYouTube_GetYouTubeStreamStatus = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.youTube_GetSwitcherStudioSetting = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/YouTube/SwitcherStreamSettings";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processYouTube_GetSwitcherStudioSetting(_response); });
        });
    };
    Client.prototype.processYouTube_GetSwitcherStudioSetting = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.youTube_PutYouTubeSwitcherStreamSetting = function (switcherStreamSetting) {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/YouTube/SwitcherStreamSettings";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(switcherStreamSetting);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processYouTube_PutYouTubeSwitcherStreamSetting(_response); });
        });
    };
    Client.prototype.processYouTube_PutYouTubeSwitcherStreamSetting = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return OK
     */
    Client.prototype.youTube_PostYouTubeSwitcherStreamSetting = function (switcherStreamSetting) {
        var _this = this;
        var url_ = this.baseUrl + "/api/StreamingProviders/YouTube/SwitcherStreamSettings";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(switcherStreamSetting);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processYouTube_PostYouTubeSwitcherStreamSetting(_response); });
        });
    };
    Client.prototype.processYouTube_PostYouTubeSwitcherStreamSetting = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return Client;
}(ClientBase));
export { Client };
/** The category type. */
export var CategoryType;
(function (CategoryType) {
    CategoryType[CategoryType["_0"] = 0] = "_0";
})(CategoryType || (CategoryType = {}));
export var Filter;
(function (Filter) {
    Filter[Filter["_0"] = 0] = "_0";
    Filter[Filter["_1"] = 1] = "_1";
    Filter[Filter["_2"] = 2] = "_2";
    Filter[Filter["_3"] = 3] = "_3";
    Filter[Filter["_4"] = 4] = "_4";
    Filter[Filter["_5"] = 5] = "_5";
    Filter[Filter["_6"] = 6] = "_6";
    Filter[Filter["_7"] = 7] = "_7";
})(Filter || (Filter = {}));
export var Sort;
(function (Sort) {
    Sort[Sort["_0"] = 0] = "_0";
    Sort[Sort["_1"] = 1] = "_1";
    Sort[Sort["_2"] = 2] = "_2";
})(Sort || (Sort = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder[SortOrder["_0"] = 0] = "_0";
    SortOrder[SortOrder["_1"] = 1] = "_1";
})(SortOrder || (SortOrder = {}));
export var Language;
(function (Language) {
    Language["En"] = "en";
    Language["Fr"] = "fr";
    Language["Sp"] = "sp";
})(Language || (Language = {}));
export var DeviceType;
(function (DeviceType) {
    DeviceType["IPad"] = "iPad";
    DeviceType["IPhone"] = "iPhone";
})(DeviceType || (DeviceType = {}));
export var CommunicationPreferences;
(function (CommunicationPreferences) {
    CommunicationPreferences["CanReceiveInstallAndLoginNotifications"] = "CanReceiveInstallAndLoginNotifications";
    CommunicationPreferences["CanReceiveAccountNotifications"] = "CanReceiveAccountNotifications";
    CommunicationPreferences["CanReceiveMarketingNotifications"] = "CanReceiveMarketingNotifications";
})(CommunicationPreferences || (CommunicationPreferences = {}));
/** The type to query. */
export var Type;
(function (Type) {
    Type["VideoPlayer"] = "VideoPlayer";
    Type["Broadcast"] = "Broadcast";
})(Type || (Type = {}));
export var RegisterBindingModelIndustry;
(function (RegisterBindingModelIndustry) {
    RegisterBindingModelIndustry["HoW"] = "HoW";
    RegisterBindingModelIndustry["Sports"] = "Sports";
})(RegisterBindingModelIndustry || (RegisterBindingModelIndustry = {}));
export var RegisterAdminBindingModelIndustry;
(function (RegisterAdminBindingModelIndustry) {
    RegisterAdminBindingModelIndustry["HoW"] = "HoW";
    RegisterAdminBindingModelIndustry["Sports"] = "Sports";
})(RegisterAdminBindingModelIndustry || (RegisterAdminBindingModelIndustry = {}));
export var AppleReceiptExpirationIntent;
(function (AppleReceiptExpirationIntent) {
    AppleReceiptExpirationIntent[AppleReceiptExpirationIntent["_1"] = 1] = "_1";
    AppleReceiptExpirationIntent[AppleReceiptExpirationIntent["_2"] = 2] = "_2";
    AppleReceiptExpirationIntent[AppleReceiptExpirationIntent["_3"] = 3] = "_3";
    AppleReceiptExpirationIntent[AppleReceiptExpirationIntent["_4"] = 4] = "_4";
    AppleReceiptExpirationIntent[AppleReceiptExpirationIntent["_5"] = 5] = "_5";
})(AppleReceiptExpirationIntent || (AppleReceiptExpirationIntent = {}));
export var AppleReceiptIsInBillingRetryPeriod;
(function (AppleReceiptIsInBillingRetryPeriod) {
    AppleReceiptIsInBillingRetryPeriod[AppleReceiptIsInBillingRetryPeriod["_0"] = 0] = "_0";
    AppleReceiptIsInBillingRetryPeriod[AppleReceiptIsInBillingRetryPeriod["_1"] = 1] = "_1";
})(AppleReceiptIsInBillingRetryPeriod || (AppleReceiptIsInBillingRetryPeriod = {}));
export var AppleReceiptCancellationReason;
(function (AppleReceiptCancellationReason) {
    AppleReceiptCancellationReason[AppleReceiptCancellationReason["_0"] = 0] = "_0";
    AppleReceiptCancellationReason[AppleReceiptCancellationReason["_1"] = 1] = "_1";
})(AppleReceiptCancellationReason || (AppleReceiptCancellationReason = {}));
export var AppleReceiptSubscriptionAutoRenewStatus;
(function (AppleReceiptSubscriptionAutoRenewStatus) {
    AppleReceiptSubscriptionAutoRenewStatus[AppleReceiptSubscriptionAutoRenewStatus["_0"] = 0] = "_0";
    AppleReceiptSubscriptionAutoRenewStatus[AppleReceiptSubscriptionAutoRenewStatus["_1"] = 1] = "_1";
})(AppleReceiptSubscriptionAutoRenewStatus || (AppleReceiptSubscriptionAutoRenewStatus = {}));
export var AppleReceiptSubscriptionPriceConsentStatus;
(function (AppleReceiptSubscriptionPriceConsentStatus) {
    AppleReceiptSubscriptionPriceConsentStatus[AppleReceiptSubscriptionPriceConsentStatus["_0"] = 0] = "_0";
    AppleReceiptSubscriptionPriceConsentStatus[AppleReceiptSubscriptionPriceConsentStatus["_1"] = 1] = "_1";
})(AppleReceiptSubscriptionPriceConsentStatus || (AppleReceiptSubscriptionPriceConsentStatus = {}));
export var AssetType;
(function (AssetType) {
    AssetType[AssetType["_0"] = 0] = "_0";
    AssetType[AssetType["_1"] = 1] = "_1";
    AssetType[AssetType["_2"] = 2] = "_2";
    AssetType[AssetType["_3"] = 3] = "_3";
    AssetType[AssetType["_4"] = 4] = "_4";
})(AssetType || (AssetType = {}));
export var AssetStatus;
(function (AssetStatus) {
    AssetStatus[AssetStatus["_0"] = 0] = "_0";
    AssetStatus[AssetStatus["_1"] = 1] = "_1";
    AssetStatus[AssetStatus["_2"] = 2] = "_2";
})(AssetStatus || (AssetStatus = {}));
export var AssetPostOptionsType;
(function (AssetPostOptionsType) {
    AssetPostOptionsType[AssetPostOptionsType["_0"] = 0] = "_0";
    AssetPostOptionsType[AssetPostOptionsType["_1"] = 1] = "_1";
    AssetPostOptionsType[AssetPostOptionsType["_2"] = 2] = "_2";
    AssetPostOptionsType[AssetPostOptionsType["_3"] = 3] = "_3";
    AssetPostOptionsType[AssetPostOptionsType["_4"] = 4] = "_4";
})(AssetPostOptionsType || (AssetPostOptionsType = {}));
export var BlueFrameTechSwitcherStreamSettingFacebookEdge;
(function (BlueFrameTechSwitcherStreamSettingFacebookEdge) {
    BlueFrameTechSwitcherStreamSettingFacebookEdge[BlueFrameTechSwitcherStreamSettingFacebookEdge["_0"] = 0] = "_0";
    BlueFrameTechSwitcherStreamSettingFacebookEdge[BlueFrameTechSwitcherStreamSettingFacebookEdge["_1"] = 1] = "_1";
    BlueFrameTechSwitcherStreamSettingFacebookEdge[BlueFrameTechSwitcherStreamSettingFacebookEdge["_2"] = 2] = "_2";
    BlueFrameTechSwitcherStreamSettingFacebookEdge[BlueFrameTechSwitcherStreamSettingFacebookEdge["_3"] = 3] = "_3";
})(BlueFrameTechSwitcherStreamSettingFacebookEdge || (BlueFrameTechSwitcherStreamSettingFacebookEdge = {}));
export var AssetPutOptionsType;
(function (AssetPutOptionsType) {
    AssetPutOptionsType[AssetPutOptionsType["_0"] = 0] = "_0";
    AssetPutOptionsType[AssetPutOptionsType["_1"] = 1] = "_1";
    AssetPutOptionsType[AssetPutOptionsType["_2"] = 2] = "_2";
    AssetPutOptionsType[AssetPutOptionsType["_3"] = 3] = "_3";
    AssetPutOptionsType[AssetPutOptionsType["_4"] = 4] = "_4";
})(AssetPutOptionsType || (AssetPutOptionsType = {}));
export var BrandProfileLinkSocialPlatformType;
(function (BrandProfileLinkSocialPlatformType) {
    BrandProfileLinkSocialPlatformType["None"] = "None";
    BrandProfileLinkSocialPlatformType["Facebook"] = "Facebook";
    BrandProfileLinkSocialPlatformType["LinkedIn"] = "LinkedIn";
    BrandProfileLinkSocialPlatformType["Twitch"] = "Twitch";
    BrandProfileLinkSocialPlatformType["YouTube"] = "YouTube";
    BrandProfileLinkSocialPlatformType["Instagram"] = "Instagram";
    BrandProfileLinkSocialPlatformType["Snapchat"] = "Snapchat";
    BrandProfileLinkSocialPlatformType["TikTok"] = "TikTok";
    BrandProfileLinkSocialPlatformType["Twitter"] = "Twitter";
})(BrandProfileLinkSocialPlatformType || (BrandProfileLinkSocialPlatformType = {}));
export var BroadcastType;
(function (BroadcastType) {
    BroadcastType["Default"] = "Default";
    BroadcastType["Practice"] = "Practice";
    BroadcastType["AutoSave"] = "AutoSave";
})(BroadcastType || (BroadcastType = {}));
export var BroadcastStatus;
(function (BroadcastStatus) {
    BroadcastStatus[BroadcastStatus["_0"] = 0] = "_0";
    BroadcastStatus[BroadcastStatus["_1"] = 1] = "_1";
    BroadcastStatus[BroadcastStatus["_2"] = 2] = "_2";
    BroadcastStatus[BroadcastStatus["_3"] = 3] = "_3";
    BroadcastStatus[BroadcastStatus["_4"] = 4] = "_4";
    BroadcastStatus[BroadcastStatus["_5"] = 5] = "_5";
})(BroadcastStatus || (BroadcastStatus = {}));
export var SwitcherStreamSettingFacebookEdge;
(function (SwitcherStreamSettingFacebookEdge) {
    SwitcherStreamSettingFacebookEdge[SwitcherStreamSettingFacebookEdge["_0"] = 0] = "_0";
    SwitcherStreamSettingFacebookEdge[SwitcherStreamSettingFacebookEdge["_1"] = 1] = "_1";
    SwitcherStreamSettingFacebookEdge[SwitcherStreamSettingFacebookEdge["_2"] = 2] = "_2";
    SwitcherStreamSettingFacebookEdge[SwitcherStreamSettingFacebookEdge["_3"] = 3] = "_3";
})(SwitcherStreamSettingFacebookEdge || (SwitcherStreamSettingFacebookEdge = {}));
export var categoryType;
(function (categoryType) {
    categoryType[categoryType["_0"] = 0] = "_0";
})(categoryType || (categoryType = {}));
export var SimulcastSwitcherStreamSettingFacebookEdge;
(function (SimulcastSwitcherStreamSettingFacebookEdge) {
    SimulcastSwitcherStreamSettingFacebookEdge[SimulcastSwitcherStreamSettingFacebookEdge["_0"] = 0] = "_0";
    SimulcastSwitcherStreamSettingFacebookEdge[SimulcastSwitcherStreamSettingFacebookEdge["_1"] = 1] = "_1";
    SimulcastSwitcherStreamSettingFacebookEdge[SimulcastSwitcherStreamSettingFacebookEdge["_2"] = 2] = "_2";
    SimulcastSwitcherStreamSettingFacebookEdge[SimulcastSwitcherStreamSettingFacebookEdge["_3"] = 3] = "_3";
})(SimulcastSwitcherStreamSettingFacebookEdge || (SimulcastSwitcherStreamSettingFacebookEdge = {}));
export var VideoPlayerIdleState;
(function (VideoPlayerIdleState) {
    VideoPlayerIdleState[VideoPlayerIdleState["_0"] = 0] = "_0";
    VideoPlayerIdleState[VideoPlayerIdleState["_1"] = 1] = "_1";
    VideoPlayerIdleState[VideoPlayerIdleState["_2"] = 2] = "_2";
    VideoPlayerIdleState[VideoPlayerIdleState["_3"] = 3] = "_3";
    VideoPlayerIdleState[VideoPlayerIdleState["_4"] = 4] = "_4";
})(VideoPlayerIdleState || (VideoPlayerIdleState = {}));
export var VideoPlayerDefaultCollectionTab;
(function (VideoPlayerDefaultCollectionTab) {
    VideoPlayerDefaultCollectionTab[VideoPlayerDefaultCollectionTab["_0"] = 0] = "_0";
    VideoPlayerDefaultCollectionTab[VideoPlayerDefaultCollectionTab["_1"] = 1] = "_1";
})(VideoPlayerDefaultCollectionTab || (VideoPlayerDefaultCollectionTab = {}));
export var VideoPlayerDefaultInteractiveTab;
(function (VideoPlayerDefaultInteractiveTab) {
    VideoPlayerDefaultInteractiveTab[VideoPlayerDefaultInteractiveTab["_0"] = 0] = "_0";
    VideoPlayerDefaultInteractiveTab[VideoPlayerDefaultInteractiveTab["_1"] = 1] = "_1";
    VideoPlayerDefaultInteractiveTab[VideoPlayerDefaultInteractiveTab["_2"] = 2] = "_2";
    VideoPlayerDefaultInteractiveTab[VideoPlayerDefaultInteractiveTab["_3"] = 3] = "_3";
    VideoPlayerDefaultInteractiveTab[VideoPlayerDefaultInteractiveTab["_4"] = 4] = "_4";
    VideoPlayerDefaultInteractiveTab[VideoPlayerDefaultInteractiveTab["_5"] = 5] = "_5";
})(VideoPlayerDefaultInteractiveTab || (VideoPlayerDefaultInteractiveTab = {}));
export var VideoPlayerAspectRatio;
(function (VideoPlayerAspectRatio) {
    VideoPlayerAspectRatio["SixteenByNine"] = "SixteenByNine";
    VideoPlayerAspectRatio["NineBySixteen"] = "NineBySixteen";
})(VideoPlayerAspectRatio || (VideoPlayerAspectRatio = {}));
export var VideoPlayerEmbeddedDisplay;
(function (VideoPlayerEmbeddedDisplay) {
    VideoPlayerEmbeddedDisplay[VideoPlayerEmbeddedDisplay["_0"] = 0] = "_0";
    VideoPlayerEmbeddedDisplay[VideoPlayerEmbeddedDisplay["_1"] = 1] = "_1";
    VideoPlayerEmbeddedDisplay[VideoPlayerEmbeddedDisplay["_2"] = 2] = "_2";
})(VideoPlayerEmbeddedDisplay || (VideoPlayerEmbeddedDisplay = {}));
export var SwitcherStreamSettingDetailsResponseFacebookEdge;
(function (SwitcherStreamSettingDetailsResponseFacebookEdge) {
    SwitcherStreamSettingDetailsResponseFacebookEdge[SwitcherStreamSettingDetailsResponseFacebookEdge["_0"] = 0] = "_0";
    SwitcherStreamSettingDetailsResponseFacebookEdge[SwitcherStreamSettingDetailsResponseFacebookEdge["_1"] = 1] = "_1";
    SwitcherStreamSettingDetailsResponseFacebookEdge[SwitcherStreamSettingDetailsResponseFacebookEdge["_2"] = 2] = "_2";
    SwitcherStreamSettingDetailsResponseFacebookEdge[SwitcherStreamSettingDetailsResponseFacebookEdge["_3"] = 3] = "_3";
})(SwitcherStreamSettingDetailsResponseFacebookEdge || (SwitcherStreamSettingDetailsResponseFacebookEdge = {}));
export var CreatorProductPriceEntitledDurationUnit;
(function (CreatorProductPriceEntitledDurationUnit) {
    CreatorProductPriceEntitledDurationUnit["Hours"] = "Hours";
    CreatorProductPriceEntitledDurationUnit["Days"] = "Days";
    CreatorProductPriceEntitledDurationUnit["Weeks"] = "Weeks";
})(CreatorProductPriceEntitledDurationUnit || (CreatorProductPriceEntitledDurationUnit = {}));
export var CatalogDetailsResponseDefaultInteractiveTab;
(function (CatalogDetailsResponseDefaultInteractiveTab) {
    CatalogDetailsResponseDefaultInteractiveTab[CatalogDetailsResponseDefaultInteractiveTab["_0"] = 0] = "_0";
    CatalogDetailsResponseDefaultInteractiveTab[CatalogDetailsResponseDefaultInteractiveTab["_1"] = 1] = "_1";
    CatalogDetailsResponseDefaultInteractiveTab[CatalogDetailsResponseDefaultInteractiveTab["_2"] = 2] = "_2";
    CatalogDetailsResponseDefaultInteractiveTab[CatalogDetailsResponseDefaultInteractiveTab["_3"] = 3] = "_3";
    CatalogDetailsResponseDefaultInteractiveTab[CatalogDetailsResponseDefaultInteractiveTab["_4"] = 4] = "_4";
    CatalogDetailsResponseDefaultInteractiveTab[CatalogDetailsResponseDefaultInteractiveTab["_5"] = 5] = "_5";
})(CatalogDetailsResponseDefaultInteractiveTab || (CatalogDetailsResponseDefaultInteractiveTab = {}));
export var CatalogDetailsResponseEmbeddedDisplay;
(function (CatalogDetailsResponseEmbeddedDisplay) {
    CatalogDetailsResponseEmbeddedDisplay[CatalogDetailsResponseEmbeddedDisplay["_0"] = 0] = "_0";
    CatalogDetailsResponseEmbeddedDisplay[CatalogDetailsResponseEmbeddedDisplay["_1"] = 1] = "_1";
    CatalogDetailsResponseEmbeddedDisplay[CatalogDetailsResponseEmbeddedDisplay["_2"] = 2] = "_2";
})(CatalogDetailsResponseEmbeddedDisplay || (CatalogDetailsResponseEmbeddedDisplay = {}));
export var CatalogDefaultInteractiveTab;
(function (CatalogDefaultInteractiveTab) {
    CatalogDefaultInteractiveTab[CatalogDefaultInteractiveTab["_0"] = 0] = "_0";
    CatalogDefaultInteractiveTab[CatalogDefaultInteractiveTab["_1"] = 1] = "_1";
    CatalogDefaultInteractiveTab[CatalogDefaultInteractiveTab["_2"] = 2] = "_2";
    CatalogDefaultInteractiveTab[CatalogDefaultInteractiveTab["_3"] = 3] = "_3";
    CatalogDefaultInteractiveTab[CatalogDefaultInteractiveTab["_4"] = 4] = "_4";
    CatalogDefaultInteractiveTab[CatalogDefaultInteractiveTab["_5"] = 5] = "_5";
})(CatalogDefaultInteractiveTab || (CatalogDefaultInteractiveTab = {}));
export var CatalogEmbeddedDisplay;
(function (CatalogEmbeddedDisplay) {
    CatalogEmbeddedDisplay[CatalogEmbeddedDisplay["_0"] = 0] = "_0";
    CatalogEmbeddedDisplay[CatalogEmbeddedDisplay["_1"] = 1] = "_1";
    CatalogEmbeddedDisplay[CatalogEmbeddedDisplay["_2"] = 2] = "_2";
})(CatalogEmbeddedDisplay || (CatalogEmbeddedDisplay = {}));
export var CustomSlugErrors;
(function (CustomSlugErrors) {
    CustomSlugErrors["Invalid"] = "Invalid";
    CustomSlugErrors["Duplicate"] = "Duplicate";
})(CustomSlugErrors || (CustomSlugErrors = {}));
export var ChurchStreamingTvSwitcherStreamSettingFacebookEdge;
(function (ChurchStreamingTvSwitcherStreamSettingFacebookEdge) {
    ChurchStreamingTvSwitcherStreamSettingFacebookEdge[ChurchStreamingTvSwitcherStreamSettingFacebookEdge["_0"] = 0] = "_0";
    ChurchStreamingTvSwitcherStreamSettingFacebookEdge[ChurchStreamingTvSwitcherStreamSettingFacebookEdge["_1"] = 1] = "_1";
    ChurchStreamingTvSwitcherStreamSettingFacebookEdge[ChurchStreamingTvSwitcherStreamSettingFacebookEdge["_2"] = 2] = "_2";
    ChurchStreamingTvSwitcherStreamSettingFacebookEdge[ChurchStreamingTvSwitcherStreamSettingFacebookEdge["_3"] = 3] = "_3";
})(ChurchStreamingTvSwitcherStreamSettingFacebookEdge || (ChurchStreamingTvSwitcherStreamSettingFacebookEdge = {}));
export var CouponResponseBillingProvider;
(function (CouponResponseBillingProvider) {
    CouponResponseBillingProvider["Stripe"] = "Stripe";
    CouponResponseBillingProvider["Shopfiy"] = "Shopfiy";
})(CouponResponseBillingProvider || (CouponResponseBillingProvider = {}));
export var ResellerInventoryItemStatus;
(function (ResellerInventoryItemStatus) {
    ResellerInventoryItemStatus[ResellerInventoryItemStatus["_0"] = 0] = "_0";
    ResellerInventoryItemStatus[ResellerInventoryItemStatus["_1"] = 1] = "_1";
    ResellerInventoryItemStatus[ResellerInventoryItemStatus["_2"] = 2] = "_2";
    ResellerInventoryItemStatus[ResellerInventoryItemStatus["_3"] = 3] = "_3";
    ResellerInventoryItemStatus[ResellerInventoryItemStatus["_4"] = 4] = "_4";
})(ResellerInventoryItemStatus || (ResellerInventoryItemStatus = {}));
export var ResellerInventoryBillingProvider;
(function (ResellerInventoryBillingProvider) {
    ResellerInventoryBillingProvider["Stripe"] = "Stripe";
    ResellerInventoryBillingProvider["Shopfiy"] = "Shopfiy";
})(ResellerInventoryBillingProvider || (ResellerInventoryBillingProvider = {}));
export var CreatorCheckoutMetadataEntityType;
(function (CreatorCheckoutMetadataEntityType) {
    CreatorCheckoutMetadataEntityType[CreatorCheckoutMetadataEntityType["_0"] = 0] = "_0";
    CreatorCheckoutMetadataEntityType[CreatorCheckoutMetadataEntityType["_1"] = 1] = "_1";
    CreatorCheckoutMetadataEntityType[CreatorCheckoutMetadataEntityType["_2"] = 2] = "_2";
})(CreatorCheckoutMetadataEntityType || (CreatorCheckoutMetadataEntityType = {}));
export var EmailAccessRequestEntityType;
(function (EmailAccessRequestEntityType) {
    EmailAccessRequestEntityType[EmailAccessRequestEntityType["_0"] = 0] = "_0";
    EmailAccessRequestEntityType[EmailAccessRequestEntityType["_1"] = 1] = "_1";
    EmailAccessRequestEntityType[EmailAccessRequestEntityType["_2"] = 2] = "_2";
})(EmailAccessRequestEntityType || (EmailAccessRequestEntityType = {}));
export var CreatorProductEntitlementsBindingModelDiscriminator;
(function (CreatorProductEntitlementsBindingModelDiscriminator) {
    CreatorProductEntitlementsBindingModelDiscriminator[CreatorProductEntitlementsBindingModelDiscriminator["_0"] = 0] = "_0";
    CreatorProductEntitlementsBindingModelDiscriminator[CreatorProductEntitlementsBindingModelDiscriminator["_1"] = 1] = "_1";
    CreatorProductEntitlementsBindingModelDiscriminator[CreatorProductEntitlementsBindingModelDiscriminator["_2"] = 2] = "_2";
    CreatorProductEntitlementsBindingModelDiscriminator[CreatorProductEntitlementsBindingModelDiscriminator["_3"] = 3] = "_3";
})(CreatorProductEntitlementsBindingModelDiscriminator || (CreatorProductEntitlementsBindingModelDiscriminator = {}));
export var CreatorProductPricesBindingModelEntitledDurationUnit;
(function (CreatorProductPricesBindingModelEntitledDurationUnit) {
    CreatorProductPricesBindingModelEntitledDurationUnit["Hours"] = "Hours";
    CreatorProductPricesBindingModelEntitledDurationUnit["Days"] = "Days";
    CreatorProductPricesBindingModelEntitledDurationUnit["Weeks"] = "Weeks";
})(CreatorProductPricesBindingModelEntitledDurationUnit || (CreatorProductPricesBindingModelEntitledDurationUnit = {}));
export var CustomerRedemptionSummarySourceType;
(function (CustomerRedemptionSummarySourceType) {
    CustomerRedemptionSummarySourceType[CustomerRedemptionSummarySourceType["_0"] = 0] = "_0";
    CustomerRedemptionSummarySourceType[CustomerRedemptionSummarySourceType["_1"] = 1] = "_1";
    CustomerRedemptionSummarySourceType[CustomerRedemptionSummarySourceType["_2"] = 2] = "_2";
})(CustomerRedemptionSummarySourceType || (CustomerRedemptionSummarySourceType = {}));
export var CustomerRedemptionSummaryRedemptionType;
(function (CustomerRedemptionSummaryRedemptionType) {
    CustomerRedemptionSummaryRedemptionType[CustomerRedemptionSummaryRedemptionType["_0"] = 0] = "_0";
    CustomerRedemptionSummaryRedemptionType[CustomerRedemptionSummaryRedemptionType["_1"] = 1] = "_1";
    CustomerRedemptionSummaryRedemptionType[CustomerRedemptionSummaryRedemptionType["_2"] = 2] = "_2";
    CustomerRedemptionSummaryRedemptionType[CustomerRedemptionSummaryRedemptionType["_3"] = 3] = "_3";
})(CustomerRedemptionSummaryRedemptionType || (CustomerRedemptionSummaryRedemptionType = {}));
export var JsonSerializerSettingsReferenceLoopHandling;
(function (JsonSerializerSettingsReferenceLoopHandling) {
    JsonSerializerSettingsReferenceLoopHandling[JsonSerializerSettingsReferenceLoopHandling["_0"] = 0] = "_0";
    JsonSerializerSettingsReferenceLoopHandling[JsonSerializerSettingsReferenceLoopHandling["_1"] = 1] = "_1";
    JsonSerializerSettingsReferenceLoopHandling[JsonSerializerSettingsReferenceLoopHandling["_2"] = 2] = "_2";
})(JsonSerializerSettingsReferenceLoopHandling || (JsonSerializerSettingsReferenceLoopHandling = {}));
export var JsonSerializerSettingsMissingMemberHandling;
(function (JsonSerializerSettingsMissingMemberHandling) {
    JsonSerializerSettingsMissingMemberHandling[JsonSerializerSettingsMissingMemberHandling["_0"] = 0] = "_0";
    JsonSerializerSettingsMissingMemberHandling[JsonSerializerSettingsMissingMemberHandling["_1"] = 1] = "_1";
})(JsonSerializerSettingsMissingMemberHandling || (JsonSerializerSettingsMissingMemberHandling = {}));
export var JsonSerializerSettingsObjectCreationHandling;
(function (JsonSerializerSettingsObjectCreationHandling) {
    JsonSerializerSettingsObjectCreationHandling[JsonSerializerSettingsObjectCreationHandling["_0"] = 0] = "_0";
    JsonSerializerSettingsObjectCreationHandling[JsonSerializerSettingsObjectCreationHandling["_1"] = 1] = "_1";
    JsonSerializerSettingsObjectCreationHandling[JsonSerializerSettingsObjectCreationHandling["_2"] = 2] = "_2";
})(JsonSerializerSettingsObjectCreationHandling || (JsonSerializerSettingsObjectCreationHandling = {}));
export var JsonSerializerSettingsNullValueHandling;
(function (JsonSerializerSettingsNullValueHandling) {
    JsonSerializerSettingsNullValueHandling[JsonSerializerSettingsNullValueHandling["_0"] = 0] = "_0";
    JsonSerializerSettingsNullValueHandling[JsonSerializerSettingsNullValueHandling["_1"] = 1] = "_1";
})(JsonSerializerSettingsNullValueHandling || (JsonSerializerSettingsNullValueHandling = {}));
export var JsonSerializerSettingsDefaultValueHandling;
(function (JsonSerializerSettingsDefaultValueHandling) {
    JsonSerializerSettingsDefaultValueHandling[JsonSerializerSettingsDefaultValueHandling["_0"] = 0] = "_0";
    JsonSerializerSettingsDefaultValueHandling[JsonSerializerSettingsDefaultValueHandling["_1"] = 1] = "_1";
    JsonSerializerSettingsDefaultValueHandling[JsonSerializerSettingsDefaultValueHandling["_2"] = 2] = "_2";
    JsonSerializerSettingsDefaultValueHandling[JsonSerializerSettingsDefaultValueHandling["_3"] = 3] = "_3";
})(JsonSerializerSettingsDefaultValueHandling || (JsonSerializerSettingsDefaultValueHandling = {}));
export var JsonSerializerSettingsPreserveReferencesHandling;
(function (JsonSerializerSettingsPreserveReferencesHandling) {
    JsonSerializerSettingsPreserveReferencesHandling[JsonSerializerSettingsPreserveReferencesHandling["_0"] = 0] = "_0";
    JsonSerializerSettingsPreserveReferencesHandling[JsonSerializerSettingsPreserveReferencesHandling["_1"] = 1] = "_1";
    JsonSerializerSettingsPreserveReferencesHandling[JsonSerializerSettingsPreserveReferencesHandling["_2"] = 2] = "_2";
    JsonSerializerSettingsPreserveReferencesHandling[JsonSerializerSettingsPreserveReferencesHandling["_3"] = 3] = "_3";
})(JsonSerializerSettingsPreserveReferencesHandling || (JsonSerializerSettingsPreserveReferencesHandling = {}));
export var JsonSerializerSettingsTypeNameHandling;
(function (JsonSerializerSettingsTypeNameHandling) {
    JsonSerializerSettingsTypeNameHandling[JsonSerializerSettingsTypeNameHandling["_0"] = 0] = "_0";
    JsonSerializerSettingsTypeNameHandling[JsonSerializerSettingsTypeNameHandling["_1"] = 1] = "_1";
    JsonSerializerSettingsTypeNameHandling[JsonSerializerSettingsTypeNameHandling["_2"] = 2] = "_2";
    JsonSerializerSettingsTypeNameHandling[JsonSerializerSettingsTypeNameHandling["_3"] = 3] = "_3";
    JsonSerializerSettingsTypeNameHandling[JsonSerializerSettingsTypeNameHandling["_4"] = 4] = "_4";
})(JsonSerializerSettingsTypeNameHandling || (JsonSerializerSettingsTypeNameHandling = {}));
export var JsonSerializerSettingsMetadataPropertyHandling;
(function (JsonSerializerSettingsMetadataPropertyHandling) {
    JsonSerializerSettingsMetadataPropertyHandling[JsonSerializerSettingsMetadataPropertyHandling["_0"] = 0] = "_0";
    JsonSerializerSettingsMetadataPropertyHandling[JsonSerializerSettingsMetadataPropertyHandling["_1"] = 1] = "_1";
    JsonSerializerSettingsMetadataPropertyHandling[JsonSerializerSettingsMetadataPropertyHandling["_2"] = 2] = "_2";
})(JsonSerializerSettingsMetadataPropertyHandling || (JsonSerializerSettingsMetadataPropertyHandling = {}));
export var JsonSerializerSettingsTypeNameAssemblyFormat;
(function (JsonSerializerSettingsTypeNameAssemblyFormat) {
    JsonSerializerSettingsTypeNameAssemblyFormat[JsonSerializerSettingsTypeNameAssemblyFormat["_0"] = 0] = "_0";
    JsonSerializerSettingsTypeNameAssemblyFormat[JsonSerializerSettingsTypeNameAssemblyFormat["_1"] = 1] = "_1";
})(JsonSerializerSettingsTypeNameAssemblyFormat || (JsonSerializerSettingsTypeNameAssemblyFormat = {}));
export var JsonSerializerSettingsTypeNameAssemblyFormatHandling;
(function (JsonSerializerSettingsTypeNameAssemblyFormatHandling) {
    JsonSerializerSettingsTypeNameAssemblyFormatHandling[JsonSerializerSettingsTypeNameAssemblyFormatHandling["_0"] = 0] = "_0";
    JsonSerializerSettingsTypeNameAssemblyFormatHandling[JsonSerializerSettingsTypeNameAssemblyFormatHandling["_1"] = 1] = "_1";
})(JsonSerializerSettingsTypeNameAssemblyFormatHandling || (JsonSerializerSettingsTypeNameAssemblyFormatHandling = {}));
export var JsonSerializerSettingsConstructorHandling;
(function (JsonSerializerSettingsConstructorHandling) {
    JsonSerializerSettingsConstructorHandling[JsonSerializerSettingsConstructorHandling["_0"] = 0] = "_0";
    JsonSerializerSettingsConstructorHandling[JsonSerializerSettingsConstructorHandling["_1"] = 1] = "_1";
})(JsonSerializerSettingsConstructorHandling || (JsonSerializerSettingsConstructorHandling = {}));
export var JsonSerializerSettingsFormatting;
(function (JsonSerializerSettingsFormatting) {
    JsonSerializerSettingsFormatting[JsonSerializerSettingsFormatting["_0"] = 0] = "_0";
    JsonSerializerSettingsFormatting[JsonSerializerSettingsFormatting["_1"] = 1] = "_1";
})(JsonSerializerSettingsFormatting || (JsonSerializerSettingsFormatting = {}));
export var JsonSerializerSettingsDateFormatHandling;
(function (JsonSerializerSettingsDateFormatHandling) {
    JsonSerializerSettingsDateFormatHandling[JsonSerializerSettingsDateFormatHandling["_0"] = 0] = "_0";
    JsonSerializerSettingsDateFormatHandling[JsonSerializerSettingsDateFormatHandling["_1"] = 1] = "_1";
})(JsonSerializerSettingsDateFormatHandling || (JsonSerializerSettingsDateFormatHandling = {}));
export var JsonSerializerSettingsDateTimeZoneHandling;
(function (JsonSerializerSettingsDateTimeZoneHandling) {
    JsonSerializerSettingsDateTimeZoneHandling[JsonSerializerSettingsDateTimeZoneHandling["_0"] = 0] = "_0";
    JsonSerializerSettingsDateTimeZoneHandling[JsonSerializerSettingsDateTimeZoneHandling["_1"] = 1] = "_1";
    JsonSerializerSettingsDateTimeZoneHandling[JsonSerializerSettingsDateTimeZoneHandling["_2"] = 2] = "_2";
    JsonSerializerSettingsDateTimeZoneHandling[JsonSerializerSettingsDateTimeZoneHandling["_3"] = 3] = "_3";
})(JsonSerializerSettingsDateTimeZoneHandling || (JsonSerializerSettingsDateTimeZoneHandling = {}));
export var JsonSerializerSettingsDateParseHandling;
(function (JsonSerializerSettingsDateParseHandling) {
    JsonSerializerSettingsDateParseHandling[JsonSerializerSettingsDateParseHandling["_0"] = 0] = "_0";
    JsonSerializerSettingsDateParseHandling[JsonSerializerSettingsDateParseHandling["_1"] = 1] = "_1";
    JsonSerializerSettingsDateParseHandling[JsonSerializerSettingsDateParseHandling["_2"] = 2] = "_2";
})(JsonSerializerSettingsDateParseHandling || (JsonSerializerSettingsDateParseHandling = {}));
export var JsonSerializerSettingsFloatFormatHandling;
(function (JsonSerializerSettingsFloatFormatHandling) {
    JsonSerializerSettingsFloatFormatHandling[JsonSerializerSettingsFloatFormatHandling["_0"] = 0] = "_0";
    JsonSerializerSettingsFloatFormatHandling[JsonSerializerSettingsFloatFormatHandling["_1"] = 1] = "_1";
    JsonSerializerSettingsFloatFormatHandling[JsonSerializerSettingsFloatFormatHandling["_2"] = 2] = "_2";
})(JsonSerializerSettingsFloatFormatHandling || (JsonSerializerSettingsFloatFormatHandling = {}));
export var JsonSerializerSettingsFloatParseHandling;
(function (JsonSerializerSettingsFloatParseHandling) {
    JsonSerializerSettingsFloatParseHandling[JsonSerializerSettingsFloatParseHandling["_0"] = 0] = "_0";
    JsonSerializerSettingsFloatParseHandling[JsonSerializerSettingsFloatParseHandling["_1"] = 1] = "_1";
})(JsonSerializerSettingsFloatParseHandling || (JsonSerializerSettingsFloatParseHandling = {}));
export var JsonSerializerSettingsStringEscapeHandling;
(function (JsonSerializerSettingsStringEscapeHandling) {
    JsonSerializerSettingsStringEscapeHandling[JsonSerializerSettingsStringEscapeHandling["_0"] = 0] = "_0";
    JsonSerializerSettingsStringEscapeHandling[JsonSerializerSettingsStringEscapeHandling["_1"] = 1] = "_1";
    JsonSerializerSettingsStringEscapeHandling[JsonSerializerSettingsStringEscapeHandling["_2"] = 2] = "_2";
})(JsonSerializerSettingsStringEscapeHandling || (JsonSerializerSettingsStringEscapeHandling = {}));
export var ITraceWriterLevelFilter;
(function (ITraceWriterLevelFilter) {
    ITraceWriterLevelFilter[ITraceWriterLevelFilter["_0"] = 0] = "_0";
    ITraceWriterLevelFilter[ITraceWriterLevelFilter["_1"] = 1] = "_1";
    ITraceWriterLevelFilter[ITraceWriterLevelFilter["_2"] = 2] = "_2";
    ITraceWriterLevelFilter[ITraceWriterLevelFilter["_3"] = 3] = "_3";
    ITraceWriterLevelFilter[ITraceWriterLevelFilter["_4"] = 4] = "_4";
})(ITraceWriterLevelFilter || (ITraceWriterLevelFilter = {}));
export var StreamingContextM_state;
(function (StreamingContextM_state) {
    StreamingContextM_state[StreamingContextM_state["_1"] = 1] = "_1";
    StreamingContextM_state[StreamingContextM_state["_2"] = 2] = "_2";
    StreamingContextM_state[StreamingContextM_state["_4"] = 4] = "_4";
    StreamingContextM_state[StreamingContextM_state["_8"] = 8] = "_8";
    StreamingContextM_state[StreamingContextM_state["_16"] = 16] = "_16";
    StreamingContextM_state[StreamingContextM_state["_32"] = 32] = "_32";
    StreamingContextM_state[StreamingContextM_state["_64"] = 64] = "_64";
    StreamingContextM_state[StreamingContextM_state["_128"] = 128] = "_128";
    StreamingContextM_state[StreamingContextM_state["_255"] = 255] = "_255";
})(StreamingContextM_state || (StreamingContextM_state = {}));
export var ExternalProviderSwitcherStreamSettingFacebookEdge;
(function (ExternalProviderSwitcherStreamSettingFacebookEdge) {
    ExternalProviderSwitcherStreamSettingFacebookEdge[ExternalProviderSwitcherStreamSettingFacebookEdge["_0"] = 0] = "_0";
    ExternalProviderSwitcherStreamSettingFacebookEdge[ExternalProviderSwitcherStreamSettingFacebookEdge["_1"] = 1] = "_1";
    ExternalProviderSwitcherStreamSettingFacebookEdge[ExternalProviderSwitcherStreamSettingFacebookEdge["_2"] = 2] = "_2";
    ExternalProviderSwitcherStreamSettingFacebookEdge[ExternalProviderSwitcherStreamSettingFacebookEdge["_3"] = 3] = "_3";
})(ExternalProviderSwitcherStreamSettingFacebookEdge || (ExternalProviderSwitcherStreamSettingFacebookEdge = {}));
export var FaceBookSwitcherStreamSettingFacebookEdge;
(function (FaceBookSwitcherStreamSettingFacebookEdge) {
    FaceBookSwitcherStreamSettingFacebookEdge[FaceBookSwitcherStreamSettingFacebookEdge["_0"] = 0] = "_0";
    FaceBookSwitcherStreamSettingFacebookEdge[FaceBookSwitcherStreamSettingFacebookEdge["_1"] = 1] = "_1";
    FaceBookSwitcherStreamSettingFacebookEdge[FaceBookSwitcherStreamSettingFacebookEdge["_2"] = 2] = "_2";
    FaceBookSwitcherStreamSettingFacebookEdge[FaceBookSwitcherStreamSettingFacebookEdge["_3"] = 3] = "_3";
})(FaceBookSwitcherStreamSettingFacebookEdge || (FaceBookSwitcherStreamSettingFacebookEdge = {}));
export var LinkedInSwitcherStreamSettingFacebookEdge;
(function (LinkedInSwitcherStreamSettingFacebookEdge) {
    LinkedInSwitcherStreamSettingFacebookEdge[LinkedInSwitcherStreamSettingFacebookEdge["_0"] = 0] = "_0";
    LinkedInSwitcherStreamSettingFacebookEdge[LinkedInSwitcherStreamSettingFacebookEdge["_1"] = 1] = "_1";
    LinkedInSwitcherStreamSettingFacebookEdge[LinkedInSwitcherStreamSettingFacebookEdge["_2"] = 2] = "_2";
    LinkedInSwitcherStreamSettingFacebookEdge[LinkedInSwitcherStreamSettingFacebookEdge["_3"] = 3] = "_3";
})(LinkedInSwitcherStreamSettingFacebookEdge || (LinkedInSwitcherStreamSettingFacebookEdge = {}));
export var RevenueMetricsRequestSummaryInterval;
(function (RevenueMetricsRequestSummaryInterval) {
    RevenueMetricsRequestSummaryInterval["Lifetime"] = "Lifetime";
    RevenueMetricsRequestSummaryInterval["Year"] = "Year";
    RevenueMetricsRequestSummaryInterval["Month"] = "Month";
    RevenueMetricsRequestSummaryInterval["Day"] = "Day";
    RevenueMetricsRequestSummaryInterval["Hour"] = "Hour";
})(RevenueMetricsRequestSummaryInterval || (RevenueMetricsRequestSummaryInterval = {}));
export var ShopifyPricePlanType;
(function (ShopifyPricePlanType) {
    ShopifyPricePlanType[ShopifyPricePlanType["_0"] = 0] = "_0";
    ShopifyPricePlanType[ShopifyPricePlanType["_1"] = 1] = "_1";
})(ShopifyPricePlanType || (ShopifyPricePlanType = {}));
export var GetStoreByIdResponseOnboardingStatus;
(function (GetStoreByIdResponseOnboardingStatus) {
    GetStoreByIdResponseOnboardingStatus[GetStoreByIdResponseOnboardingStatus["_0"] = 0] = "_0";
    GetStoreByIdResponseOnboardingStatus[GetStoreByIdResponseOnboardingStatus["_1"] = 1] = "_1";
    GetStoreByIdResponseOnboardingStatus[GetStoreByIdResponseOnboardingStatus["_2"] = 2] = "_2";
    GetStoreByIdResponseOnboardingStatus[GetStoreByIdResponseOnboardingStatus["_3"] = 3] = "_3";
    GetStoreByIdResponseOnboardingStatus[GetStoreByIdResponseOnboardingStatus["_4"] = 4] = "_4";
    GetStoreByIdResponseOnboardingStatus[GetStoreByIdResponseOnboardingStatus["_5"] = 5] = "_5";
})(GetStoreByIdResponseOnboardingStatus || (GetStoreByIdResponseOnboardingStatus = {}));
export var ShopifySubscriptionStatus;
(function (ShopifySubscriptionStatus) {
    ShopifySubscriptionStatus[ShopifySubscriptionStatus["_0"] = 0] = "_0";
    ShopifySubscriptionStatus[ShopifySubscriptionStatus["_1"] = 1] = "_1";
    ShopifySubscriptionStatus[ShopifySubscriptionStatus["_2"] = 2] = "_2";
    ShopifySubscriptionStatus[ShopifySubscriptionStatus["_3"] = 3] = "_3";
    ShopifySubscriptionStatus[ShopifySubscriptionStatus["_4"] = 4] = "_4";
    ShopifySubscriptionStatus[ShopifySubscriptionStatus["_5"] = 5] = "_5";
})(ShopifySubscriptionStatus || (ShopifySubscriptionStatus = {}));
export var StreamingProviderType;
(function (StreamingProviderType) {
    StreamingProviderType[StreamingProviderType["_0"] = 0] = "_0";
    StreamingProviderType[StreamingProviderType["_1"] = 1] = "_1";
})(StreamingProviderType || (StreamingProviderType = {}));
export var StreamSpotSwitcherStreamSettingFacebookEdge;
(function (StreamSpotSwitcherStreamSettingFacebookEdge) {
    StreamSpotSwitcherStreamSettingFacebookEdge[StreamSpotSwitcherStreamSettingFacebookEdge["_0"] = 0] = "_0";
    StreamSpotSwitcherStreamSettingFacebookEdge[StreamSpotSwitcherStreamSettingFacebookEdge["_1"] = 1] = "_1";
    StreamSpotSwitcherStreamSettingFacebookEdge[StreamSpotSwitcherStreamSettingFacebookEdge["_2"] = 2] = "_2";
    StreamSpotSwitcherStreamSettingFacebookEdge[StreamSpotSwitcherStreamSettingFacebookEdge["_3"] = 3] = "_3";
})(StreamSpotSwitcherStreamSettingFacebookEdge || (StreamSpotSwitcherStreamSettingFacebookEdge = {}));
export var SwitchboardSwitcherStreamSettingFacebookEdge;
(function (SwitchboardSwitcherStreamSettingFacebookEdge) {
    SwitchboardSwitcherStreamSettingFacebookEdge[SwitchboardSwitcherStreamSettingFacebookEdge["_0"] = 0] = "_0";
    SwitchboardSwitcherStreamSettingFacebookEdge[SwitchboardSwitcherStreamSettingFacebookEdge["_1"] = 1] = "_1";
    SwitchboardSwitcherStreamSettingFacebookEdge[SwitchboardSwitcherStreamSettingFacebookEdge["_2"] = 2] = "_2";
    SwitchboardSwitcherStreamSettingFacebookEdge[SwitchboardSwitcherStreamSettingFacebookEdge["_3"] = 3] = "_3";
})(SwitchboardSwitcherStreamSettingFacebookEdge || (SwitchboardSwitcherStreamSettingFacebookEdge = {}));
export var TutorialCollectionDevice;
(function (TutorialCollectionDevice) {
    TutorialCollectionDevice["IPad"] = "iPad";
    TutorialCollectionDevice["IPhone"] = "iPhone";
})(TutorialCollectionDevice || (TutorialCollectionDevice = {}));
export var TutorialCollectionLanguage;
(function (TutorialCollectionLanguage) {
    TutorialCollectionLanguage["En"] = "en";
    TutorialCollectionLanguage["Fr"] = "fr";
    TutorialCollectionLanguage["Sp"] = "sp";
})(TutorialCollectionLanguage || (TutorialCollectionLanguage = {}));
export var ITutorialContentContentType;
(function (ITutorialContentContentType) {
    ITutorialContentContentType["Video"] = "Video";
    ITutorialContentContentType["Text"] = "Text";
})(ITutorialContentContentType || (ITutorialContentContentType = {}));
export var communicationPreferences;
(function (communicationPreferences) {
    communicationPreferences["CanReceiveInstallAndLoginNotifications"] = "CanReceiveInstallAndLoginNotifications";
    communicationPreferences["CanReceiveAccountNotifications"] = "CanReceiveAccountNotifications";
    communicationPreferences["CanReceiveMarketingNotifications"] = "CanReceiveMarketingNotifications";
})(communicationPreferences || (communicationPreferences = {}));
export var TwilioBindingCreateOptionsBindingType;
(function (TwilioBindingCreateOptionsBindingType) {
    TwilioBindingCreateOptionsBindingType["Apn"] = "apn";
    TwilioBindingCreateOptionsBindingType["Fcm"] = "fcm";
    TwilioBindingCreateOptionsBindingType["Gmc"] = "gmc";
    TwilioBindingCreateOptionsBindingType["Sms"] = "sms";
    TwilioBindingCreateOptionsBindingType["FacebookMessenger"] = "facebook-messenger";
})(TwilioBindingCreateOptionsBindingType || (TwilioBindingCreateOptionsBindingType = {}));
export var communicationPreferences2;
(function (communicationPreferences2) {
    communicationPreferences2["CanReceiveInstallAndLoginNotifications"] = "CanReceiveInstallAndLoginNotifications";
    communicationPreferences2["CanReceiveAccountNotifications"] = "CanReceiveAccountNotifications";
    communicationPreferences2["CanReceiveMarketingNotifications"] = "CanReceiveMarketingNotifications";
})(communicationPreferences2 || (communicationPreferences2 = {}));
export var communicationPreferences3;
(function (communicationPreferences3) {
    communicationPreferences3["CanReceiveInstallAndLoginNotifications"] = "CanReceiveInstallAndLoginNotifications";
    communicationPreferences3["CanReceiveAccountNotifications"] = "CanReceiveAccountNotifications";
    communicationPreferences3["CanReceiveMarketingNotifications"] = "CanReceiveMarketingNotifications";
})(communicationPreferences3 || (communicationPreferences3 = {}));
export var TwilioBindingPutOptionsBindingType;
(function (TwilioBindingPutOptionsBindingType) {
    TwilioBindingPutOptionsBindingType["Apn"] = "apn";
    TwilioBindingPutOptionsBindingType["Fcm"] = "fcm";
    TwilioBindingPutOptionsBindingType["Gmc"] = "gmc";
    TwilioBindingPutOptionsBindingType["Sms"] = "sms";
    TwilioBindingPutOptionsBindingType["FacebookMessenger"] = "facebook-messenger";
})(TwilioBindingPutOptionsBindingType || (TwilioBindingPutOptionsBindingType = {}));
export var communicationPreferences4;
(function (communicationPreferences4) {
    communicationPreferences4["CanReceiveInstallAndLoginNotifications"] = "CanReceiveInstallAndLoginNotifications";
    communicationPreferences4["CanReceiveAccountNotifications"] = "CanReceiveAccountNotifications";
    communicationPreferences4["CanReceiveMarketingNotifications"] = "CanReceiveMarketingNotifications";
})(communicationPreferences4 || (communicationPreferences4 = {}));
export var VideoRoomStatus;
(function (VideoRoomStatus) {
    VideoRoomStatus[VideoRoomStatus["_0"] = 0] = "_0";
    VideoRoomStatus[VideoRoomStatus["_1"] = 1] = "_1";
})(VideoRoomStatus || (VideoRoomStatus = {}));
export var TwitchSwitcherStreamSettingFacebookEdge;
(function (TwitchSwitcherStreamSettingFacebookEdge) {
    TwitchSwitcherStreamSettingFacebookEdge[TwitchSwitcherStreamSettingFacebookEdge["_0"] = 0] = "_0";
    TwitchSwitcherStreamSettingFacebookEdge[TwitchSwitcherStreamSettingFacebookEdge["_1"] = 1] = "_1";
    TwitchSwitcherStreamSettingFacebookEdge[TwitchSwitcherStreamSettingFacebookEdge["_2"] = 2] = "_2";
    TwitchSwitcherStreamSettingFacebookEdge[TwitchSwitcherStreamSettingFacebookEdge["_3"] = 3] = "_3";
})(TwitchSwitcherStreamSettingFacebookEdge || (TwitchSwitcherStreamSettingFacebookEdge = {}));
export var VideoMetricsRequestSummaryInterval;
(function (VideoMetricsRequestSummaryInterval) {
    VideoMetricsRequestSummaryInterval["Lifetime"] = "Lifetime";
    VideoMetricsRequestSummaryInterval["Year"] = "Year";
    VideoMetricsRequestSummaryInterval["Month"] = "Month";
    VideoMetricsRequestSummaryInterval["Day"] = "Day";
    VideoMetricsRequestSummaryInterval["Hour"] = "Hour";
})(VideoMetricsRequestSummaryInterval || (VideoMetricsRequestSummaryInterval = {}));
export var VideoPlayerSwitcherStreamSettingFacebookEdge;
(function (VideoPlayerSwitcherStreamSettingFacebookEdge) {
    VideoPlayerSwitcherStreamSettingFacebookEdge[VideoPlayerSwitcherStreamSettingFacebookEdge["_0"] = 0] = "_0";
    VideoPlayerSwitcherStreamSettingFacebookEdge[VideoPlayerSwitcherStreamSettingFacebookEdge["_1"] = 1] = "_1";
    VideoPlayerSwitcherStreamSettingFacebookEdge[VideoPlayerSwitcherStreamSettingFacebookEdge["_2"] = 2] = "_2";
    VideoPlayerSwitcherStreamSettingFacebookEdge[VideoPlayerSwitcherStreamSettingFacebookEdge["_3"] = 3] = "_3";
})(VideoPlayerSwitcherStreamSettingFacebookEdge || (VideoPlayerSwitcherStreamSettingFacebookEdge = {}));
export var BroadcastDetailsResponseBroadcastStatus;
(function (BroadcastDetailsResponseBroadcastStatus) {
    BroadcastDetailsResponseBroadcastStatus[BroadcastDetailsResponseBroadcastStatus["_0"] = 0] = "_0";
    BroadcastDetailsResponseBroadcastStatus[BroadcastDetailsResponseBroadcastStatus["_1"] = 1] = "_1";
    BroadcastDetailsResponseBroadcastStatus[BroadcastDetailsResponseBroadcastStatus["_2"] = 2] = "_2";
    BroadcastDetailsResponseBroadcastStatus[BroadcastDetailsResponseBroadcastStatus["_3"] = 3] = "_3";
    BroadcastDetailsResponseBroadcastStatus[BroadcastDetailsResponseBroadcastStatus["_4"] = 4] = "_4";
    BroadcastDetailsResponseBroadcastStatus[BroadcastDetailsResponseBroadcastStatus["_5"] = 5] = "_5";
})(BroadcastDetailsResponseBroadcastStatus || (BroadcastDetailsResponseBroadcastStatus = {}));
export var VideoPlayerEntitlementResponseIdleState;
(function (VideoPlayerEntitlementResponseIdleState) {
    VideoPlayerEntitlementResponseIdleState[VideoPlayerEntitlementResponseIdleState["_0"] = 0] = "_0";
    VideoPlayerEntitlementResponseIdleState[VideoPlayerEntitlementResponseIdleState["_1"] = 1] = "_1";
    VideoPlayerEntitlementResponseIdleState[VideoPlayerEntitlementResponseIdleState["_2"] = 2] = "_2";
    VideoPlayerEntitlementResponseIdleState[VideoPlayerEntitlementResponseIdleState["_3"] = 3] = "_3";
    VideoPlayerEntitlementResponseIdleState[VideoPlayerEntitlementResponseIdleState["_4"] = 4] = "_4";
})(VideoPlayerEntitlementResponseIdleState || (VideoPlayerEntitlementResponseIdleState = {}));
export var VideoPlayerEntitlementResponseDefaultInteractiveTab;
(function (VideoPlayerEntitlementResponseDefaultInteractiveTab) {
    VideoPlayerEntitlementResponseDefaultInteractiveTab[VideoPlayerEntitlementResponseDefaultInteractiveTab["_0"] = 0] = "_0";
    VideoPlayerEntitlementResponseDefaultInteractiveTab[VideoPlayerEntitlementResponseDefaultInteractiveTab["_1"] = 1] = "_1";
    VideoPlayerEntitlementResponseDefaultInteractiveTab[VideoPlayerEntitlementResponseDefaultInteractiveTab["_2"] = 2] = "_2";
    VideoPlayerEntitlementResponseDefaultInteractiveTab[VideoPlayerEntitlementResponseDefaultInteractiveTab["_3"] = 3] = "_3";
    VideoPlayerEntitlementResponseDefaultInteractiveTab[VideoPlayerEntitlementResponseDefaultInteractiveTab["_4"] = 4] = "_4";
    VideoPlayerEntitlementResponseDefaultInteractiveTab[VideoPlayerEntitlementResponseDefaultInteractiveTab["_5"] = 5] = "_5";
})(VideoPlayerEntitlementResponseDefaultInteractiveTab || (VideoPlayerEntitlementResponseDefaultInteractiveTab = {}));
export var VideoPlayerEntitlementResponseAspectRatio;
(function (VideoPlayerEntitlementResponseAspectRatio) {
    VideoPlayerEntitlementResponseAspectRatio["SixteenByNine"] = "SixteenByNine";
    VideoPlayerEntitlementResponseAspectRatio["NineBySixteen"] = "NineBySixteen";
})(VideoPlayerEntitlementResponseAspectRatio || (VideoPlayerEntitlementResponseAspectRatio = {}));
export var VideoPlayerEntitlementResponseEmbeddedDisplay;
(function (VideoPlayerEntitlementResponseEmbeddedDisplay) {
    VideoPlayerEntitlementResponseEmbeddedDisplay[VideoPlayerEntitlementResponseEmbeddedDisplay["_0"] = 0] = "_0";
    VideoPlayerEntitlementResponseEmbeddedDisplay[VideoPlayerEntitlementResponseEmbeddedDisplay["_1"] = 1] = "_1";
    VideoPlayerEntitlementResponseEmbeddedDisplay[VideoPlayerEntitlementResponseEmbeddedDisplay["_2"] = 2] = "_2";
})(VideoPlayerEntitlementResponseEmbeddedDisplay || (VideoPlayerEntitlementResponseEmbeddedDisplay = {}));
export var PlayerDetailsResponseIdleState;
(function (PlayerDetailsResponseIdleState) {
    PlayerDetailsResponseIdleState[PlayerDetailsResponseIdleState["_0"] = 0] = "_0";
    PlayerDetailsResponseIdleState[PlayerDetailsResponseIdleState["_1"] = 1] = "_1";
    PlayerDetailsResponseIdleState[PlayerDetailsResponseIdleState["_2"] = 2] = "_2";
    PlayerDetailsResponseIdleState[PlayerDetailsResponseIdleState["_3"] = 3] = "_3";
    PlayerDetailsResponseIdleState[PlayerDetailsResponseIdleState["_4"] = 4] = "_4";
})(PlayerDetailsResponseIdleState || (PlayerDetailsResponseIdleState = {}));
export var PlayerDetailsResponseDefaultInteractiveTab;
(function (PlayerDetailsResponseDefaultInteractiveTab) {
    PlayerDetailsResponseDefaultInteractiveTab[PlayerDetailsResponseDefaultInteractiveTab["_0"] = 0] = "_0";
    PlayerDetailsResponseDefaultInteractiveTab[PlayerDetailsResponseDefaultInteractiveTab["_1"] = 1] = "_1";
    PlayerDetailsResponseDefaultInteractiveTab[PlayerDetailsResponseDefaultInteractiveTab["_2"] = 2] = "_2";
    PlayerDetailsResponseDefaultInteractiveTab[PlayerDetailsResponseDefaultInteractiveTab["_3"] = 3] = "_3";
    PlayerDetailsResponseDefaultInteractiveTab[PlayerDetailsResponseDefaultInteractiveTab["_4"] = 4] = "_4";
    PlayerDetailsResponseDefaultInteractiveTab[PlayerDetailsResponseDefaultInteractiveTab["_5"] = 5] = "_5";
})(PlayerDetailsResponseDefaultInteractiveTab || (PlayerDetailsResponseDefaultInteractiveTab = {}));
export var PlayerDetailsResponseAspectRatio;
(function (PlayerDetailsResponseAspectRatio) {
    PlayerDetailsResponseAspectRatio["SixteenByNine"] = "SixteenByNine";
    PlayerDetailsResponseAspectRatio["NineBySixteen"] = "NineBySixteen";
})(PlayerDetailsResponseAspectRatio || (PlayerDetailsResponseAspectRatio = {}));
export var PlayerDetailsResponseEmbeddedDisplay;
(function (PlayerDetailsResponseEmbeddedDisplay) {
    PlayerDetailsResponseEmbeddedDisplay[PlayerDetailsResponseEmbeddedDisplay["_0"] = 0] = "_0";
    PlayerDetailsResponseEmbeddedDisplay[PlayerDetailsResponseEmbeddedDisplay["_1"] = 1] = "_1";
    PlayerDetailsResponseEmbeddedDisplay[PlayerDetailsResponseEmbeddedDisplay["_2"] = 2] = "_2";
})(PlayerDetailsResponseEmbeddedDisplay || (PlayerDetailsResponseEmbeddedDisplay = {}));
export var WebLinkRequestType;
(function (WebLinkRequestType) {
    WebLinkRequestType["VideoPlayer"] = "VideoPlayer";
    WebLinkRequestType["Broadcast"] = "Broadcast";
})(WebLinkRequestType || (WebLinkRequestType = {}));
export var YouTubeSwitcherStreamSettingFacebookEdge;
(function (YouTubeSwitcherStreamSettingFacebookEdge) {
    YouTubeSwitcherStreamSettingFacebookEdge[YouTubeSwitcherStreamSettingFacebookEdge["_0"] = 0] = "_0";
    YouTubeSwitcherStreamSettingFacebookEdge[YouTubeSwitcherStreamSettingFacebookEdge["_1"] = 1] = "_1";
    YouTubeSwitcherStreamSettingFacebookEdge[YouTubeSwitcherStreamSettingFacebookEdge["_2"] = 2] = "_2";
    YouTubeSwitcherStreamSettingFacebookEdge[YouTubeSwitcherStreamSettingFacebookEdge["_3"] = 3] = "_3";
})(YouTubeSwitcherStreamSettingFacebookEdge || (YouTubeSwitcherStreamSettingFacebookEdge = {}));
var SwaggerException = /** @class */ (function (_super) {
    __extends(SwaggerException, _super);
    function SwaggerException(message, status, response, headers, result) {
        var _this = _super.call(this) || this;
        _this.isSwaggerException = true;
        _this.message = message;
        _this.status = status;
        _this.response = response;
        _this.headers = headers;
        _this.result = result;
        return _this;
    }
    SwaggerException.isSwaggerException = function (obj) {
        return obj.isSwaggerException === true;
    };
    return SwaggerException;
}(Error));
export { SwaggerException };
function throwException(message, status, response, headers, result) {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}
